{
  "ai": {
    "actions": {
      "addAttachments": "Dodajte fotografije ali datoteke"
    },
    "attachments": {
      "imageAlt": "Slika",
      "remove": "Odstranite"
    },
    "conversation": {
      "emptyDescription": "Začnite pogovor in sporočila se bodo prikazala tukaj",
      "emptyTitle": "Še ni sporočil"
    },
    "core": {
      "placeholder": "Kaj bi radi izvedeli?",
      "stop": "Ustavite",
      "submit": "Pošljite",
      "uploadFiles": "Naložite datoteke"
    },
    "sources": {
      "usedCount": "{count, plural, one {Uporabljen {count} vir} two {Uporabljena {count} vira} few {Uporabljeni {count} viri} other {Uporabljenih {count} virov}}"
    },
    "tool": {
      "errorHeading": "Napaka",
      "parameters": "Parametri",
      "statusAwaitingApproval": "Čaka na odobritev",
      "statusCompleted": "Končano",
      "statusDenied": "Zavrnjeno",
      "statusError": "Napaka",
      "statusPending": "Čaka",
      "statusResponded": "Odgovorjeno",
      "statusRunning": "Poteka"
    }
  },

  "auth": {
    "appleNativeSheet": {
      "appleFailed": "Vpis z Apple ni uspel. Čez trenutek poskusite znova.",
      "appleInvalidResponse": "Apple je vrnil odgovor, ki ga nismo mogli prebrati. Poskusite znova.",
      "appleNotHandled": "Apple zahteve za vpis ni mogel obdelati. Poskusite znova.",
      "appleNotInteractive": "Apple ni mogel prikazati okna za vpis. Poskusite znova.",
      "appleUnavailable": "Apple ni mogel začeti vpisa. V nastavitvah iOS preverite, ali ste vpisani v svoj Apple Account, in poskusite znova."
    },
    "appleSignInButton": {
      "continue": "Nadaljujte z Apple",
      "errorFallback": "Pri vpisu z Apple je prišlo do napake",
      "signingIn": "Vpisovanje …"
    },
    "authScreen": {
      "confirmPasswordLabel": "Potrdite geslo",
      "confirmPasswordPlaceholder": "Znova vnesite geslo",
      "errorPasswordTooShort": "Geslo mora imeti vsaj 8 znakov",
      "errorPasswordsMismatch": "Gesli se ne ujemata",
      "newPasswordLabel": "Novo geslo",
      "newPasswordPlaceholder": "Najmanj 8 znakov",
      "passwordResetDescription": "Geslo je uspešno ponastavljeno.",
      "passwordResetTitle": "Geslo ponastavljeno",
      "signIn": "Vpišite se"
    },
    "errors": {
      "accountNotFound": "Računa ni mogoče najti",
      "changeEmailDisabled": "Sprememba e-poštnega naslova je onemogočena",
      "credentialAccountNotFound": "Računa z geslom ni mogoče najti",
      "emailAlreadyVerified": "E-poštni naslov je že potrjen",
      "emailCanNotBeUpdated": "E-poštnega naslova ni mogoče spremeniti",
      "emailMismatch": "E-poštna naslova se ne ujemata",
      "emailNotVerified": "E-poštni naslov ni potrjen",
      "failedToUnlinkLastAccount": "Zadnjega povezanega računa ne morete odstraniti",
      "invalidEmail": "Neveljaven e-poštni naslov",
      "invalidEmailOrPassword": "Napačen e-poštni naslov ali geslo",
      "invalidOtp": "Neveljavna enkratna koda",
      "invalidPassword": "Napačno geslo",
      "invalidToken": "Neveljaven žeton",
      "linkedAccountAlreadyExists": "Povezan račun že obstaja",
      "otpExpired": "Enkratna koda je potekla",
      "passwordAlreadySet": "Uporabnik že ima nastavljeno geslo",
      "passwordTooLong": "Geslo je predolgo",
      "passwordTooShort": "Geslo je prekratko",
      "sessionExpired": "Seja je potekla. Za to dejanje se znova vpišite.",
      "sessionNotFresh": "Za to dejanje se morate znova vpisati",
      "socialAccountAlreadyLinked": "Račun družbenega omrežja je že povezan",
      "tokenExpired": "Žeton je potekel",
      "tooManyAttempts": "Preveč poskusov",
      "tooManyRequests": "Preveč poskusov. Počakajte trenutek in poskusite znova.",
      "userAlreadyExists": "Uporabnik že obstaja.",
      "userAlreadyExistsUseAnotherEmail": "Uporabnik že obstaja. Uporabite drug e-poštni naslov.",
      "userAlreadyHasPassword": "Uporabnik že ima geslo. Za izbris računa ga vnesite.",
      "userNotFound": "Uporabnika ni mogoče najti"
    },
    "filingExceptionNotice": {
      "worksFromDayOne": "Sporočila gostov, koledar, naloge in AI pomočnik delujejo že od prvega dne."
    },
    "forgotPassword": {
      "backToSignIn": "Nazaj na vpis",
      "codeLabel": "Koda za ponastavitev",
      "descriptionCode": "Na {email} smo poslali kodo. Spodaj jo vnesite skupaj z novim geslom.",
      "descriptionEmail": "Vnesite e-poštni naslov in poslali vam bomo 6-mestno kodo za ponastavitev",
      "emailLabel": "E-pošta",
      "emailPlaceholder": "ime@primer.si",
      "errorCodeIncomplete": "Vnesite 6-mestno kodo iz e-pošte",
      "errorEmailRequired": "E-poštni naslov je obvezen",
      "resend": "Niste prejeli kode? Pošljite znova",
      "resetting": "Ponastavljanje …",
      "sendCode": "Pošljite kodo za ponastavitev",
      "submit": "Ponastavite geslo",
      "titleCode": "Vnesite kodo za ponastavitev",
      "titleEmail": "Pozabljeno geslo"
    },
    "googleSignInButton": {
      "continue": "Nadaljujte z Google",
      "signingIn": "Vpisovanje …"
    },
    "legalConsent": {
      "agreement": "Z ustvaritvijo računa se strinjate s <terms>Pogoji uporabe</terms> in <privacy>Politiko zasebnosti</privacy>."
    },
    "oauthConsent": {
      "allow": "Dovolite dostop",
      "allowing": "Dovoljevanje …",
      "deny": "Zavrnite",
      "denying": "Zavračanje …",
      "errorRequestInvalid": "Ta zahteva za povezavo ni več veljavna. Zaprite zavihek in se znova povežite iz aplikacije AI.",
      "errorSessionEnded": "Vaša seja v Vidimu je potekla. Znova se vpišite, nato se ponovno povežite iz aplikacije AI.",
      "errorUnreachable": "Vidimo ni dosegljiv. Preverite povezavo in poskusite znova.",
      "expiredDescription": "Ta zahteva za povezavo je neveljavna ali je potekla. Zaprite zavihek in se znova povežite iz aplikacije AI.",
      "expiredTitle": "Zahteva za povezavo je potekla",
      "goToSignIn": "Na vpis",
      "guestsDetail": "kontaktni podatki, stanje prijav",
      "guestsLabel": "Gostje in prijave",
      "loading": "Nalaganje …",
      "occupancyDetail": "kazalniki, sobe, ekipa",
      "occupancyLabel": "Zasedenost in podatki o nastanitvi",
      "importHeading": "Uvoz vaših obstoječih rezervacij",
      "importScope": "Lastniki in upravitelji lahko aplikaciji AI dovolijo, da rezervacije iz vašega trenutnega sistema kopira v nastanitev, ki je v Vidimu še v pripravi. Posodobi ali odpove lahko le rezervacije, uvožene iz vašega trenutnega sistema, in nič, kar uvozi, ne doseže gostov, kanalov ali pristojnih organov.",
      "readOnlyHeading": "Dostop samo za branje do",
      "readOnlyScope": "Samo tisto, kar vaša vloga v aplikaciji že vidi. Ničesar ne more ustvariti, spremeniti, poslati ali izbrisati.",
      "readOnlyScopeExceptImport": "Samo tisto, kar vaša vloga v aplikaciji že vidi. Razen uvoza rezervacij ničesar ne more ustvariti, spremeniti, poslati ali izbrisati.",
      "readableItem": "<strong>{label}</strong><muted>: {detail}</muted>",
      "reservationsDetail": "rezervacije, datumi, proste sobe",
      "reservationsLabel": "Rezervacije in razpoložljivost",
      "signInRequiredDescription": "Vaša seja v Vidimu je potekla. Vpišite se, nato povezavo znova začnite iz aplikacije AI.",
      "signInRequiredTitle": "Potreben je vpis",
      "signedInAs": "Vpisani ste kot {email}. Povezavo lahko kadar koli prekinete v aplikaciji {name}.",
      "signedInAsUnnamed": "Vpisani ste kot {email}. Povezavo lahko kadar koli prekinete v aplikaciji AI.",
      "tasksDetail": "čiščenje in vzdrževanje",
      "tasksLabel": "Naloge",
      "title": "Želite dovoliti dostop do podatkov v Vidimu?",
      "touristTaxDetail": "dolgovani in plačani zneski",
      "touristTaxLabel": "Turistična taksa in stanja",
      "wantsToConnect": "<app>{name}</app> se želi povezati z vašim računom Vidimo.",
      "wantsToConnectUnnamed": "Aplikacija AI se želi povezati z vašim računom Vidimo."
    },
    "resetPassword": {
      "backToSignIn": "Nazaj na vpis",
      "description": "Spodaj vnesite novo geslo",
      "errorTokenMissing": "Žeton za ponastavitev je neveljaven ali manjka",
      "resetting": "Ponastavljanje …",
      "submit": "Ponastavite geslo",
      "title": "Ponastavitev gesla"
    },
    "signIn": {
      "description": "Za vpis v račun spodaj vnesite e-poštni naslov",
      "emailLabel": "E-pošta",
      "emailPlaceholder": "ime@primer.si",
      "errorCredentialsRequired": "E-poštni naslov in geslo sta obvezna",
      "forgotPassword": "Ste pozabili geslo?",
      "noAccount": "Še nimate računa?",
      "passwordLabel": "Geslo",
      "passwordPlaceholder": "Vnesite geslo",
      "signUp": "Registrirajte se",
      "signingIn": "Vpisovanje …",
      "submit": "Vpišite se",
      "title": "Vpis"
    },
    "signUp": {
      "creatingAccount": "Ustvarjanje računa …",
      "description": "Registrirajte se in začnite uporabljati Vidimo",
      "emailLabel": "E-pošta",
      "emailPlaceholder": "ime@primer.si",
      "errorCredentialsRequired": "E-poštni naslov in geslo sta obvezna",
      "errorNameRequired": "Prikazno ime je obvezno",
      "errorPasswordTooShort": "Geslo mora imeti vsaj 8 znakov",
      "haveAccount": "Že imate račun?",
      "nameLabel": "Prikazno ime",
      "namePlaceholder": "Janez Novak",
      "passwordHint": "Vsaj 8 znakov",
      "passwordLabel": "Geslo",
      "passwordPlaceholder": "Najmanj 8 znakov",
      "signIn": "Vpišite se",
      "submit": "Ustvarite račun",
      "title": "Ustvarite račun"
    },
    "socialSignIn": {
      "divider": "Ali nadaljujte z"
    },
    "verifyEmail": {
      "backToSignIn": "Nazaj na vpis",
      "continue": "Nadaljujte",
      "errorLinkExpired": "Ta potrditvena povezava je potekla. Pošljite novo.",
      "errorLinkFailed": "Ta potrditvena povezava ni delovala.",
      "errorLinkInvalid": "Ta potrditvena povezava ni več veljavna.",
      "errorLinkNotVerified": "Ta potrditvena povezava ni delovala. Pošljite novo.",
      "errorNoSessionEmail": "V seji ni e-poštnega naslova uporabnika",
      "errorNotConfirmed": "Ne moremo potrditi, da je bil e-poštni naslov potrjen.",
      "errorTokenMissing": "Potrditveni žeton je neveljaven ali manjka",
      "failedTitle": "Potrditev ni uspela",
      "goToSignIn": "Na vpis",
      "resend": "Znova pošljite potrditveno e-pošto",
      "resent": "Poslano: v nabiralniku vas čaka nova povezava.",
      "sendAnother": "Pošljite novo",
      "successDescription": "E-poštni naslov je potrjen. Samodejno boste vpisani.",
      "successTitle": "E-poštni naslov potrjen",
      "unconfirmedDescription": "Niste vpisani, zato rezultata tukaj ne moremo potrditi. Vpišite se: če je povezava delovala, je vaš e-poštni naslov že potrjen.",
      "unconfirmedTitle": "Preverite potrditveno povezavo"
    }
  },

  "calendar": {
    "agendaData": {
      "arrival": "Prihod",
      "balanceDue": "Za plačilo {amount}",
      "departure": "Odhod",
      "due": "Rok {date}",
      "eta": "Prihod okoli {time}",
      "guest": "Gost",
      "inHouse": "V nastanitvi",
      "paid": "Plačano",
      "until": "Do {date}"
    },
    "calendarAgendaView": {
      "arrivals": "Prihodi",
      "departures": "Odhodi",
      "emptyDescription": "Za {date} ni prihodov, odhodov ali gostov v nastanitvi.",
      "emptyDescriptionToday": "Danes ni prihodov, odhodov ali gostov v nastanitvi.",
      "emptyTitle": "Nič načrtovanega",
      "inHouse": "V nastanitvi",
      "syncing": "Sinhroniziranje dnevnega pregleda …",
      "tasksFor": "Naloge za {guestName}",
      "unassigned": "Nedodeljeno",
      "unconfirmed": "Nepotrjeno"
    },
    "calendarAvailabilityBand": {
      "free": "Prosto",
      "freeRoomsPerNight": "Proste sobe na noč",
      "roomsFree": "{count, plural, one {prosta soba} two {prosti sobi} few {proste sobe} other {prostih sob}}",
      "spokenDatePrefix": "{date}: "
    },
    "calendarLegend": {
      "markBase": "Osnovna cena",
      "markChanged": "Pravkar spremenjeno",
      "markChosen": "Izbrano za spremembo",
      "markChosenClosed": "Izbrano, ni v prodaji",
      "markClosed": "Ni v prodaji",
      "markMinStay": "Najkrajše bivanje",
      "markSeason": "Iz sezone",
      "markSet": "Nastavljeno za to noč",
      "rates": "Cene",
      "reservations": "Rezervacije",
      "tapActivity": "Kdo je kaj spremenil, najdete v nastavitvah nastanitve pod Ekipa > Dejavnost.",
      "tapDate": "Tapnite datum, da spremenite to noč za vse vrste enot v nastanitvi.",
      "tapNight": "Tapnite noč, da jo spremenite.",
      "tapOtherRow": "Tapnite noč v drugi vrstici, da dodate to vrsto enote.",
      "tapSpan": "Za več zaporednih noči tapnite drugo noč v isti vrstici.",
      "tasks": "Naloge",
      "title": "Legenda"
    },
    "calendarPage": {
      "createFirstUnit": "Ustvarite prvo enoto",
      "emptyDescription": "Nastanitvi dodajte enoto, da boste lahko spremljali rezervacije v koledarju.",
      "emptyTitle": "Še ni enot",
      "legend": "Legenda koledarja",
      "newReservation": "Nova rezervacija",
      "newTask": "Nova naloga",
      "tasksMissingTitle": "V koledarju manjkajo naloge",
      "title": "Koledar",
      "unavailableDescription": "Na tej napravi Vidimo ne more naložiti enot. Ob ponovnem poskusu se bo aplikacija znova naložila.",
      "unavailableTitle": "Koledarja trenutno ni mogoče prikazati"
    },
    "calendarView": {
      "blockDates": "Zaprite datume",
      "blockingHint": "Povlecite po vrstici sobe čez noči, ki jih želite zapreti. Za pomikanje podrsajte po datumih ali imenih sob, za ogled bivanja pa najprej tapnite »{done}«.",
      "doneBlocking": "Končajte zapiranje",
      "errorBlockFailed": "Teh noči ni bilo mogoče zapreti. Poskusite znova.",
      "jumpToDate": "Skočite na datum",
      "next": "Naprej",
      "noUnits": "Ni enot za prikaz",
      "previous": "Nazaj",
      "staffEmptyDescription": "Pogled osebja prikazuje dodeljene naloge in odsotnosti vsakega člana ekipe.",
      "staffEmptyTitle": "Ni članov ekipe za prikaz",
      "syncing": "Sinhroniziranje koledarja …",
      "today": "Danes",
      "unassignedLane": "Nedodeljeno",
      "unknownProperty": "Neznana nastanitev"
    },
    "calendarViewMenu": {
      "title": "Pogled",
      "triggerLabel": "Pogled: {view}"
    },
    "propertyEmptyState": {
      "acceptInvitation": "Sprejmite povabilo",
      "back": "Nazaj",
      "createDescription": "Nastavite novo nastanitev za upravljanje gostov in osebja.",
      "createInstead": "Raje ustvarite nastanitev",
      "createTitle": "Ustvarite nastanitev",
      "errorCreateFailed": "Nastanitve ni bilo mogoče ustvariti. Poskusite znova.",
      "getStartedDescription": "Ustvarite novo nastanitev ali se s kodo povabila pridružite obstoječi.",
      "getStartedTitle": "Začnite",
      "invitedAs": "Povabljeni kot: {role}",
      "invitedDescription": "{count, plural, one {Povabljeni ste v nastanitev. Za začetek sprejmite povabilo.} two {Povabljeni ste v ti nastanitvi. Za začetek sprejmite eno od povabil.} few {Povabljeni ste v te nastanitve. Za začetek sprejmite eno od povabil.} other {Povabljeni ste v te nastanitve. Za začetek sprejmite eno od povabil.}}",
      "invitedTitle": "Povabljeni ste",
      "joinDescription": "Vnesite prejeto kodo povabila in se pridružite ekipi.",
      "joinTitle": "Pridružite se nastanitvi",
      "syncing": "Nastavljanje nastanitve …",
      "syncingSlow": "To traja dlje kot običajno. Nastanitev je nastavljena in se bo prikazala, ko se povezava ujame.",
      "toastCreated": "Nastanitev ustvarjena"
    },
    "timelineData": {
      "away": "Odsoten"
    },
    "todayPage": {
      "nextDay": "Naslednji dan",
      "pickDay": "Izberite dan",
      "previousDay": "Prejšnji dan"
    },
    "transportSelector": {
      "changeTransport": "Zamenjajte kanal",
      "menuLabel": "Izberite kanal"
    },
    "unitReadinessControl": {
      "errorUpdateFailed": "Stanja sobe ni bilo mogoče posodobiti. Poskusite znova.",
      "hint": "Shrani se ob vsaki spremembi. Ko je naloga čiščenja zaključena, se stanje nastavi na Čisto, ob odhodu gosta pa na Umazano. Izjema je Izven uporabe, ki ga lahko odstranite le vi.",
      "label": "Pripravljenost",
      "outOfOrderHint": "Stanje Izven uporabe prepreči tudi nove rezervacije v tej sobi in začasno onemogoči kodo za vrata gostom, ki v njej že bivajo."
    }
  },

  "checkIn": {
    "guestRegistration": {
      "anotherGuest": "drug gost",
      "heldByOther": "Dokument {documentNumber} ima že {holderName}."
    },
    "useRegistrationOutbox": {
      "deferred": "{count, plural, one {Prijavo je prevzel drug vpisani uporabnik: {guests}. Oddana bo, ko se ta naslednjič vpiše tukaj.} two {Prijave so prevzeli drugi vpisani uporabniki: {guests}. Oddane bodo, ko se ti naslednjič vpišejo tukaj.} few {Prijave so prevzeli drugi vpisani uporabniki: {guests}. Oddane bodo, ko se ti naslednjič vpišejo tukaj.} other {Prijave so prevzeli drugi vpisani uporabniki: {guests}. Oddane bodo, ko se ti naslednjič vpišejo tukaj.}}",
      "dropped": "{count, plural, one {Prijave ni bilo mogoče oddati: {guests}. Odprite rezervacijo in jo popravite.} two {Prijav ni bilo mogoče oddati: {guests}. Odprite rezervacije in jih popravite.} few {Prijav ni bilo mogoče oddati: {guests}. Odprite rezervacije in jih popravite.} other {Prijav ni bilo mogoče oddati: {guests}. Odprite rezervacije in jih popravite.}}",
      "filed": "{count, plural, one {Čakajoča prijava gosta je oddana.} two {# čakajoči prijavi gostov sta oddani.} few {# čakajoče prijave gostov so oddane.} other {# čakajočih prijav gostov je oddanih.}}",
      "guestsOneNameAndOthers": "{first} in {count, plural, one {še #} two {še #} few {še #} other {še #}}",
      "guestsTwoNames": "{first} in {second}",
      "guestsTwoNamesAndOthers": "{first}, {second} in {count, plural, one {še #} two {še #} few {še #} other {še #}}",
      "guestsUnnamed": "{count, plural, one {en gost} two {# gosta} few {# gostje} other {# gostov}}"
    }
  },

  "common": {
    "countryPicker": {
      "emptyLabel": "Ni ustreznih držav",
      "placeholder": "Izberite državo",
      "searchLabel": "Iščite države"
    },
    "dateRangePicker": {
      "nights": "{nights, plural, one {# noč} two {# noči} few {# noči} other {# noči}}",
      "placeholder": "Izberite datume"
    },
    "detailsDrawer": {
      "close": "Zaprite",
      "copyLinkLabel": "Kopirajte povezavo do tega zapisa",
      "edit": "Uredite"
    },
    "dialog": {
      "close": "Zaprite"
    },
    "errors": {
      "generic": "Nekaj je šlo narobe. Poskusite znova.",
      "networkUnreachable": "Ni povezave. Preverite omrežje in poskusite znova.",
      "subscriptionRequired": "Ta nastanitev nima aktivne naročnine, zato tega še ni mogoče storiti.",
      "unreadableNumber": "Vnesite število, na primer {example, number}."
    },
    "insetForm": {
      "cancel": "Prekličite",
      "save": "Shranite",
      "saving": "Shranjevanje …"
    },
    "loading": "Nalaganje",
    "personCard": {
      "call": "Pokličite",
      "callLabel": "Pokličite: {name}",
      "idOnFile": "Dokument shranjen",
      "message": "Pišite",
      "openLabel": "Odprite: {name}"
    },
    "phoneNumberInput": {
      "country": "Klicna koda države",
      "international": "Mednarodno",
      "invalid": "Preverite številko in z zastavico izberite njeno državo."
    },
    "picker": {
      "done": "Končano",
      "noMatches": "Ni zadetkov",
      "search": "Iskanje"
    }
  },

  "communications": {
    "connectRefusalDrafts": {
      "account_claimed": "Pozdravljeni, poskušam povezati račun, ki je že povezan z drugo nastanitvijo. Mi lahko pomagate?",
      "number_claimed": "Pozdravljeni, poskušam povezati številko, ki je že povezana z drugo nastanitvijo. Mi lahko pomagate?",
      "property_preparing": "Pozdravljeni, kanal želim povezati, medtem ko je moja nastanitev še v pripravi. Mi lahko pomagate?",
      "setup_broken": "Pozdravljeni, povezovanje kanala se je ustavilo med nastavljanjem in ga v aplikaciji ne morem dokončati. Mi lahko pomagate?",
      "subscription_required": "Pozdravljeni, povezovanje kanala zahteva aktivno naročnino. Mi lahko pomagate?"
    },
    "activeCallView": {
      "activeCall": "Aktiven klic",
      "hangUp": "Prekinite",
      "minimiseCall": "Pomanjšajte klic",
      "mute": "Izklopite mikrofon",
      "roomStatus": "Soba {unitCode} · {status}",
      "speakerOff": "Zvočnik izklopljen",
      "speakerOn": "Zvočnik vklopljen",
      "transfer": "Preusmerite",
      "unmute": "Vklopite mikrofon"
    },
    "aiChatListView": {
      "emptyDescription": "Začnite nov pogovor z AI pomočnikom",
      "emptyTitle": "Ni pogovorov z AI",
      "newChat": "Nov klepet"
    },
    "aiChatView": {
      "aiAssistant": "AI pomočnik",
      "chooseProperty": "Izberite nastanitev",
      "choosePropertyDescription": "Pomočnik odgovarja za eno nastanitev naenkrat, zato izberite tisto, o kateri sprašujete.",
      "choosePropertyTitle": "Katera nastanitev?",
      "emptyDescription": "Vprašajte me o gostih, spremembah rezervacij ali operativnih nalogah",
      "emptyTitle": "Kako vam lahko pomagam?",
      "errorAmbiguousScopeDetail": "Pomočnik odgovarja za eno nastanitev naenkrat. V glavi izberite eno in vprašajte znova.",
      "errorAmbiguousScopeTitle": "Izberite nastanitev",
      "errorEmptyScopeDetail": "Izbrani obseg ne vključuje nobene nastanitve, do katere imate dostop. Razširite ga v glavi in poskusite znova.",
      "errorEmptyScopeTitle": "Obseg je prazen",
      "errorPausedDetailNative": "AI je vključen v aktivno naročnino za to nastanitev.",
      "errorPausedTitle": "AI je zaustavljen",
      "errorSend": "Sporočila ni bilo mogoče poslati. Poskusite znova.",
      "errorTranscribe": "Posnetka ni bilo mogoče prepisati",
      "errorUnreachableDetail": "Preverite povezavo in poskusite znova.",
      "errorUnreachableTitle": "Pomočnik ni mogel odgovoriti",
      "newChat": "Nov klepet",
      "retry": "Poskusite znova",
      "retryTooltip": "Znova pošljite zadnje sporočilo",
      "suggestionCheckIns": "Pokaži današnje prihode",
      "suggestionMaintenance": "So kakšne težave za vzdrževanje?",
      "suggestionOccupancy": "Kakšna je bila zasedenost prejšnji mesec?"
    },
    "aiMessageParts": {
      "copied": "Kopirano v odložišče",
      "copyTooltip": "Kopirajte sporočilo",
      "errorCopy": "Sporočila ni bilo mogoče kopirati",
      "moreActions": "Več dejanj",
      "regenerate": "Ustvarite znova",
      "sourceFallbackTitle": "Sklic na rezervacijo"
    },
    "aiPromptComposer": {
      "placeholder": "Vprašajte karkoli",
      "placeholderTranscribing": "Prepisovanje …"
    },
    "callEventBubble": {
      "callEnded": "Klic končan",
      "callWithDuration": "Klic · {duration}",
      "calling": "Klicanje …",
      "incomingCall": "Dohodni klic",
      "incomingCallRinging": "Dohodni klic …",
      "missedCall": "Zgrešen klic",
      "ongoingCall": "Klic poteka · {duration}",
      "outgoingCall": "Odhodni klic",
      "outgoingMissedCall": "Neodgovorjen odhodni klic"
    },
    "chatHeader": {
      "back": "Nazaj",
      "badgeGuest": "Gost",
      "badgeInternal": "Interno",
      "badgeSupport": "Podpora",
      "call": "Pokličite: {name}",
      "linkReservation": "Povežite z rezervacijo",
      "openReservation": "Odprite rezervacijo",
      "unknownName": "Neznano"
    },
    "chatInputBar": {
      "placeholder": "Napišite sporočilo …",
      "recordVoice": "Posnemite glasovno sporočilo",
      "sendDocument": "Pošljite dokument",
      "sendPhotoOrVideo": "Pošljite fotografijo ali videoposnetek",
      "transcribing": "Prepisovanje …"
    },
    "chatItem": {
      "chatWith": "Klepet: {name}",
      "noMessages": "Še ni sporočil",
      "unknownName": "Neznano"
    },
    "chatMessageBubble": {
      "copied": "Kopirano v odložišče",
      "copyMessage": "Kopirajte sporočilo",
      "dismissReactionPicker": "Zaprite izbiro odzivov",
      "errorCopy": "Sporočila ni bilo mogoče kopirati",
      "messagePlaceholder": "Sporočilo",
      "senderAndTime": "{sender} · {time}"
    },
    "chatView": {
      "emptyDescription": "Pošljite sporočilo in začnite pogovor",
      "emptyTitle": "Začnite pogovor",
      "scrollToNewest": "Pomaknite se na najnovejše sporočilo"
    },
    "chatsTabBar": {
      "ai": "AI",
      "guests": "Gostje",
      "openDialer": "Odprite številčnico",
      "staff": "Osebje",
      "unread": "{count, plural, one {{count} neprebrano} two {{count} neprebrani} few {{count} neprebrana} other {{count} neprebranih}}"
    },
    "chatsView": {
      "emptyDescription": "Na seznamu izberite klepet z gostom, osebjem ali AI",
      "emptyTitle": "Izberite pogovor",
      "hideConversationList": "Skrijte seznam pogovorov",
      "showConversationList": "Pokažite seznam pogovorov"
    },
    "deliveryErrorCopy": {
      "genericFailure": "Sporočila ni bilo mogoče dostaviti.",
      "instagramGeneric": "Tega odgovora ni bilo mogoče poslati na Instagramu.",
      "instagramLateReplyRefused": "Ni poslano: Instagram Vidimu še ni dovolil odgovarjati več kot 24 ur po gostovem zadnjem sporočilu.",
      "instagramNoIdentity": "Ni poslano: tega gosta ni mogoče doseči na Instagramu.",
      "instagramNotConnected": "Ni poslano: Instagram za to nastanitev ni povezan. Znova ga povežite pod Nastavitve > Sporočanje.",
      "instagramUndeliverable": "Instagram tega sporočila ni dostavil. Gost je morda blokiral račun ali izbrisal klepet.",
      "instagramWindowClosed": "Ni poslano: časovno okno za odgovor na Instagramu se je zaprlo. Gost mora znova pisati.",
      "invalidNumber": "Gostova telefonska številka je videti neveljavna. Preverite gostove kontaktne podatke.",
      "optedOut": "Gost se je odjavil od sporočil s te številke. Pošiljanje ostane blokirano, dokler se znova ne prijavi.",
      "phoneUnreachable": "Gostov telefon ni dosegljiv: morda je izklopljen ali zunaj dosega. Poskusite pozneje.",
      "whatsappWindowClosed": "24-urno okno za odgovor v WhatsAppu se je zaprlo. Gostu znova pišite z odobreno predlogo sporočila."
    },
    "dialerDrawer": {
      "call": "Pokličite",
      "calling": "Klicanje …",
      "cancel": "Prekličite",
      "description": "Vnesite številko ali poiščite obstoječega gosta.",
      "errorAlreadyInCall": "Že ste v klicu",
      "errorCallingUnsupported": "Klicanje je na voljo le v mobilni aplikaciji",
      "errorPermissionRequest": "Zahteve za dovoljenje ni bilo mogoče poslati. Poskusite znova.",
      "errorStartCall": "Klica ni bilo mogoče začeti",
      "guest": "Gost",
      "noMatches": "Ni zadetkov",
      "permissionRequestSent": "Zahteva za dovoljenje poslana prek WhatsAppa",
      "phoneNumber": "Telefonska številka",
      "phoneNumberPlaceholder": "Vnesite telefonsko številko",
      "refusal": {
        "invalid_phone_number": "To ni veljavna telefonska številka. Vnesite jo s klicno kodo države, na primer +386.",
        "whatsapp_not_connected": "Ta nastanitev nima povezane številke WhatsApp. Številko povežite v Nastavitvah in poskusite znova."
      },
      "requestCallPermission": "Zaprosite za dovoljenje za klic (WhatsApp)",
      "search": "Iskanje",
      "searchPlaceholder": "Iščite ime ali številko",
      "sending": "Pošiljanje …",
      "staff": "Osebje",
      "title": "Pokličite"
    },
    "entityShareCard": {
      "guestFallbackName": "Gost",
      "kindBooking": "Rezervacija",
      "kindGuest": "Gost",
      "kindTask": "Naloga",
      "noUpcomingStay": "Ni prihajajočega bivanja",
      "sharedBooking": "Poslana rezervacija",
      "sharedGuest": "Poslani podatki o gostu",
      "sharedTask": "Poslana naloga",
      "stayDates": "{checkIn}–{checkOut}",
      "unassigned": "Nedodeljeno",
      "unscheduled": "Brez termina"
    },
    "guestChatDetails": {
      "erasedStaffSender": "Nekdanji član ekipe",
      "errorAccountLoading": "Račun se še nalaga; poskusite znova čez trenutek",
      "errorNoMembership": "Vašega članstva v tej nastanitvi ni bilo mogoče ugotoviti",
      "errorNoProperty": "Najprej izberite nastanitev",
      "errorNotSent": "Sporočila ni bilo mogoče poslati. Poskusite znova.",
      "errorNotStarted": "Tega klepeta ni bilo mogoče začeti. Poskusite znova.",
      "guestFallback": "Gost",
      "linkOnlyStaffDescription": "Gostje je ne morejo odpreti, zato ni ničesar za pošiljanje.",
      "linkOnlyStaffTitle": "Ta povezava deluje le v klepetih osebja",
      "linkRemovedDescription": "Deluje le v klepetih osebja, zato je gost ne bo videl.",
      "linkRemovedTitle": "Povezava do zapisa odstranjena"
    },
    "guestChatInputBar": {
      "waitingForGuest": "Čakamo, da gost piše"
    },
    "guestChatListView": {
      "emptyDescription": "Čakamo na nova sporočila gostov",
      "emptyTitle": "Ni klepetov z gosti",
      "fallbackName": "Gost"
    },
    "guestChatMessageBubble": {
      "attachment": "Priloga",
      "copyErrorForSupport": "Kopirajte napako za podporo",
      "draftReply": "Pripravite odgovor",
      "drafting": "Pripravljanje …",
      "errorCopied": "Napaka kopirana za podporo",
      "errorCopyFailed": "Napake ni bilo mogoče kopirati",
      "retry": "Poskusite znova",
      "retrySendFailed": "Ponovno pošiljanje ni uspelo; poskusite znova",
      "retryTranscriptionFailed": "Ponovni prepis ni uspel; poskusite znova",
      "showOriginal": "Pokažite izvirnik",
      "showTranslation": "Pokažite prevod",
      "statusDelivered": "Dostavljeno",
      "statusFailed": "Ni uspelo",
      "statusPending": "V čakanju",
      "statusRead": "Prebrano",
      "statusSent": "Poslano",
      "translate": "Prevedite",
      "translateMessage": "Prevedite sporočilo",
      "translating": "Prevajanje …"
    },
    "guestChatView": {
      "draftFailed": "Odgovora ni bilo mogoče pripraviti. Poskusite znova.",
      "placeholderCheckingAccess": "Preverjanje dostopa …",
      "placeholderDiverted": "Odgovorite prek kanala {transport}; kanal {divertedFrom} ne more pošiljati",
      "placeholderLoadingChannels": "Nalaganje kanalov …",
      "placeholderNoChannel": "Noben kanal tukaj še ne more pošiljati",
      "placeholderReply": "Odgovorite gostu …",
      "placeholderUnreachable": "Gost ni dosegljiv po nobenem kanalu",
      "voiceNoteFailed": "Glasovnega sporočila ni bilo mogoče poslati"
    },
    "guestChats": {
      "linkFailed": "Tega pogovora ni bilo mogoče povezati z rezervacijo.",
      "refusal": {
        "chat_not_found": "Ta pogovor ne obstaja več.",
        "no_room": "Ta rezervacija nima sobe, v katero bi lahko dodali gosta.",
        "party_full": "Na tej rezervaciji so že vsi pričakovani gostje. Če želite dodati tega gosta, najprej povečajte število pri »Odrasli«, »Otroci« ali »Dojenčki«.",
        "reservation_not_active": "V to rezervacijo ni več mogoče dodajati gostov.",
        "reservation_not_found": "Ta rezervacija ne obstaja več."
      }
    },
    "guestDetails": {
      "age": "{age, plural, one {{age} leto} two {{age} leti} few {{age} leta} other {{age} let}}",
      "call": "Pokličite",
      "documentTypeIdCard": "Osebna izkaznica",
      "documentTypeOther": "Drugo",
      "documentTypePassport": "Potni list",
      "expires": "Velja do {date}",
      "guestInformation": "Podatki o gostu",
      "identityDocuments": "Osebni dokumenti",
      "issuedBy": "Izdala: {country}",
      "loadError": "Profila tega gosta ni bilo mogoče naložiti.",
      "merge": "Združite",
      "message": "Pišite",
      "notFoundDescription": "Ta gost morda spada k nastanitvi, ki trenutno ni izbrana. Zamenjajte nastanitev in poskusite znova.",
      "notFoundTitle": "Gosta ni mogoče najti",
      "relatedBookings": "Povezane rezervacije"
    },
    "guestDirectoryView": {
      "allStatuses": "Vsi statusi",
      "allUnits": "Vse enote",
      "arrivalDates": "Datumi prihoda",
      "callGuest": "Pokličite: {name}",
      "clear": "Počistite",
      "emptyDescription": "Gostje se prikažejo tukaj, ko rezervirajo ali se prijavijo.",
      "emptyTitle": "Še ni gostov",
      "filteredCount": "{count, plural, one {{filtered} od {count}} two {{filtered} od {count}} few {{filtered} od {count}} other {{filtered} od {count}}}",
      "guestCount": "{count, plural, one {{count} gost} two {{count} gosta} few {{count} gostje} other {{count} gostov}}",
      "noMatchesDescription": "Tem filtrom ne ustreza noben gost.",
      "noMatchesTitle": "Ni zadetkov",
      "openGuest": "Odprite: {name}",
      "searchPlaceholder": "Iščite ime, telefon ali e-pošto …",
      "statusFilterLabel": "Filtrirajte po statusu rezervacije",
      "syncing": "Sinhroniziranje gostov …",
      "title": "Gostje",
      "unitFilterLabel": "Filtrirajte po enoti"
    },
    "guestReplyDeniedBar": {
      "cannotReply": "Vaša vloga v tej nastanitvi ne omogoča odgovarjanja gostom",
      "preparing": "Ta nastanitev je v pripravi, zato gostom še vedno odgovarja njen trenutni sistem"
    },
    "guestTransports": {
      "emailNotConfigured": "Kanal e-pošte še ni nastavljen.",
      "inboundOnly": "Sporočila iz storitve {platform} prihajajo sem, odgovorov pa še ni mogoče pošiljati.",
      "instagramNotSetUp": "Instagram še ni nastavljen.",
      "smsNotConnected": "S to nastanitvijo še ni povezana nobena številka za SMS.",
      "smsUnavailable": "SMS še ni na voljo.",
      "whatsAppNotConnected": "WhatsApp s to nastanitvijo še ni povezan.",
      "whatsAppSettingUp": "WhatsApp se še nastavlja. To običajno traja nekaj minut."
    },
    "inCallOverlay": {
      "activeCall": "Aktiven klic",
      "expandActiveCall": "Razširite aktivni klic",
      "hangUp": "Prekinite",
      "mute": "Izklopite mikrofon",
      "speakerOff": "Zvočnik izklopljen",
      "speakerOn": "Zvočnik vklopljen",
      "unmute": "Vklopite mikrofon"
    },
    "incomingCallView": {
      "accept": "Sprejmite",
      "decline": "Zavrnite",
      "headerPhone": "Dohodni · Telefon",
      "headerWhatsApp": "Dohodni · WhatsApp",
      "hintCheckingInToday": "Prihod danes",
      "hintCheckingInTomorrow": "Prihod jutri",
      "hintCheckingOutToday": "Odhod danes",
      "hintCheckingOutTomorrow": "Odhod jutri",
      "hintInDays": "{count, plural, one {Čez # dan} two {Čez # dneva} few {Čez # dni} other {Čez # dni}}",
      "roomStatus": "Soba {unit} · {status}",
      "roomStatusWithHint": "Soba {unit} · {status} · {hint}",
      "unknownCaller": "Neznan klicatelj"
    },
    "incomingStaffCallView": {
      "accept": "Sprejmite",
      "decline": "Zavrnite",
      "header": "Dohodni · Interno",
      "internal": "Interno",
      "internalAtProperty": "Interno · {property}",
      "internalCall": "Interni klic"
    },
    "instagramWindowNotice": {
      "closed": "Časovno okno za odgovor na Instagramu se je zaprlo. Preden lahko odgovorite, vam mora gost znova pisati.",
      "closesOn": "Instagram bo ta klepet zaprl {date}.",
      "neverMessaged": "Instagram dovoljuje le odgovore. Gost vam mora pisati prvi."
    },
    "linkReservationPicker": {
      "description": "Izberite rezervacijo, na katero se nanaša ta pogovor. {name} bo dodan(a) na seznam gostov rezervacije.",
      "noReservations": "Ni tekočih ali prihajajočih rezervacij za povezavo",
      "noSearchMatches": "Nobena rezervacija ne ustreza iskanju",
      "searchPlaceholder": "Iščite po gostu, številki rezervacije ali enoti …",
      "title": "Povežite z rezervacijo",
      "unnamedBooker": "Gost brez imena"
    },
    "loadEarlierMessages": {
      "label": "Naložite starejša sporočila"
    },
    "media": {
      "tooLarge": "Datoteka je prevelika. Največja velikost je {max}."
    },
    "mergeGuestPickerModal": {
      "descriptionNamed": "Združite tega gosta z drugim profilom. Izberite profil, v katerega ga želite združiti. Podatki gosta {name} bodo dodani v ta profil.",
      "descriptionUnnamed": "Združite tega gosta z drugim profilom. Izberite profil, v katerega ga želite združiti. Podatki tega gosta bodo dodani v ta profil.",
      "noOtherGuests": "Ni drugih gostov za združitev",
      "noSearchMatches": "Iskanju ne ustreza noben gost",
      "searchPlaceholder": "Iščite po imenu gosta …",
      "suggestedByAi": "Predlaga AI",
      "title": "Združite goste"
    },
    "messageAttachment": {
      "document": "Dokument",
      "photo": "Fotografija",
      "photoUnavailable": "Fotografija ni na voljo",
      "videoUnavailable": "Videoposnetek ni na voljo"
    },
    "messageContextMenu": {
      "dismissMenu": "Zaprite meni",
      "moreActions": "Več dejanj",
      "react": "Odzovite se"
    },
    "messageReactionPicker": {
      "moreReactions": "Več odzivov",
      "reactWith": "Odzovite se z {emoji}"
    },
    "microphone": {
      "permissionMessage": "Za klicanje in sprejemanje klicev Vidimo potrebuje dostop do mikrofona. Tapnite Nastavitve in vklopite Mikrofon.",
      "permissionTitle": "Potreben je dostop do mikrofona",
      "settingsGuidance": "Odprite Nastavitve > Aplikacije > Vidimo in vklopite Mikrofon."
    },
    "nativeListeners": {
      "errorCallFailed": "Klic ni uspel. Poskusite znova."
    },
    "reactionPills": {
      "reaction": "{count, plural, one {Odziv {emoji}, {count}} two {Odziv {emoji}, {count}} few {Odziv {emoji}, {count}} other {Odziv {emoji}, {count}}}"
    },
    "recordingErrorBar": {
      "dismiss": "Opustite",
      "error": "Napaka",
      "retry": "Poskusite znova"
    },
    "sendAttachment": {
      "errorConnection": "Preverite povezavo in poskusite znova.",
      "errorNotSent": "Priloge ni bilo mogoče poslati",
      "refusal": {
        "outside_service_window": "WhatsApp dovoljuje priloge le v 24 urah po gostovem zadnjem sporočilu. Pošljite jo po e-pošti ali pošljite predlogo, da znova odprete pogovor.",
        "outside_service_window_voice": "WhatsApp dovoljuje glasovna sporočila le v 24 urah po gostovem zadnjem sporočilu. Raje ga pošljite po e-pošti.",
        "oversize": "{kind, select, image {Fotografija} video {Videoposnetek} voice {Glasovno sporočilo} other {Datoteka}}: {size}. {transport, select, email {E-pošta sprejme {max}.} sms {MMS sprejme {max}. Raje pošljite po e-pošti.} staff {Ta klepet sprejme {max}.} whatsapp {WhatsApp sprejme {max}. Raje pošljite po e-pošti.} other {Ta klepet sprejme {max}. Raje pošljite po e-pošti.}}",
        "sms_no_media": "SMS ne more prenašati prilog. Pogovor preklopite na WhatsApp ali e-pošto.",
        "unsupported_channel": "Ta kanal ne podpira prilog."
      },
      "rejectedTitle": "Tega tukaj ni mogoče poslati",
      "rejectedType": "Datoteke {type} ni mogoče poslati v klepetu.",
      "rejectedUnknownType": "Te vrste datoteke ni mogoče poslati v klepetu."
    },
    "staffChatDetails": {
      "groupChatFallbackName": "Skupinski klepet",
      "internal": "Interno",
      "manageMembers": "Člane upravljajte v nastavitvah nastanitve",
      "memberCount": "{count, plural, one {{count} član} two {{count} člana} few {{count} člani} other {{count} članov}}",
      "noMembers": "V tem klepetu ni članov."
    },
    "staffChatDetailsPage": {
      "directMessageFallback": "Neposredno sporočilo",
      "errorNoMembership": "Vašega članstva v tej nastanitvi ni bilo mogoče ugotoviti",
      "errorNoSharedProperty": "Nimata skupne nastanitve",
      "errorNotSent": "Sporočila ni bilo mogoče poslati. Poskusite znova.",
      "errorNotStarted": "Tega klepeta ni bilo mogoče začeti. Poskusite znova.",
      "errorSignedOut": "Za pošiljanje sporočil se vpišite",
      "errorStillLoading": "Še se nalaga; poskusite znova čez trenutek",
      "staffChatFallback": "Klepet osebja"
    },
    "staffChatListView": {
      "emptyDescription": "Začnite pogovor z osebjem",
      "emptyTitle": "Ni klepetov z osebjem"
    },
    "staffChatMessageBubble": {
      "attachmentPlaceholder": "Priloga",
      "deleteMessage": "Izbrišite sporočilo",
      "deletedByOther": "To sporočilo je bilo izbrisano",
      "deletedByYou": "To sporočilo ste izbrisali",
      "retryTranscriptionFailed": "Ponovni prepis ni uspel; poskusite znova"
    },
    "staffChatView": {
      "cancel": "Prekličite",
      "delete": "Izbrišite",
      "deleteDialogDescription": "Odstranjeno bo za vse v tem klepetu. Pogovor ohrani svoje mesto v niti in pokaže, da je bilo sporočilo izbrisano.",
      "deleteDialogTitle": "Želite izbrisati to sporočilo?",
      "deleteFailed": "Sporočila ni bilo mogoče izbrisati",
      "replyPlaceholder": "Odgovorite: {name} …",
      "sendPlaceholder": "Pošljite sporočilo …",
      "voiceNoteSendFailed": "Glasovnega sporočila ni bilo mogoče poslati"
    },
    "staffDetails": {
      "activeTasks": "{count, plural, one {Aktivne naloge ({count})} two {Aktivne naloge ({count})} few {Aktivne naloge ({count})} other {Aktivne naloge ({count})}}",
      "call": "Pokličite",
      "completedOn": "Opravljeno {date}",
      "message": "Pišite",
      "noTasksAssigned": "Ni dodeljenih nalog",
      "recentlyCompleted": "Nedavno opravljeno",
      "staffInformation": "Podatki o članu ekipe"
    },
    "suggestionActions": {
      "arrivalUpdated": "Predviden prihod posodobljen na {time}",
      "checkOutUpdated": "Odhod posodobljen na {time}",
      "guestAdded": "{guestName} dodan(a) na rezervacijo",
      "guestAlreadyOnBooking": "{guestName} je že na tej rezervaciji; pogovor je zdaj povezan z njo",
      "missingLink": "Temu predlogu manjka pogovor ali rezervacija za povezavo.",
      "missingTimeChange": "Temu predlogu manjka, kar potrebuje za uporabo.",
      "noStayDate": "Ta rezervacija nima datuma, na katerega bi lahko postavili čas.",
      "noTask": "Ta predlog nima naloge za ustvarjanje.",
      "rateChangeMissing": "To obvestilo ne navaja več spremembe, na katero se je nanašalo.",
      "taskCreated": "Naloga ustvarjena: {title}"
    },
    "suggestionCard": {
      "accept": "Sprejmite",
      "dismiss": "Opustite",
      "dismissLabel": "Opustite: {title}"
    },
    "supportChatDetails": {
      "errorNotSent": "Sporočila ni bilo mogoče poslati. Poskusite znova."
    },
    "supportChatView": {
      "addPhoto": "Dodajte fotografijo",
      "dictate": "Narekujte sporočilo",
      "dictationFailed": "Tega nismo slišali. Poskusite znova.",
      "dictationNeedsSubscription": "Narekovanje zahteva aktivno naročnino. Še vedno lahko tipkate.",
      "emptyDescription": "Povejte nam, kaj potrebujete, v svojem jeziku: s tipkanjem, govorom ali fotografijo. Vidimo, iz katere nastanitve in s katerega zaslona pišete, zato vam tega ni treba razlagati.",
      "emptyTitle": "Pišite ekipi Vidimo",
      "photo": "Fotografija",
      "photoUnavailable": "Fotografija ni na voljo",
      "placeholder": "Pišite ekipi Vidimo …",
      "removePhoto": "Odstranite fotografijo",
      "send": "Pošljite",
      "showOriginal": "Pokažite izvirnik",
      "showTranslation": "Pokažite prevod",
      "stopDictating": "Ustavite narekovanje",
      "supportSession": "V seji podpore odgovarjajte iz CRM-ja.",
      "teamNameWithProperty": "Ekipa Vidimo · {propertyName}",
      "transcribing": "Prepisovanje …"
    },
    "supportReplyBanner": {
      "open": "Odprite"
    },
    "transcribe": {
      "failed": "Posnetka ni bilo mogoče prepisati. Poskusite znova."
    },
    "transferPicker": {
      "empty": "V tej nastanitvi ni drugih članov osebja, na katere bi lahko preusmerili klic.",
      "title": "Preusmerite klic na"
    },
    "useGuestCall": {
      "errorAlreadyInCall": "Že ste v klicu",
      "errorNotStarted": "Klica ni bilo mogoče začeti"
    },
    "useOpenChat": {
      "errorNoProperty": "Najprej izberite nastanitev",
      "errorNoSharedProperty": "Nimata skupne nastanitve",
      "errorNotSwitched": "Preklop na to nastanitev ni uspel",
      "errorSelf": "Sami sebi ne morete pisati",
      "errorStillLoading": "Še se nalaga; poskusite znova čez trenutek",
      "switched": "Nastanitev zamenjana",
      "switchedTo": "Preklopljeno na {name}"
    },
    "useShareAudienceGap": {
      "one": "{name} tega ne more odpreti",
      "people": "{count, plural, one {{count} oseba tega ne more odpreti} two {{count} osebi tega ne moreta odpreti} few {{count} osebe tega ne morejo odpreti} other {{count} oseb tega ne more odpreti}}",
      "two": "{first} in {second} tega ne moreta odpreti"
    },
    "useVoiceRecording": {
      "micBlockedInBrowser": "Dostop do mikrofona je blokiran. Dovolite ga v nastavitvah brskalnika in poskusite znova.",
      "micPermissionMessage": "Za snemanje glasovnega sporočila Vidimo potrebuje dostop do mikrofona. Tapnite Nastavitve in vklopite Mikrofon.",
      "micUnavailable": "Dostop do mikrofona ni mogoč. Preverite dovoljenja.",
      "transcriptionFailed": "Prepis ni uspel",
      "transcriptionTimedOut": "Prepisovanje je trajalo predolgo. Preverite povezavo in poskusite znova."
    },
    "voiceContext": {
      "errorNoActiveCall": "Ni aktivnega klica za preusmeritev",
      "errorNotTransferred": "Klica ni bilo mogoče preusmeriti. Poskusite znova.",
      "errorUnsupported": "Klicanje je na voljo le v mobilni aplikaciji"
    },
    "voiceNoteAttachment": {
      "noSpeech": "Govor ni zaznan",
      "pause": "Zaustavite glasovno sporočilo",
      "play": "Predvajajte glasovno sporočilo",
      "seek": "Previjte glasovno sporočilo",
      "transcribing": "Prepisovanje …",
      "transcript": "Prepis",
      "transcriptUnavailable": "Prepis ni na voljo",
      "tryAgain": "Poskusite znova"
    }
  },

  "connect": {
    "connectScreen": {
      "contactSupport": "Pišite podpori",
      "returnToVidimo": "Nazaj v Vidimo"
    },
    "instagramConnectResult": {
      "cancelled": {
        "detail": "Povezovanje je bilo preklicano. Kadar koli lahko znova začnete v Vidimu.",
        "title": "Instagram ni povezan"
      },
      "connected": {
        "detail": "Vaš vir in neposredna sporočila so pripravljeni. Vrnite se v Vidimo in nadaljujte.",
        "title": "Instagram je povezan"
      },
      "connectedElsewhere": {
        "detail": "Ta račun Instagram je že povezan z drugo nastanitvijo. Najprej ga tam odklopite ali pa povežite drug račun.",
        "title": "Že povezan drugje"
      },
      "expired": {
        "detail": "Ta povezava ni več veljavna. Začnite znova v aplikaciji Vidimo.",
        "title": "Povezava je potekla"
      },
      "failed": {
        "detail": "Pri dokončanju povezovanja je šlo nekaj narobe. Poskusite znova v aplikaciji Vidimo.",
        "title": "Instagram ni povezan"
      },
      "invalidLink": {
        "detail": "V tej povezavi manjkajo podatki. Začnite znova v aplikaciji Vidimo.",
        "title": "Neveljavna povezava"
      },
      "subscriptionRequired": {
        "detail": "Za povezavo kanala potrebujete aktivno naročnino.",
        "title": "Potrebna je naročnina"
      }
    },
    "whatsappConnect": {
      "expiredBody": "Zaradi varnosti so takšne povezave veljavne le kratek čas, ta pa je že potekla. Vrnite se v Vidimo in začnite znova na kartici WhatsApp v razdelku Sporočanje. Pri vaši nastanitvi se ni nič spremenilo.",
      "expiredTitle": "Povezava je potekla",
      "failedBody": "Nastavitve WhatsApp ni bilo mogoče naložiti. Poskusite znova ali začnite znova v aplikaciji Vidimo.",
      "failedTitle": "Nekaj je šlo narobe",
      "loading": "Nalaganje …",
      "noNumberBody": "Vrnite se v Vidimo, na kartici WhatsApp v razdelku Sporočanje vnesite svojo številko WhatsApp in znova začnite povezovanje. Če na kartici ni polja za številko, najprej znova zaženite Vidimo, da se posodobi. Pri vaši nastanitvi se ni nič spremenilo.",
      "noNumberTitle": "Številko vnesite v aplikaciji Vidimo",
      "openFromApp": "To stran lahko odprete le iz aplikacije Vidimo.",
      "title": "Povežite WhatsApp",
      "tryAgain": "Poskusite znova",
      "unavailableBody": "Povezava WhatsApp v tem okolju ni nastavljena.",
      "unavailableTitle": "Tukaj ni na voljo"
    },
    "whatsappEmbeddedSignup": {
      "buttonContinue": "Nadaljujte s Facebookom",
      "buttonFinishing": "Dokončevanje nastavitve …",
      "buttonInPopup": "Nadaljujte v pojavnem oknu …",
      "buttonLoading": "Nalaganje …",
      "buttonTryAgain": "Poskusite znova",
      "cancelled": "Registracija je bila preklicana. Kadar koli lahko začnete znova.",
      "closeAnytime": "To okno lahko kadar koli zaprete. Pri vaši nastanitvi se nič ne spremeni, dokler nastavitev WhatsAppa ni končana.",
      "errorConnectFailed": "Povezave z WhatsAppom ni bilo mogoče dokončati. Pri vaši nastanitvi se ni nič spremenilo. Poskusite znova.",
      "errorNoAccount": "Računa WhatsApp ni bilo mogoče prebrati pri Meti. Poskusite znova.",
      "errorUnconfirmed": "Povezave z WhatsAppom ni bilo mogoče potrditi. Preden poskusite znova, v Vidimu preverite Nastavitve > Sporočanje.",
      "expiredBody": "Ta povezava je potekla, preden je bila registracija končana. Vrnite se v Vidimo in začnite znova na kartici WhatsApp v razdelku Sporočanje. Pri vaši nastanitvi se ni nič spremenilo.",
      "introConnect": "Nastavili boste sporočanje WhatsApp Business na številki <number>{phone}</number> za nastanitev <name>{property}</name>. Registracija pri Meti traja nekaj minut in poteka v pojavnem oknu.",
      "introReconnect": "Povezavo WhatsApp za nastanitev <name>{property}</name> na številki <number>{phone}</number> je treba znova potrditi. Registracija pri Meti traja nekaj minut in poteka v pojavnem oknu.",
      "nextStepCheck": "WhatsApp preveri vašo številko. To običajno traja nekaj minut.",
      "nextStepCode": "Če vam WhatsApp kodo pošlje v SMS-u ali jo sporoči s klicem, jo vnesite na kartici WhatsApp v razdelku Sporočanje.",
      "nextStepsHeading": "Kaj sledi",
      "pendingBody": "WhatsApp nastavlja številko za nastanitev {property}.",
      "pendingTitle": "Vse je urejeno, od tu naprej poskrbimo mi",
      "reload": "Znova naložite",
      "sdkUnavailableBody": "Če uporabljate blokator vsebine, ga za to stran izklopite in jo znova naložite. Pri vaši nastanitvi se ni nič spremenilo.",
      "sdkUnavailableTitle": "Registracija pri Meti se ni naložila",
      "stepConfirmCode": "Potrdite kodo za preverjanje, ki jo Meta pošlje na to številko. Če prispe, ko to stran že zaprete, jo vnesite v aplikaciji Vidimo.",
      "stepPickAccount": "Izberite ali ustvarite račun WhatsApp Business in vnesite to isto številko. Številka ostane vaša in je ni treba prenašati.",
      "stepSignIn": "Prijavite se z računom Facebook, ki upravlja (ali bo upravljal) vaše podjetje.",
      "successBody": "Vaša številka WhatsApp Business je zdaj povezana z nastanitvijo {property}.",
      "successTitle": "WhatsApp je povezan",
      "thisProperty": "to nastanitev",
      "titleReconnect": "Znova povežite WhatsApp"
    }
  },

  "labels": {
    "balanceDue": "Za plačilo {amount}",
    "blockReason": {
      "maintenance": "Vzdrževanje",
      "manual": "Ročno zaprto",
      "owner": "Bivanje lastnika"
    },
    "blockReasonUnknown": "Zaprto",
    "callStatus": {
      "connected": "Povezano",
      "connecting": "Povezovanje …",
      "reconnecting": "Ponovno povezovanje …",
      "ringing": "Zvoni …"
    },
    "cancellationPolicyDescription": {
      "flexible": "Brezplačna odpoved do 1 dneva pred prihodom.",
      "moderate": "Brezplačna odpoved do 5 dni pred prihodom.",
      "non_refundable": "Plačilo za to rezervacijo ni vračljivo.",
      "strict": "Brezplačna odpoved do 14 dni pred prihodom."
    },
    "cleaningKind": {
      "post-checkout": "Po odhodu",
      "pre-checkin-refresh": "Osvežitev pred prihodom",
      "turnover": "Menjava gostov"
    },
    "drawerTitle": {
      "breakfast-service": "Zajtrk",
      "guest": "Gost",
      "reservation-unit": "Rezervacija",
      "staff": "Član ekipe",
      "staff-chat": "Člani klepeta",
      "task": "Naloga"
    },
    "guestIdentity": {
      "detail": {
        "authorityRejected": "Organ je zavrnil podatke",
        "filedOtherYourself": "Drugo poročilo ste oddali sami",
        "noAutomaticFiling": "Vidimo te prijave ne oddaja",
        "otherFacility": "Oddano pod drugo številko RNO",
        "reconnectCredentials": "Dostopne podatke za oddajo je treba znova vnesti",
        "savedNeverFiled": "Shranjeno pri gostu, brez oddaje",
        "typedNeverScanned": "Vneseno ročno, brez skeniranja"
      },
      "status": {
        "actionNeeded": "Potrebno ukrepanje",
        "fileManually": "Oddajte ročno",
        "filedByYou": "Oddali ste sami",
        "filing": "Oddaja poteka",
        "idNotScanned": "Dokument ni skeniran",
        "idOnFile": "Dokument shranjen",
        "noIdOnFile": "Dokument ni shranjen",
        "notFiledYet": "Še ni oddano",
        "registered": "Prijavljeno",
        "rejected": "Zavrnjeno",
        "reportCancelled": "Prijava stornirana",
        "submitted": "Oddano"
      }
    },
    "mealInclusion": {
      "complimentary": "Brezplačno",
      "included": "Vključeno v ceno"
    },
    "mealPlace": {
      "breakfast_area": "Prostor za zajtrk",
      "in_room": "V sobi",
      "takeaway_box": "Paket za s seboj"
    },
    "regimeException": {
      "alloggiati-web": "Vidimo ob spletni prijavi zbere podatke vsakega gosta za Alloggiati Web, statističnih podatkov ISTAT pa še ne more pripraviti ali poslati; samodejna oddaja prijav na Alloggiati Web je še v razvoju.",
      "declaration-meuble-de-tourisme": "Vidimo ne odda prijave turistične nastanitve (meublé de tourisme) namesto vas.",
      "eturizem": "Vidimo pripravlja vaša poročila za eTurizem. Samodejna oddaja podatkov na AJPES je še v razvoju.",
      "evisitor": "Vidimo še ne more prijaviti vaših gostov v sistem eVisitor namesto vas.",
      "imposta-di-soggiorno": "Vidimo še ne more izračunati turistične takse za vašo občino (Comune).",
      "istat-ross-1000": "Vidimo še ne more pripraviti ali poslati statističnih podatkov ISTAT vaši deželi.",
      "ses-hospedajes": "Vidimo še ne more oddati vaših poročil v sistem SES.Hospedajes namesto vas.",
      "siba": "Vidimo še ne more poslati vaših obrazcev v sistem SIBA namesto vas."
    },
    "registrationCredentialField": {
      "alloggiati_web": {
        "idAppartamento": "ID apartmaja",
        "password": "Geslo",
        "username": "Uporabniško ime",
        "wskey": "Ključ spletne storitve (WS Key)"
      },
      "eturizem": {
        "certificate": "Digitalno potrdilo (.p12 / KDP)",
        "certificatePassword": "Geslo potrdila",
        "password": "Geslo za portal AJPES",
        "rno": "Številka RNO",
        "username": "Uporabniško ime za portal AJPES"
      },
      "evisitor": {
        "password": "Geslo",
        "username": "Uporabniško ime"
      },
      "istat": {
        "password": "Geslo",
        "structureCode": "Koda obrata",
        "username": "Uporabniško ime"
      },
      "ses_hospedajes": {
        "clientCertificate": "Odjemalsko potrdilo SSL",
        "clientCertificatePassword": "Geslo potrdila",
        "password": "Geslo",
        "username": "Uporabniško ime spletne storitve"
      },
      "siba": {
        "accessKey": "Dostopni ključ (Chave de Acesso)",
        "establishment": "Številka obrata",
        "nipc": "Davčna številka (NIPC)"
      }
    },
    "registrationCredentialHelp": {
      "alloggiati_web": {
        "idAppartamento": "Samo če pod enim računom upravljate več enot.",
        "username": "Izda ga vaša krajevna Questura.",
        "wskey": "Ustvarite ga v Alloggiati Web. Ob vsaki menjavi gesla potrebujete novega, ustvarite pa lahko le enega na dan."
      },
      "eturizem": {
        "certificate": "Kvalificirano slovensko digitalno potrdilo, izdano vašemu podjetju.",
        "certificatePassword": "Pustite prazno, če potrdilo nima gesla.",
        "rno": "Identifikacijska številka, ki jo je AJPES tej nastanitvi dodelil v Registru nastanitvenih obratov (RNO). Samo števke.",
        "username": "Uporabniško ime, s katerim se prijavite v portal AJPES, ne vaš e-poštni naslov. E-poštnega naslova AJPES tukaj ne sprejme. Ko ste prijavljeni, je prikazano v zgornjem desnem kotu portala."
      },
      "evisitor": {
        "username": "Izda ga vaša krajevna turistična skupnost."
      },
      "istat": {
        "structureCode": "Koda, ki jo je vaša dežela dodelila tej nastanitvi (na primer B01205). Z njo je nastanitev označena v vsakem poročilu.",
        "username": "Izda ga turistični urad vaše dežele, ne ISTAT."
      },
      "ses_hospedajes": {
        "clientCertificate": "Samo če vaša nastavitev pri ministrstvu zahteva odjemalsko potrdilo.",
        "clientCertificatePassword": "Pustite prazno, če potrdilo nima gesla.",
        "username": "Uporabniško ime spletne storitve iz portala Sede Electrónica. Končuje se z WS."
      },
      "siba": {
        "accessKey": "Prejmete ga po pošti ali e-pošti.",
        "establishment": "Dodeli jo UCFE ob registraciji enote.",
        "nipc": "Davčna številka nastanitvene enote."
      }
    },
    "registrationCredentialPlaceholder": {
      "ses_hospedajes": {
        "username": "npr. 1234567WS"
      }
    },
    "registrationField": {
      "arrivalDate": "Datum prihoda",
      "birthCountry": "Država rojstva",
      "birthPlace": "Kraj rojstva",
      "dateOfBirth": "Datum rojstva",
      "departureDate": "Datum odhoda",
      "documentNumber": "Številka dokumenta",
      "documentType": "Vrsta dokumenta",
      "expiryDate": "Velja do",
      "firstName": "Ime",
      "issuingCountry": "Država izdaje",
      "lastName": "Priimek",
      "nationality": "Državljanstvo",
      "personalNumber": "Osebna identifikacijska številka",
      "residenceAddress": "Naslov prebivališča",
      "residenceCountry": "Država prebivališča",
      "sex": "Spol",
      "stayPurpose": "Namen bivanja"
    },
    "registrationOption": {
      "documentType": {
        "id_card": "Osebna izkaznica",
        "other": "Drugo",
        "passport": "Potni list"
      },
      "sex": {
        "F": "Ženski",
        "M": "Moški"
      },
      "stayPurpose": {
        "business": "Poslovni namen",
        "education": "Izobraževanje",
        "family": "Obisk družine",
        "medical": "Zdravljenje",
        "other": "Drugo",
        "tourism": "Turizem"
      }
    },
    "registrationSystem": {
      "alloggiati_web": {
        "authority": "Polizia di Stato (krajevna Questura)",
        "enrollmentSteps": {
          "enterCredentials": "Spodaj vnesite uporabniško ime, geslo in WS Key.",
          "generateWsKey": "Prijavite se in ustvarite ključ spletne storitve (WS Key). Ob vsaki menjavi gesla potrebujete novega, ustvarite pa lahko le enega na dan.",
          "requestAccount": "Pri krajevni Questuri zaprosite za račun Alloggiati Web. Prejmete uporabniško ime in geslo."
        }
      },
      "eturizem": {
        "authority": "AJPES",
        "enrollmentSteps": {
          "checkAccess": "Preverite, ali ima ta račun dostop do eTurizma. AJPES ga dodeli posebej, zato račun za portal brez njega ne more oddajati prijav.",
          "enterCredentials": "Spodaj vnesite to uporabniško ime in pripadajoče geslo, naložite potrdilo ter dodajte številko RNO. Vidimo prijave gostov, ki jih odda sam, v eTurizmu številči od {guestbookBase, number} naprej (polje »Zaporedna številka prijave gosta«), zato lahko vaš trenutni sistem do odhoda gostov sam zaključi prijave, ki jih je že oddal, ne da bi ena prijava prepisala drugo. Vidimo prijavlja goste, ki prispejo od dneva povezave naprej: poskrbite, da trenutni sistem od takrat ne prijavlja več novih gostov, sicer jih AJPES zabeleži dvakrat.",
          "findUsername": "Poiščite svoje uporabniško ime za portal AJPES. To je ime, ki ste ga izbrali ob odprtju računa, ne vaš e-poštni naslov: e-poštnega naslova AJPES ne sprejme. Prijavite se v portal AJPES in prikazano bo v zgornjem desnem kotu.",
          "obtainCertificate": "Pridobite kvalificirano slovensko digitalno potrdilo (.p12 / KDP), izdano vašemu podjetju.",
          "registerAccommodation": "Nastanitev vpišite v Register nastanitvenih obratov (RNO) pri AJPES. Register ji dodeli identifikacijsko številko: to je vaša številka RNO."
        }
      },
      "evisitor": {
        "authority": "Hrvaška turistična skupnost (krajevna turistična skupnost)",
        "enrollmentSteps": {
          "enterCredentials": "Vnesite ju spodaj.",
          "receiveCredentials": "Krajevna turistična skupnost vam izda uporabniško ime in geslo za eVisitor."
        }
      },
      "istat": {
        "authority": "Deželni urad za turistično statistiko (mreža ISTAT)",
        "enrollmentSteps": {
          "enterCredentials": "Vnesite kodo obrata, uporabniško ime in geslo.",
          "requestAccess": "Turistični urad svoje dežele (Ufficio Turismo) zaprosite za dostop prek spletne storitve (web service). Izda vam uporabniško ime in geslo ter sporoči kodo obrata."
        }
      },
      "ses_hospedajes": {
        "authority": "Ministerio del Interior (Sede Electrónica)",
        "enrollmentSteps": {
          "enroll": "Nastanitev vpišite v Sede Electrónica in izberite pošiljanje prek spletne storitve.",
          "obtainCertificate": "Če vaša nastavitev to zahteva, pri ministrstvu pridobite odjemalsko potrdilo SSL.",
          "receiveCredentials": "Prejmete uporabniško ime spletne storitve (končuje se z WS) in geslo."
        }
      },
      "siba": {
        "authority": "UCFE (Sistema de Segurança Interna)",
        "enrollmentSteps": {
          "enterCredentials": "Spodaj vnesite davčno številko, številko obrata in dostopni ključ.",
          "receiveAccessKey": "UCFE za ta obrat izda dostopni ključ (Chave de Acesso); nadomestnega zahtevajte na siba@ssi.gov.pt.",
          "register": "Nastanitveno enoto registrirajte pri UCFE kot uporabnik sistema SIBA in pridobite številko obrata."
        }
      }
    },
    "reservationSource": {
      "direct": "Neposredno",
      "other": "Drugo"
    },
    "reservationStatus": {
      "cancelled": "Odpovedano",
      "checked_in": "V nastanitvi",
      "checked_out": "Odšel",
      "confirmed": "Potrjeno",
      "declined": "Zavrnjeno",
      "no_show": "Ni prišel",
      "requested": "Povpraševanje"
    },
    "role": {
      "manager": "Upravitelj",
      "operator": "Sodelavec",
      "owner": "Lastnik",
      "receptionist": "Receptor"
    },
    "roleDescription": {
      "manager": "Vodi vsakdanje delo. Upravlja osebje, razen lastnikov.",
      "operator": "Terensko osebje: vidi le svoje naloge in povezane rezervacije.",
      "owner": "Popoln nadzor: obračun, nastavitve, brisanje.",
      "receptionist": "Skrbi za goste, rezervacije in naloge. Brez skrbniških pravic."
    },
    "roomAmenity": {
      "10": "Kopalni plašč",
      "105": "Štedilnik",
      "107": "Telefon",
      "11": "Brezplačni toaletni pripomočki",
      "13": "Kad",
      "142": "Prha",
      "144": "Zvočna izolacija",
      "146": "Mize in stoli",
      "15": "Kad ali prha",
      "162": "Garderobna omara",
      "166": "Klimatizacija",
      "167": "Opekač kruha",
      "18": "Kabelska televizija",
      "19": "Aparat za kavo/čaj",
      "193": "Skupna kopalnica",
      "2": "Klimatska naprava",
      "210": "Satelitska televizija",
      "223": "Pogled na gore",
      "224": "Pogled na morje",
      "228": "Copati",
      "245": "Zasebni bazen",
      "246": "TV z ravnim zaslonom",
      "251": "Televizor",
      "259": "Filmi",
      "28": "Pisalna miza",
      "3": "Budilka",
      "32": "Pomivalni stroj",
      "41": "Kamin",
      "5": "Radio",
      "50": "Sušilnik za lase",
      "5017": "Balkon",
      "55": "Likalnik in deska",
      "59": "Kuhinja",
      "61": "Čajna kuhinja",
      "68": "Mikrovalovna pečica",
      "69": "Minibar",
      "7": "Terasa",
      "77": "Pečica",
      "85": "Lastna kopalnica",
      "88": "Hladilnik",
      "92": "Sef"
    },
    "supportTeamName": "Ekipa Vidimo",
    "taskAssignmentPreset": {
      "first_available": "Prvi prosti",
      "specific_staff": "Določena oseba",
      "unassigned": "Brez dodelitve"
    },
    "taskFunction": {
      "check_in": "Sprejem gostov",
      "check_out": "Odhod gostov",
      "cleaning": "Čiščenje",
      "concierge": "Concierge",
      "maintenance": "Vzdrževanje"
    },
    "taskRuleTrigger": {
      "any": "Katero koli čiščenje"
    },
    "taskStatus": {
      "cancelled": "Preklicano",
      "completed": "Opravljeno",
      "in_progress": "V teku",
      "missed": "Prepozno",
      "paused": "Zaustavljeno",
      "pending": "Čaka"
    },
    "transport": {
      "email": "E-pošta",
      "phone": "Telefon",
      "sms": "SMS"
    },
    "unitReadiness": {
      "clean": "Čisto",
      "dirty": "Umazano",
      "inspected": "Pregledano",
      "out_of_order": "Izven uporabe"
    },
    "unitType": {
      "apartment": "Apartma",
      "double": "Dvoposteljna",
      "family": "Družinska",
      "quadruple": "Štiriposteljna",
      "single": "Enoposteljna",
      "studio": "Studio",
      "suite": "Suita",
      "triple": "Triposteljna",
      "twin": "Dvoposteljna z ločenima posteljama",
      "villa": "Vila"
    }
  },

  "meals": {
    "breakfastService": {
      "roomNotAssigned": "Soba ni dodeljena"
    },
    "breakfastServiceBody": {
      "breakfastArea": "Prostor za zajtrk",
      "cancel": "Prekličite",
      "complimentaryTag": "brezplačno",
      "coverCount": "{count, plural, one {# pogrinjek} two {# pogrinjka} few {# pogrinjki} other {# pogrinjkov}}",
      "done": "Končano",
      "emptyBody": "Nihče od nocojšnjih gostov nima zajtrka {date}.",
      "emptyTitle": "Danes zjutraj ni zajtrka",
      "errorRoomNotUpdated": "Te sobe ni bilo mogoče posodobiti. Poskusite znova.",
      "errorRoomsNotMoved": "Teh sob ni bilo mogoče premakniti. Poskusite znova.",
      "groupCount": "{count, plural, one {# soba} two {# sobi} few {# sobe} other {# sob}} · {covers}",
      "loading": "Nalaganje zajtrka",
      "movedTo": "{count, plural, one {# soba} two {# sobi} few {# sobe} other {# sob}} · {place, select, breakfast_area {prostor za zajtrk} in_room {v sobi} takeaway_box {paket za s seboj} other {{place}}}",
      "roomsOnDate": "{count, plural, one {# soba} two {# sobi} few {# sobe} other {# sob}} · {date}",
      "rowLabel": "{room}, {covers}",
      "rowLabelServed": "{room}, {covers}, postreženo",
      "select": "Izberite",
      "selectedCount": "{count, plural, one {# izbrana} two {# izbrani} few {# izbrane} other {# izbranih}}",
      "serveInRoom": "Postrezite v sobi",
      "served": "Postreženo"
    },
    "breakfastSummaryRow": {
      "ariaLabel": "Zajtrk, {covers, plural, one {# pogrinjek} two {# pogrinjka} few {# pogrinjki} other {# pogrinjkov}}, sobe: {rooms, plural, one {#} two {#} few {#} other {#}}",
      "inRoomCount": "{count, plural, one {# v sobi} two {# v sobi} few {# v sobi} other {# v sobi}}",
      "servedCount": "{count, plural, one {# postrežen} two {# postrežena} few {# postreženi} other {# postreženih}}",
      "title": "Zajtrk · {count, plural, one {# soba} two {# sobi} few {# sobe} other {# sob}}"
    },
    "reservationBreakfastCard": {
      "chargeForMorning": "Zaračunajte za to jutro",
      "coversAt": "{count, plural, one {# pogrinjek} two {# pogrinjka} few {# pogrinjki} other {# pogrinjkov}} · {place, select, breakfast_area {prostor za zajtrk} in_room {v sobi} takeaway_box {paket za s seboj} other {{place}}}",
      "errorMorningNotUpdated": "Tega jutra ni bilo mogoče posodobiti. Poskusite znova.",
      "givenBy": "Podaril: {name}",
      "makeComplimentary": "Podarite",
      "makeComplimentaryHint": "Podarite: odšteje se od računa",
      "markNotTaken": "Označite, da ni bil zaužit",
      "markServed": "Označite kot postreženo",
      "morningCount": "{count, plural, one {# jutro} two {# jutri} few {# jutra} other {# juter}}",
      "notCharged": "Ni zaračunano",
      "statusExpected": "Pričakovano",
      "statusNotTaken": "Ni zaužit",
      "statusServed": "Postreženo",
      "title": "Zajtrk",
      "unconfirmedCount": "Nepotrjeno: {count, plural, one {# jutro} two {# jutri} few {# jutra} other {# juter}}"
    }
  },

  "notifications": {
    "attention": {
      "activityFailed": "Samodejni ponovni poskus",
      "activityPending": "V čakalni vrsti za oddajo",
      "activitySubmitting": "Oddajanje poteka",
      "severityAtRisk": "Rok se izteka",
      "severityNeedsAction": "Potrebno ukrepanje"
    },
    "filingAttentionSection": {
      "activityNotConfirmed": "Prijava še ni potrjena",
      "activitySubmitted": "Oddano, čaka na potrditev organa",
      "checkIn": "Prijava",
      "checkOut": "Odjava",
      "deadlinePassed": "Rok je potekel",
      "detailNoDeadline": "{activity}, zakonski rok za oddajo pa se izteka.",
      "detailWithDeadline": "{activity} · {relative}",
      "title": "Prijava gostov"
    },
    "notificationMenu": {
      "activity": "Dejavnost",
      "close": "Zaprite obvestila",
      "emptyDescription": "Tukaj se bodo prikazali predlagani ukrepi in dejavnost",
      "emptySearchDescription": "Poskusite z drugim iskalnim izrazom",
      "errorApplyFailed": "Tega predloga ni bilo mogoče uporabiti. Morda je zastarel.",
      "errorDismissFailed": "Tega predloga ni bilo mogoče opustiti. Poskusite znova.",
      "errorMissingMergeProfiles": "Temu predlogu manjkata profila za združitev.",
      "errorNotCleared": "Te kartice ni bilo mogoče počistiti. Poskusite znova.",
      "errorNotClearedAfter": "{message}, vendar te kartice ni bilo mogoče počistiti. Poskusite znova.",
      "noActivity": "Še ni dejavnosti",
      "noPendingSuggestions": "Ni čakajočih predlogov",
      "noResults": "Ni zadetkov",
      "searchPlaceholder": "Iščite predloge in dejavnost …",
      "suggestedActions": "Predlagani ukrepi",
      "title": "Obvestila"
    },
    "notificationPrimer": {
      "decline": "Ne zdaj",
      "description": "Vklopite obvestila in Vidimo vas bo obveščal o novih sporočilih gostov in ekipe, prihodih in odpovedih ter rokih za prijavo gostov. Brez njih boste za to izvedeli šele, ko boste naslednjič odprli aplikacijo.",
      "enable": "Vklopite obvestila",
      "title": "Izveste takoj, ko vam gost piše"
    },
    "pushRegistration": {
      "androidChannelName": "Obvestila"
    },
    "relativeDeadline": {
      "dueInDays": "{count, plural, one {rok čez {count} d} two {rok čez {count} d} few {rok čez {count} d} other {rok čez {count} d}}",
      "dueInHours": "{count, plural, one {rok čez {count} h} two {rok čez {count} h} few {rok čez {count} h} other {rok čez {count} h}}",
      "dueInMinutes": "{count, plural, one {rok čez {count} min} two {rok čez {count} min} few {rok čez {count} min} other {rok čez {count} min}}",
      "overdueByDays": "{count, plural, one {zamuda {count} d} two {zamuda {count} d} few {zamuda {count} d} other {zamuda {count} d}}",
      "overdueByHours": "{count, plural, one {zamuda {count} h} two {zamuda {count} h} few {zamuda {count} h} other {zamuda {count} h}}",
      "overdueByMinutes": "{count, plural, one {zamuda {count} min} two {zamuda {count} min} few {zamuda {count} min} other {zamuda {count} min}}"
    },
    "statisticsAttentionSection": {
      "activityNotConfirmed": "Še ni potrjeno",
      "activitySubmitted": "Oddano, čaka na potrditev urada",
      "title": "Statistična poročila"
    },
    "taxReturnAttentionSection": {
      "detail": "{amount} za plačilo do {date}",
      "dueSoon": "Rok se izteka",
      "overdue": "V zamudi",
      "title": "Turistična taksa",
      "uncomputed": "{count, plural, one {taksa za # bivanje še ni izračunana} two {taksa za # bivanji še ni izračunana} few {taksa za # bivanja še ni izračunana} other {taksa za # bivanj še ni izračunana}}"
    },
    "timeOffProposalCard": {
      "confirm": "Potrdite",
      "dismiss": "Opustite",
      "errorMarkAway": "Odsotnosti ni bilo mogoče označiti. Poskusite znova.",
      "markedAway": "{who}: označeno kot odsoten",
      "markedAwayReleased": "{who}: označeno kot odsoten · {count, plural, one {# naloga ostaja nedodeljena} two {# nalogi ostajata nedodeljeni} few {# naloge ostajajo nedodeljene} other {# nalog ostaja nedodeljenih}}",
      "markedAwayReleasedDescription": "Znova jih dodelite v stolpcu Nedodeljeno pod Naloge.",
      "review": "Preglejte",
      "staffMemberFallback": "Član ekipe",
      "viewSourceMessage": "Oglejte si izvorno sporočilo"
    }
  },

  "rates": {
    "controls": {
      "fewerLabel": "{label}, manj",
      "moreLabel": "{label}, več"
    },
    "copy": {
      "board": {
        "noPrice": "Brez cene",
        "notKept": "Noči tako daleč naprej niso shranjene v tem telefonu.",
        "pastMonth": "Noči tako daleč nazaj niso shranjene v tem telefonu.",
        "tapHint": "Tapnite noč, da jo spremenite, ali datum, da spremenite vse vrste enot.",
        "tapHintProperty": "Tapnite noč, da jo spremenite, ali datum, da spremenite vse vrste enot v nastanitvi {propertyName}."
      },
      "changeNights": {
        "bookedWhenClosing": "{count, plural, one {{count} od teh noči že ima rezervacije. Zaprtje ustavi le nove rezervacije.} two {{count} od teh noči že imata rezervacije. Zaprtje ustavi le nove rezervacije.} few {{count} od teh noči že imajo rezervacije. Zaprtje ustavi le nove rezervacije.} other {{count} od teh noči že ima rezervacije. Zaprtje ustavi le nove rezervacije.}}",
        "cancel": "Prekličite",
        "chooseUnitType": "Izberite vsaj eno vrsto enote.",
        "close": "Zaprite",
        "fields": {
          "checkIn": "Prihod",
          "checkOut": "Odhod",
          "maximumStay": "Najdaljše bivanje",
          "minimumStay": "Najkrajše bivanje",
          "price": "Cena",
          "sale": "Prodaja"
        },
        "firstNight": "Prva noč",
        "firstThenLast": "Tapnite prvo noč, nato zadnjo",
        "lastNight": "Zadnja noč",
        "leaveAsIs": "Pustite, kot je",
        "minFromSeason": "Iz sezone",
        "nothingToSend": "Izberite, kaj želite spremeniti.",
        "priceFor": "Nova cena za vrsto enote {unitTypeName}",
        "priceToSet": "Nova cena",
        "priceUseSeasonOrBase": "Uporabite sezonsko ali osnovno",
        "saveLabel": "Shranite",
        "setAPrice": "Raje nastavite ceno",
        "tapForSpan": "Za več noči tapnite še drugo noč.",
        "tapToWiden": "Za več noči tapnite še drugo noč ali drugo vrstico, da jo dodate.",
        "title": "Spremenite noči",
        "toWord": "do",
        "useSeasonOrBaseInstead": "Raje uporabite sezonsko ali osnovno ceno",
        "was": "Prej: {reads}."
      },
      "changes": {
        "sendAgain": "Pošljite znova",
        "showTheseNights": "Pokažite te noči",
        "status": "Status",
        "taskId": "Sklic kanala",
        "title": "Spremembe cen",
        "undo": "Razveljavite to spremembo",
        "whatChanged": "Kaj se je spremenilo",
        "whatWasSent": "Kaj je bilo poslano",
        "who": {
          "automatic": "Samodejno",
          "automaticAt": "Samodejno, {time}",
          "bySupport": "Podpora Vidimo v imenu: {actor}",
          "inTheApp": "{name}, {time}, v aplikaciji",
          "onBehalf": "{agent} (podpora Vidimo) v imenu: {actor}",
          "unknown": "Neznano"
        }
      },
      "delivery": {
        "awaitingFullSync": "Poslano bo ob naslednji polni sinhronizaciji",
        "notConnected": "Nobena rezervacijska stran ni povezana, zato je ostalo v Vidimu",
        "notMapped": "Ni poslano: ta vrsta enote ni povezana z vašimi kanali",
        "notSent": "Ni poslano v vaše kanale",
        "passedUnanswered": "Te noči so minile, preden so vaši kanali potrdili spremembo",
        "sending": "Pošiljanje v vaše kanale",
        "sent": "Poslano v vaše kanale",
        "sentAt": "Poslano v vaše kanale ob {time}",
        "unmapped": "{count, plural, one {{unitTypes} ni povezana z vašimi kanali, zato ni bila poslana.} two {{unitTypes} nista povezani z vašimi kanali, zato nista bili poslani.} few {{unitTypes} niso povezane z vašimi kanali, zato niso bile poslane.} other {{unitTypes} niso povezane z vašimi kanali, zato niso bile poslane.}}"
      },
      "discard": {
        "body": "Izbrali ste noči ali vnesli vrednost. Želite zavreči to spremembo?",
        "discard": "Zavrzite",
        "forTapOn": "Želite začeti spremembo v nastanitvi {propertyName}? Kar ste vnesli tukaj, bo zavrženo.",
        "keep": "Nadaljujte urejanje"
      },
      "editor": {
        "closedOn": "{of, plural, one {Zaprto {on} od {of} noči} two {Zaprto {on} od {of} noči} few {Zaprto {on} od {of} noči} other {Zaprto {on} od {of} noči}}",
        "detailsKept": "Podrobnosti sprememb hranimo 90 dni.",
        "lastChanged": "Nazadnje spremenil(a) {who}, {when}.",
        "notAllowedOn": "{of, plural, one {Ni dovoljeno {on} od {of} noči} two {Ni dovoljeno {on} od {of} noči} few {Ni dovoljeno {on} od {of} noči} other {Ni dovoljeno {on} od {of} noči}}",
        "varies": "Različno"
      },
      "errors": {
        "belowLowest": "Najnižja cena za vrsto enote {unitTypeName} je {price}.",
        "conflict": "Te noči so bile od vašega zadnjega ogleda spremenjene v drugi napravi. Preverite jih in pošljite še enkrat.",
        "lowestNotAbove0": "Vnesite najnižjo ceno, večjo od 0.",
        "lowestOverBase": "Najnižja cena ne sme biti višja od osnovne cene.",
        "offline": "Ste brez povezave, zato to ni bilo shranjeno. Shranite znova, ko boste spet povezani.",
        "priceAbove0": "Vnesite ceno, večjo od 0.",
        "priceToType": "Vnesite novo ceno.",
        "priceUnreadable": "Vnesite ceno, na primer {example, number}.",
        "pricedUnder": "{which, select, nights {{nights, plural, one {Za {nights} noč vrste {unitTypeName} je cena nižja od {amount}. Najprej jo zvišajte, nato nastavite najnižjo ceno.} two {Za {nights} noči vrste {unitTypeName} je cena nižja od {amount}. Najprej jo zvišajte, nato nastavite najnižjo ceno.} few {Za {nights} noči vrste {unitTypeName} je cena nižja od {amount}. Najprej jo zvišajte, nato nastavite najnižjo ceno.} other {Za {nights} noči vrste {unitTypeName} je cena nižja od {amount}. Najprej jo zvišajte, nato nastavite najnižjo ceno.}}} seasons {{seasons, plural, one {Za {seasons} sezono vrste {unitTypeName} je cena nižja od {amount}. Najprej jo zvišajte, nato nastavite najnižjo ceno.} two {Za {seasons} sezoni vrste {unitTypeName} je cena nižja od {amount}. Najprej jo zvišajte, nato nastavite najnižjo ceno.} few {Za {seasons} sezone vrste {unitTypeName} je cena nižja od {amount}. Najprej jo zvišajte, nato nastavite najnižjo ceno.} other {Za {seasons} sezon vrste {unitTypeName} je cena nižja od {amount}. Najprej jo zvišajte, nato nastavite najnižjo ceno.}}} other {Za {nights, plural, one {{nights} noč} two {{nights} noči} few {{nights} noči} other {{nights} noči}} in {seasons, plural, one {{seasons} sezono} two {{seasons} sezoni} few {{seasons} sezone} other {{seasons} sezon}} vrste {unitTypeName} je cena nižja od {amount}. Najprej jo zvišajte, nato nastavite najnižjo ceno.}}",
        "staysContradict": "Najkrajše bivanje je daljše od najdaljšega, zato se na to noč ne more začeti nobeno bivanje."
      },
      "heldBack": {
        "basePrice": "Osnovna cena je že {price}, zato se za vrsto enote {unitTypeName} nič ne spremeni.",
        "seasonMinimum": "Najkrajše bivanje sezone je že {nights}, zato se nič ne spremeni.",
        "seasonPrice": "Sezona {seasonName} že določa ceno {price}, zato se za vrsto enote {unitTypeName} nič ne spremeni.",
        "seasonPriceUnnamed": "Sezonska cena je že {price}, zato se za vrsto enote {unitTypeName} nič ne spremeni."
      },
      "hold": {
        "sendNow": "Pošljite zdaj",
        "waiting": "{changes, plural, one {{changes} sprememba bo poslana} two {{changes} spremembi bosta poslani} few {{changes} spremembe bodo poslane} other {{changes} sprememb bo poslanih}} v vaše kanale čez {seconds, plural, one {{seconds} s} two {{seconds} s} few {{seconds} s} other {{seconds} s}}"
      },
      "night": {
        "allowed": "Dovoljeno",
        "checkIn": "Prihod",
        "checkOut": "Odhod",
        "closed": "Zaprto",
        "fallBackToBase": "Uporabite osnovno ceno ({price})",
        "fallBackToSeason": "Uporabite sezono {name} ({price})",
        "maximumStay": "Najdaljše bivanje",
        "minFromSeason": "{count, plural, one {{count} iz sezone} two {{count} iz sezone} few {{count} iz sezone} other {{count} iz sezone}}",
        "minimumStay": "Najkrajše bivanje",
        "noLimit": "Brez omejitve",
        "noMinimum": "Brez minimuma",
        "notAllowed": "Ni dovoljeno",
        "notForSale": "Brez cene, zato ni v prodaji",
        "open": "Odprto",
        "price": "Cena",
        "priceFromBase": "Osnovna cena",
        "priceFromBaseAt": "Osnovna cena ({price})",
        "priceFromSeason": "Iz sezone {name}",
        "priceFromSeasonAt": "Iz sezone {name} ({price})",
        "priceRange": "{low}–{high}",
        "priceSetForNight": "Nastavljeno za to noč",
        "priceSetForNights": "Nastavljeno za te noči",
        "sale": "Prodaja",
        "seeTheChange": "Oglejte si spremembo.",
        "unitsFree": "{total, plural, one {Prosto: {free} od {total} enote} two {Prosto: {free} od {total} enot} few {Prosto: {free} od {total} enot} other {Prosto: {free} od {total} enot}}"
      },
      "nights": "{count, plural, one {{count} noč} two {{count} noči} few {{count} noči} other {{count} noči}}",
      "planned": {
        "checkInAllowed": "{position, select, first {Prihod dovoljen} other {prihod dovoljen}}",
        "checkInNotAllowed": "{position, select, first {Prihod ni dovoljen} other {prihod ni dovoljen}}",
        "checkOutAllowed": "{position, select, first {Odhod dovoljen} other {odhod dovoljen}}",
        "checkOutNotAllowed": "{position, select, first {Odhod ni dovoljen} other {odhod ni dovoljen}}",
        "chooseNights": "Izberite noči, ki jih želite spremeniti",
        "chooseSomething": "Izberite, kaj želite spremeniti",
        "chooseUnitType": "Izberite vsaj eno vrsto enote",
        "close": "{position, select, first {Zaprite} other {zaprite}}",
        "maxStay": "{position, select, first {{nights, plural, one {Nastavite najdaljše bivanje na {nights} noč} two {Nastavite najdaljše bivanje na {nights} noči} few {Nastavite najdaljše bivanje na {nights} noči} other {Nastavite najdaljše bivanje na {nights} noči}}} verb {{nights, plural, one {nastavite najdaljše bivanje na {nights} noč} two {nastavite najdaljše bivanje na {nights} noči} few {nastavite najdaljše bivanje na {nights} noči} other {nastavite najdaljše bivanje na {nights} noči}}} other {{nights, plural, one {najdaljše bivanje na {nights} noč} two {najdaljše bivanje na {nights} noči} few {najdaljše bivanje na {nights} noči} other {najdaljše bivanje na {nights} noči}}}}",
        "maxStayCleared": "{position, select, first {Brez najdaljšega bivanja} other {brez najdaljšega bivanja}}",
        "minStay": "{position, select, first {{nights, plural, one {Nastavite najkrajše bivanje na {nights} noč} two {Nastavite najkrajše bivanje na {nights} noči} few {Nastavite najkrajše bivanje na {nights} noči} other {Nastavite najkrajše bivanje na {nights} noči}}} verb {{nights, plural, one {nastavite najkrajše bivanje na {nights} noč} two {nastavite najkrajše bivanje na {nights} noči} few {nastavite najkrajše bivanje na {nights} noči} other {nastavite najkrajše bivanje na {nights} noči}}} other {{nights, plural, one {najkrajše bivanje na {nights} noč} two {najkrajše bivanje na {nights} noči} few {najkrajše bivanje na {nights} noči} other {najkrajše bivanje na {nights} noči}}}}",
        "minStayCleared": "{position, select, first {Najkrajše bivanje iz sezone} other {najkrajše bivanje iz sezone}}",
        "price": "{position, select, first {Nastavite ceno na {price}} verb {nastavite ceno na {price}} other {ceno na {price}}}",
        "priceCleared": "{position, select, first {Uporabite sezonsko ali osnovno ceno} other {uporabite sezonsko ali osnovno ceno}}",
        "reopen": "{position, select, first {Znova odprite} other {znova odprite}}",
        "sentence": "{unitTypes}: {changes}, {span} ({count, plural, one {{count} noč} two {{count} noči} few {{count} noči} other {{count} noči}})."
      },
      "sent": {
        "checkInAllowed": "prihod dovoljen",
        "checkInNotAllowed": "prihod ni dovoljen",
        "checkOutAllowed": "odhod dovoljen",
        "checkOutNotAllowed": "odhod ni dovoljen",
        "closed": "zaprto",
        "maxStay": "{nights, plural, one {najdaljše bivanje {nights} noč} two {najdaljše bivanje {nights} noči} few {najdaljše bivanje {nights} noči} other {najdaljše bivanje {nights} noči}}",
        "maxStayCleared": "brez najdaljšega bivanja",
        "minStay": "{nights, plural, one {najkrajše bivanje {nights} noč} two {najkrajše bivanje {nights} noči} few {najkrajše bivanje {nights} noči} other {najkrajše bivanje {nights} noči}}",
        "minStayCleared": "najkrajše bivanje iz sezone",
        "priceCleared": "cena spet iz sezone ali osnovna",
        "reopened": "znova odprto"
      },
      "summary": {
        "closedFor": "{unitTypes}: zaprto {span}",
        "line": "{unitTypes}: {fields}, {span}",
        "lineNights": "{unitTypes}: {fields}, {span} ({count, plural, one {{count} noč} two {{count} noči} few {{count} noči} other {{count} noči}})",
        "reopenedFor": "{unitTypes}: znova odprto {span}",
        "undone": "Razveljavljeno: {body}",
        "unitTypesHeadline": "{types, plural, one {{types} vrsta enote, {span}} two {{types} vrsti enot, {span}} few {{types} vrste enot, {span}} other {{types} vrst enot, {span}}}",
        "unitsFreeHeadline": "Poslano število prostih enot",
        "unitsFreeLine": "{free, plural, one {{unitType}: {free} prosta, {span}} two {{unitType}: {free} prosti, {span}} few {{unitType}: {free} proste, {span}} other {{unitType}: {free} prostih, {span}}}",
        "unitsFreeSent": "Poslano število prostih enot: {lines}. {trigger, select, nightly_refresh {Nočna osvežitev.} other {Po rezervaciji ali zaprtju.}}"
      },
      "toast": {
        "nothingConnected": "Nobena rezervacijska stran ni povezana, zato se cene spremenijo samo v Vidimu.",
        "saved": "Shranjeno",
        "undo": "Razveljavite",
        "undone": "Razveljavljeno",
        "waiting": "Zadnja sprememba se še shranjuje. Čez trenutek shranite znova."
      },
      "viewMenu": {
        "rates": "Cene",
        "staff": "Osebje",
        "units": "Enote"
      },
      "words": {
        "and": "{head} in {last}",
        "sentences": "{head}. {next}",
        "series": "{head}, {next}"
      }
    },
    "rateChangeDetailPage": {
      "awaitingFullSync": "{what}: vaši kanali jih še niso potrdili, zato jih bomo poslali ob naslednji polni sinhronizaciji.",
      "changedLine": "{unitType}, {span} ({count}): {changes}",
      "copied": "Kopirano",
      "copy": "Kopirajte",
      "copyFailed": "Kopiranje ni uspelo",
      "fieldCheckIn": "prihod",
      "fieldCheckOut": "odhod",
      "fieldMaxStay": "najdaljše bivanje",
      "fieldMinStayArrival": "najkrajše bivanje ob prihodu",
      "fieldMinStayThrough": "najkrajše bivanje čez to noč",
      "fieldPrice": "cena",
      "fieldSale": "prodaja",
      "fieldUnitsFree": "proste enote",
      "loading": "Nalaganje …",
      "noValueChanged": "Nobena vrednost se ni spremenila",
      "notFound": "Spremembe ni mogoče najti.",
      "notSent": "{what}: vaši kanali jih niso sprejeli.",
      "notSentBecauseConnection": "Vidimo takrat ni imel več dostopa do te nastanitve v vaših kanalih.",
      "notSentBecauseValues": "Preverite te vrednosti in jih nato pošljite znova.",
      "passedUnanswered": "{what}: vaši kanali jih niso potrdili, preden so te noči minile.",
      "pushedLine": "{unitType} {span}: {fields}",
      "saved": "Shranjeno {time}.",
      "sending": "{what}: pošiljanje.",
      "sent": "{what}, poslano v vaše kanale",
      "sentAt": "{what}, poslano v vaše kanale ob {time}",
      "taskIdAwaiting": "{taskId}: na voljo po pošiljanju",
      "wasNow": "{field}: prej {before}, zdaj {after}",
      "whatRates": "Cene in pravila",
      "whatUnitsFree": "Proste enote"
    },
    "ratesBoard": {
      "cellLabel": "{rowName}, {day}: {price}",
      "cellLabelClosed": "{rowName}, {day}: {price}, zaprto",
      "dateTapLabel": "Vse vrste enot na dan {day}",
      "dateTapPropertyLabel": "Vse vrste enot v nastanitvi {propertyName} na dan {day}",
      "units": "{count, plural, one {# enota} two {# enoti} few {# enote} other {# enot}}"
    },
    "ratesView": {
      "emptyDescription": "Preden nastavite cene, tej nastanitvi dodajte enote.",
      "emptyTitle": "Še ni enot",
      "nextMonth": "Naslednji mesec",
      "previousMonth": "Prejšnji mesec",
      "thisMonth": "Ta mesec"
    }
  },

  "reservations": {
    "assignUnitSelect": {
      "checking": "Preverjanje prostih enot …",
      "errorNotAssigned": "Te enote ni bilo mogoče dodeliti. Poskusite znova.",
      "errorUnitTaken": "Ta enota je za nekatere od teh noči že dodeljena drugemu bivanju. Izberite drugo enoto.",
      "noneFree": "Nobena enota ni prosta vse noči",
      "placeholder": "Dodelite enoto"
    },
    "cancelReservationAction": {
      "cancelAction": "Odpovejte rezervacijo",
      "cancelBody": "Rezervacija gosta {guestName} bo odpovedana, enota pa bo za te noči spet prosta.",
      "cancelTitle": "Želite odpovedati to rezervacijo?",
      "cancelToast": "Rezervacija odpovedana",
      "declineAction": "Zavrnite povpraševanje",
      "declineBody": "Povpraševanje gosta {guestName} bo zavrnjeno, enota pa za te noči ostane prosta.",
      "declineTitle": "Želite zavrniti to povpraševanje?",
      "declineToast": "Povpraševanje zavrnjeno",
      "errorCancel": "Rezervacije ni bilo mogoče odpovedati. Poskusite znova.",
      "errorDecline": "Povpraševanja ni bilo mogoče zavrniti. Poskusite znova.",
      "errorUndoCancel": "Razveljavitev ni uspela. Rezervacija ostaja odpovedana.",
      "errorUndoDecline": "Razveljavitev ni uspela. Povpraševanje ostaja zavrnjeno.",
      "keepIt": "Obdržite",
      "undo": "Razveljavite"
    },
    "checkInInviteCard": {
      "deliveryBounced": "Zavrnjeno: naslov sporočila ni sprejel",
      "deliveryComplained": "Prejemnik ga je označil kot neželeno pošto",
      "deliveryDelivered": "Dostavljeno",
      "deliverySent": "Poslano, čaka na potrditev",
      "deliverySuppressed": "Ni poslano: naslov je na seznamu blokiranih",
      "errorNotSent": "Povabila ni bilo mogoče poslati",
      "errorPreview": "Predogleda ni bilo mogoče naložiti",
      "noInvitation": "Za to rezervacijo ni povabila",
      "notSentYet": "Za to rezervacijo še ni bilo poslano nobeno povabilo.",
      "previewEmail": "Predogled e-pošte",
      "sendAgain": "Pošljite znova",
      "sendInvitation": "Pošljite povabilo",
      "sentTo": "Poslano na {email} dne {date}{count, plural, =0 {} =1 {} one { ({count}-krat)} two { ({count}-krat)} few { ({count}-krat)} other { ({count}-krat)}}.",
      "sentToast": "Povabilo k prijavi poslano na {email}",
      "title": "Povabilo k prijavi",
      "unavailableNoDates": "Najprej dodajte datuma prihoda in odhoda.",
      "unavailableNoEmail": "Ta rezervacija je prispela brez e-poštnega naslova.",
      "unavailableNotActive": "Ta rezervacija je odpovedana, zato ni ničesar za pošiljanje.",
      "unavailableNotFound": "Te rezervacije ni bilo mogoče najti."
    },
    "checkInLinkCard": {
      "copied": "Kopirano",
      "copy": "Kopirajte",
      "description": "Pošljite jo gostu in prijava se mu odpre brez vpisa. Predogled vam pokaže, kaj vidi gost.",
      "errorCreate": "Povezave za prijavo ni bilo mogoče ustvariti",
      "errorNotCopied": "Povezave ni bilo mogoče kopirati",
      "noLink": "Za to rezervacijo ni povezave",
      "preview": "Predogled",
      "title": "Povezava za samoprijavo",
      "toastCopied": "Povezava kopirana",
      "unavailableNoDates": "Najprej dodajte datuma prihoda in odhoda.",
      "unavailableNotActive": "Ta rezervacija je odpovedana, zato prijava ni mogoča.",
      "unavailableNotFound": "Te rezervacije ni bilo mogoče najti."
    },
    "collectPaymentSheet": {
      "amountLabel": "Znesek ({currency})",
      "channelWarning": "Ta rezervacija je prišla prek kanala, ki ceno sobe običajno pobere sam. Če jo zaračunate še enkrat, bo gost plačal dvakrat: zaračunajte le dodatke.",
      "copied": "Kopirano",
      "copy": "Kopirajte",
      "createLink": "Ustvarite plačilno povezavo",
      "creating": "Ustvarjanje …",
      "errorCopy": "Kopiranje ni uspelo: označite povezavo in jo kopirajte ročno.",
      "errorCreateLink": "Povezave ni bilo mogoče ustvariti. Poskusite znova.",
      "errorNoAmount": "Vnesite znesek za plačilo.",
      "holdLapsesWarning": "To bivanje traja dlje kot 7 dni, kolikor velja blokada. Kartica bo sproščena okoli {date}, pred gostovim odhodom, in po tem zneska ne boste mogli več unovčiti. Če potrebujete kritje do gostovega odhoda, v nastavitvah plačil izberite <strong>Bremenite</strong>.",
      "holdNotice": "Znesek se na gostovi kartici blokira: denar ostane gostov in nihče ni bremenjen, dokler ga ne unovčite. Blokada velja približno 7 dni, nato se kartica samodejno sprosti in zneska ne morete več unovčiti.",
      "linkCopied": "Plačilna povezava kopirana",
      "pendingUntilPaid": "Postavka je na računu prikazana kot neplačana, dokler gost ne dokonča plačila.",
      "presetBalance": "Celoten preostanek",
      "presetDeposit": "30-odstotno predplačilo",
      "presetTouristTax": "Turistična taksa",
      "sendHoldLink": "Pošljite to gostu. Znesek se blokira na njegovi kartici: denar ostane njegov, dokler ga ne unovčite.",
      "sendLink": "Pošljite to gostu. Račun se posodobi takoj, ko plača.",
      "title": "Prejmite plačilo"
    },
    "confirmMoneyAction": {
      "cancel": "Prekličite",
      "working": "Obdelava …"
    },
    "editGuestForm": {
      "avatarAlt": "Gost",
      "backToGuests": "Nazaj na goste",
      "emailLabel": "E-pošta",
      "emailPlaceholder": "gost@primer.si (obvezno, če ni imena ali telefona)",
      "errorNotSaved": "Gosta ni bilo mogoče shraniti. Poskusite znova.",
      "firstNameLabel": "Ime",
      "firstNamePlaceholder": "Vnesite ime (neobvezno, če sta vnesena telefon ali e-pošta)",
      "lastNameLabel": "Priimek",
      "lastNamePlaceholder": "Vnesite priimek (neobvezno, če sta vnesena telefon ali e-pošta)",
      "nationalityLabel": "Državljanstvo",
      "nationalityPlaceholder": "Izberite državljanstvo",
      "notFound": "Gosta ni mogoče najti",
      "phoneLabel": "Telefon",
      "phonePlaceholder": "(obvezno, če ni imena)",
      "saved": "Podatki o gostu shranjeni.",
      "title": "Uredite gosta"
    },
    "editReservationForm": {
      "accessibilityLabel": "Dostopnost",
      "accessibilityPlaceholder": "npr. raje pritličje, dostop z invalidskim vozičkom",
      "adultsLabel": "Odrasli",
      "arrivalTimeLabel": "Predviden čas prihoda",
      "backToCalendar": "Nazaj na koledar",
      "beforeCreating": "Pred ustvarjanjem",
      "beforeSaving": "Pred shranjevanjem",
      "channelCancelledNote": "Odpovedano na kanalu {source}; obnovi jo lahko le kanal",
      "channelDatesNote": "Datume upravlja {source}; spremenite jih tam in samodejno se bodo sinhronizirali",
      "channelManagedNote": "Sinhronizirano s kanala {source}. Datumi bivanja in odpovedi se upravljajo na kanalu in se sinhronizirajo samodejno; podatke o gostu, opombe in enoto lahko urejate tukaj.",
      "checkInTimeLabel": "Čas prihoda",
      "checkOutTimeLabel": "Čas odhoda",
      "checkingAvailability": "Preverjanje razpoložljivosti …",
      "childrenLabel": "Otroci",
      "create": "Ustvarite",
      "datesLabel": "Prihod–odhod",
      "dietaryLabel": "Prehrana",
      "dietaryPlaceholder": "npr. vegetarijanska pozdravna košarica, alergija na oreščke",
      "emailLabel": "E-pošta",
      "emailPlaceholder": "maja@primer.si",
      "errorAdultsRequired": "Za prijavo gosta nastavite število odraslih",
      "errorCheckInDateRequired": "Datum prihoda je obvezen",
      "errorCheckInTimeInvalid": "Čas prihoda mora biti v obliki 13:00",
      "errorCheckOutBeforeCheckIn": "Odhod mora biti po prihodu",
      "errorCheckOutDateRequired": "Datum odhoda je obvezen",
      "errorCheckOutTimeRequired": "Čas odhoda je obvezen",
      "errorFirstNameRequired": "Ime gosta je obvezno",
      "errorNotCreated": "Rezervacije ni bilo mogoče ustvariti. Vaši podatki so še vedno tukaj: poskusite znova.",
      "errorNotSaved": "Rezervacije ni bilo mogoče shraniti. Vaše spremembe so še vedno tukaj: poskusite znova.",
      "errorPropertyRequired": "Nastanitev je obvezna",
      "errorRoomRequired": "Izberite sobo za to rezervacijo",
      "firstNameLabel": "Ime",
      "firstNamePlaceholder": "Maja",
      "groupBookingNote": "Ta rezervacija obsega več enot; spreminjanje enot tukaj še ni podprto",
      "guestHeading": "Gost",
      "hasPetsLabel": "Potuje s hišnim ljubljenčkom",
      "infantsLabel": "Dojenčki",
      "lastNameLabel": "Priimek",
      "lastNamePlaceholder": "Novak",
      "notFound": "Rezervacije ni mogoče najti",
      "petNotesLabel": "Opombe o ljubljenčku",
      "petNotesPlaceholder": "npr. 1 majhen pes (Piki)",
      "phoneLabel": "Telefon",
      "propertyLabel": "Nastanitev",
      "propertyLocked": "Nastanitve po ustvarjanju rezervacije ni mogoče spremeniti",
      "propertyPlaceholder": "Izberite nastanitev",
      "save": "Shranite",
      "statusLabel": "Status",
      "stayDetailsHeading": "Podrobnosti bivanja",
      "titleEdit": "Uredite rezervacijo",
      "titleNew": "Nova rezervacija",
      "toastCreated": "Rezervacija ustvarjena.",
      "toastSaved": "Rezervacija shranjena.",
      "unitConflict": "Ta enota je že rezervirana {checkIn}–{checkOut}. Prilagodite datume ali izberite drugo enoto.",
      "unitConflictBy": "To enoto je že rezerviral(a) {name}, {checkIn}–{checkOut}. Prilagodite datume ali izberite drugo enoto.",
      "unitConflictByWithRef": "To enoto je že rezerviral(a) {name}, {checkIn}–{checkOut} (št. {reference}). Prilagodite datume ali izberite drugo enoto.",
      "unitConflictWithRef": "Ta enota je že rezervirana {checkIn}–{checkOut} (št. {reference}). Prilagodite datume ali izberite drugo enoto.",
      "unitLabel": "Enota",
      "unitPlaceholder": "Izberite sobo",
      "unitsFree": "{free, plural, one {Prosta {free} od {total}} two {Prosti {free} od {total}} few {Proste {free} od {total}} other {Prostih {free} od {total}}}"
    },
    "guestRegistrationStatus": {
      "authorityQuote": "»{reason}«",
      "authorityQuoteAt": "– {when}",
      "cancelAction": "Stornirajte to prijavo",
      "cancelConfirm": "Stornirajte prijavo",
      "cancelHint": "Samo če gost tukaj ne biva: če ni prišel ali če je bila prijava oddana za napačno nastanitev. Tega ni mogoče razveljaviti.",
      "cancelKeep": "Obdržite prijavo",
      "cancelTitle": "Želite stornirati to prijavo v sistemu {authority}?",
      "cancelledToast": "Prijava v sistemu {authority} je stornirana.",
      "cancelledWith": "Prijava v sistemu {authority} stornirana",
      "cancelledWithOn": "Prijava v sistemu {authority} stornirana {when}",
      "downloadReceipt": "Prenesite potrdilo",
      "errorCancel": "Prijave ni bilo mogoče stornirati. Poskusite znova.",
      "errorCancelRefused": "Prijava ni bila stornirana.",
      "errorDownloadReceipt": "Potrdila ni bilo mogoče prenesti. Poskusite znova.",
      "errorMarkFiled": "Oddaje ni bilo mogoče označiti. Poskusite znova.",
      "errorRetry": "Ponovna oddaja ni uspela. Poskusite znova.",
      "errorRetryFailedAgain": "Oddaja znova ni uspela.",
      "fixAndRefile": "Popravite in znova oddajte",
      "headlineAuthRefused": "{authority} je zavrnil dostopne podatke te nastanitve",
      "headlineAuthUnused": "Dostopnih podatkov te nastanitve za sistem {authority} ni bilo mogoče uporabiti",
      "headlineFiledByHost": "Drugo poročilo za tega gosta ste v sistem {authority} oddali sami",
      "headlineIncomplete": "{authority} te prijave ni mogel dokončati",
      "headlineMissingData": "{authority} potrebuje podatke, ki jih ta prijava nima",
      "headlineNoConnector": "Vidimo te prijave ne oddaja v sistem {authority}",
      "headlineNotReached": "Ta prijava še ni prispela v sistem {authority}",
      "headlineOtherFacility": "Ta gost je v sistemu {authority} prijavljen pod drugo številko RNO",
      "headlineUnattributed": "Sistem {authority} morda že ima to prijavo",
      "headlineValidation": "{authority} je zavrnil to prijavo",
      "lastTried": "Zadnji poskus {when}",
      "legalDeadline": "Zakonski rok · {deadline}",
      "markFiledAction": "Označite kot ročno oddano",
      "markFiledConfirm": "Označite kot oddano",
      "markFiledDescription": "Samo če je gost v sistemu {authority} že prijavljen: prijavili ste ga sami ali ste ga tam našli. Vidimo vas na to prijavo ne bo več opozarjal in je pozneje ne bo oddal.",
      "markFiledNotYet": "Še ne",
      "markFiledTitle": "Želite to prijavo označiti kot oddano?",
      "markedFiledToast": "Označeno kot oddano.",
      "nextStepAuth": "Znova vnesite dostopne podatke nastanitve, nato poskusite znova.",
      "nextStepFiledByHost": "Pred iztekom roka oddajte sami tudi to, nato jo tukaj označite kot oddano.",
      "nextStepMissingData": "Dopolnite manjkajoče podatke in shranite, da se prijava znova odda.",
      "nextStepNoConnector": "Gosta pred iztekom roka prijavite pri organu sami, nato prijavo tukaj označite kot oddano.",
      "nextStepOtherFacility": "Če je gost bival v obratu s številko RNO, s katero je bil zapis o njem oddan, ga tam na portalu organa zaključite; če ni, ga stornirajte in gosta prijavite pod trenutno številko RNO. Nato prijavo tukaj označite kot oddano. Če ste številko RNO te nastanitve spremenili pomotoma, jo popravite nazaj in poskusite znova.",
      "nextStepTransient": "Samodejni ponovni poskus.",
      "nextStepUnattributed": "Prijavo smo poslali, vendar nismo mogli potrditi, ali jo je organ sprejel. Preverite na portalu organa: če je gost tam, tapnite »Označite kot ročno oddano«; sicer tapnite »Poskusite znova«.",
      "nextStepValidation": "Spodaj popravite podatke in shranite. Prijava se bo znova oddala samodejno.",
      "openPortal": "Odprite {authority}",
      "reconnectCredentials": "Znova vnesite dostopne podatke",
      "retry": "Poskusite znova",
      "retrySubmittedToast": "Oddaja poslana.",
      "withdrawDescription": "{authority} bo zapis označil kot storniran, zato gost ne bo več prijavljen kot nastanjen tukaj. To uporabite, kadar gost tukaj ni bival: če ni prišel ali če je bilo bivanje oddano za napačno nastanitev. V Vidimu tega ni mogoče razveljaviti in Vidimo tega gosta pozneje ne bo znova prijavil.",
      "withdrawnBody": "Zapis ostane v njihovem registru, označen kot storniran. Gost ni prijavljen kot nastanjen tukaj."
    },
    "mergeConfirmView": {
      "cancel": "Prekličite",
      "confirm": "Potrdite združitev",
      "description": "Podatki gosta {source} bodo dodani v profil gosta {target}.",
      "source": "Vir",
      "target": "Cilj",
      "title": "Potrdite združitev"
    },
    "registrationDetailsForm": {
      "checkOutAtDeparture": "Odjava gosta se sporoči ob odhodu.",
      "correctDetails": "Popravite podatke",
      "correctingNote": "Ob shranjevanju se popravljeni podatki pošljejo z vsako prijavo, ki še čaka na oddajo ali je bila zavrnjena; prijava, ki jo je organ že sprejel, se ne pošlje znova.",
      "errorNotSaved": "Podatkov ni bilo mogoče shraniti. Poskusite znova.",
      "idDocument": "Osebni dokument",
      "noIdOnFile": "Dokument še ni shranjen.",
      "optional": "Neobvezno",
      "placeholderBirthCountry": "Izberite državo rojstva",
      "placeholderDocumentType": "Izberite vrsto dokumenta",
      "placeholderIssuingCountry": "Izberite državo izdaje",
      "placeholderNationality": "Izberite državljanstvo",
      "placeholderResidenceCountry": "Izberite državo prebivališča",
      "placeholderSex": "Izberite spol",
      "placeholderStayPurpose": "Izberite namen bivanja",
      "saved": "Podatki za prijavo shranjeni.",
      "savedBlockedAuth": "Shranjeno. Za oddajo morate znova vnesti dostopne podatke nastanitve za državni portal.",
      "savedBlockedFiledByHost": "Shranjeno. Drugo poročilo za tega gosta ste oddali sami, zato pri organu sami oddajte tudi to.",
      "savedBlockedMissingData": "Shranjeno, vendar oddaja še potrebuje podatke, ki jih ta prijava še nima.",
      "savedBlockedNoConnector": "Shranjeno. Vidimo tega gosta ne prijavlja, zato ga pred iztekom roka prijavite pri organu sami.",
      "savedBlockedOtherFacility": "Shranjeno. Zapis o tem gostu je oddan pod drugo številko RNO. Če gost ni bival v tistem obratu, zapis na portalu organa stornirajte in gosta prijavite pod trenutno številko; sicer ga zaključite pod tisto.",
      "savedBlockedUnknown": "Shranjeno, vendar oddaja še zahteva pozornost.",
      "savedBlockedValidation": "Shranjeno, vendar jo je organ znova zavrnil.",
      "savedFiled": "Shranjeno in oddano. Organ je prijavo potrdil.",
      "savedSubmitted": "Shranjeno in oddano. Čaka na potrditev.",
      "scanAgain": "Znova skenirajte dokument",
      "scanId": "Skenirajte dokument",
      "title": "Prijava",
      "typeId": "Vnesite ročno"
    },
    "reservationFolioCard": {
      "add": "Dodajte",
      "addCharge": "Dodajte postavko",
      "addChargeTitle": "Dodajte postavko",
      "amountPlaceholder": "Znesek ({currency})",
      "balanceDue": "Za plačilo",
      "breakfastControlLabel": "Zajtrk se nastavi po jutrih bivanja: odprite Zajtrk",
      "breakfastControlTitle": "Nastavi se po jutrih bivanja, v razdelku Zajtrk",
      "cancel": "Prekličite",
      "capture": "Unovčite",
      "captureConfirm": "Unovčite {amount}",
      "captureDescription": "{amount} se z gostove kartice prenese na vaš račun Stripe. To je celotna blokada: pozneje lahko znesek vrnete, preostanka pa ne morete unovčiti.",
      "captureTitle": "Želite unovčiti to blokado?",
      "chargeKind": "Vrsta postavke",
      "chipFailed": "neuspešno",
      "chipHoldExpired": "blokada potekla",
      "chipOnHold": "blokirano",
      "chipPending": "v obdelavi",
      "chipRefunded": "vrnjeno",
      "chipReleased": "sproščeno",
      "collectPayment": "Prejmite plačilo",
      "collectedByChannelName": "Pobral {channel}",
      "complimentary": "Brezplačno",
      "descriptionPlaceholder": "Opis",
      "errorChargeNotAdded": "Postavke ni bilo mogoče dodati. Poskusite znova.",
      "errorChargeRemoveRolledBack": "Postavke ni bilo mogoče odstraniti. Spet je na računu.",
      "errorEnterAmount": "Vnesite znesek",
      "errorMoneyActionFailed": "To ni uspelo. Poskusite znova.",
      "errorPaymentNotRecorded": "Plačila ni bilo mogoče evidentirati. Poskusite znova.",
      "errorPaymentRemoveRolledBack": "Plačila ni bilo mogoče odstraniti. Spet je na računu.",
      "fromChannel": "Iz kanala",
      "fromChannelName": "S kanala {channel}",
      "holdCaptured": "Blokada unovčena",
      "holdReleased": "Blokada sproščena",
      "inTheRate": "V ceni",
      "kindAccommodation": "Cena sobe",
      "kindAdjustment": "Popravek",
      "kindDiscount": "Popust",
      "kindFee": "Pristojbina",
      "kindTax": "Davek",
      "methodBankTransfer": "Bančno nakazilo",
      "methodCard": "Kartica",
      "methodCash": "Gotovina",
      "methodChannelCollected": "Pobral kanal",
      "methodDeposit": "Predplačilo",
      "methodGiftVoucher": "Darilni bon",
      "methodOther": "Drugo",
      "noCharges": "Še ni postavk.",
      "notTaken": "Ni zaužito",
      "partyAdults": "{count, plural, one {# odrasli} two {# odrasla} few {# odrasli} other {# odraslih}}",
      "partyAdultsAndChildren": "{adults, plural, one {# odrasli} two {# odrasla} few {# odrasli} other {# odraslih}} · {children, plural, one {# otrok} two {# otroka} few {# otroci} other {# otrok}}",
      "partyChildren": "{count, plural, one {# otrok} two {# otroka} few {# otroci} other {# otrok}}",
      "partyCovers": "{count, plural, one {# pogrinjek} two {# pogrinjka} few {# pogrinjki} other {# pogrinjkov}}",
      "paymentMethod": "Način plačila",
      "quantityPlaceholder": "Kol.",
      "rateAdultsAndChildren": "Odrasli {adult} · Otroci {child}",
      "ratePerPerson": "{amount} na osebo",
      "record": "Evidentirajte",
      "recordPayment": "Evidentirajte plačilo",
      "recordPaymentTitle": "Evidentirajte plačilo",
      "referencePlaceholder": "Sklic (neobvezno)",
      "refund": "Vrnite",
      "refundConfirm": "Vrnite {amount}",
      "refundDescription": "{amount} se z vašega računa Stripe vrne gostu. Stripe ob vračilu ne povrne svoje provizije za obdelavo.",
      "refundIssued": "Vračilo izvedeno",
      "refundTitle": "Želite vrniti to plačilo?",
      "release": "Sprostite",
      "releaseConfirm": "Sprostite {amount}",
      "releaseDescription": "Blokada zneska {amount} na gostovi kartici bo sproščena in pozneje je ne boste mogli unovčiti. Za novo blokado mora gost znova plačati.",
      "releaseTitle": "Želite sprostiti to blokado?",
      "removeCharge": "Odstranite postavko",
      "removePayment": "Odstranite plačilo",
      "title": "Račun",
      "total": "Skupaj",
      "touristTax": "Turistična taksa",
      "voucherCodePlaceholder": "Koda bona (neobvezno)"
    },
    "reservationTaxCard": {
      "filedThrough": "Oddaja prek sistema {system}",
      "guestNumber": "Gost {number}",
      "guestShare": "{band} · {nights, plural, one {# noč} two {# noči} few {# noči} other {# noči}}",
      "needsBirthDates": "{count, plural, =0 {Dodajte datume rojstva gostov} one {Dodajte datum rojstva za # gosta} two {Dodajte datuma rojstva za # gosta} few {Dodajte datume rojstva za # goste} other {Dodajte datume rojstva za # gostov}}",
      "needsCategory": "Izberite kategorijo nastanitve",
      "needsGuests": "Za prikaz te takse vnesite število gostov",
      "needsIntegration": "Za prikaz te takse nastavite sistem {system}",
      "needsMunicipality": "Za prikaz te takse izberite občino nastanitve",
      "needsPrice": "Za prikaz te takse dodajte ceno sobe",
      "needsRegistration": "Za prikaz te takse nastavite prijavo gostov",
      "noLines": "Turistična taksa za to bivanje še ni izračunana.",
      "notCovered": "Še ni podprto",
      "paysFree": "Brez takse",
      "paysFull": "Polna taksa",
      "paysHalf": "Polovična taksa",
      "paysPercent": "{percent} polne takse",
      "ratePercent": "{percent} cene, največ {cap}",
      "ratePerNight": "{rate} na noč",
      "ratePerNightFrom": "Od {date}: {rate} na noč",
      "rateWithSurcharge": "{rate} + {surcharge} {label}",
      "title": "Turistična taksa",
      "zone": "Znesek za {zone}"
    },
    "reservationTaxNote": {
      "add": "Dodajte opombo o taksi",
      "cancel": "Prekličite",
      "edit": "Uredite",
      "help": "Podatki o turistični taksi za to bivanje, ki jih rezervacija ne navaja, npr. da je gost pokazal napotnico za zdraviliško zdravljenje. To opombo vidi samo osebje.",
      "label": "Opomba o taksi",
      "placeholder": "npr. Gost je pokazal zdravniško napotnico za zdraviliško zdravljenje",
      "save": "Shranite opombo",
      "saveFailed": "Opombe o taksi ni bilo mogoče shraniti. Poskusite znova."
    },
    "reservationUnitDetails": {
      "adults": "{count, plural, one {{count} odrasli} two {{count} odrasla} few {{count} odrasli} other {{count} odraslih}}",
      "blockedChannelCancelled": "Odpovedano na kanalu; obnovi jo lahko le kanal.",
      "blockedPermission": "Nimate dovoljenja za spreminjanje statusa te rezervacije.",
      "blockedPreparing": "Ta nastanitev je v pripravi, zato to bivanje še vedno upravlja njen trenutni sistem. Tukaj ga še ni mogoče spremeniti, odpovedati ali zanj poslati povezave za prijavo.",
      "bookedVia": "Rezervirano prek",
      "bookerTitle": "Nosilec rezervacije",
      "bookingReference": "Številka rezervacije",
      "call": "Pokličite",
      "callAriaLabel": "Pokličite: {name}",
      "checkInLabel": "Prihod",
      "checkOutLabel": "Odhod",
      "children": "{count, plural, one {{count} otrok} two {{count} otroka} few {{count} otroci} other {{count} otrok}}",
      "copyRoomLinkLabel": "Kopirajte povezavo do sobe {room}",
      "duration": "{count, plural, one {{count} noč} two {{count} noči} few {{count} noči} other {{count} noči}}",
      "durationLabel": "Trajanje",
      "expectedArrivalLabel": "Predviden prihod",
      "guestSummary": "{occupancy} · shranjeni dokumenti: {idsOnFile} od {count, plural, one {{count}} two {{count}} few {{count}} other {{count}}}",
      "guestsTitle": "Gostje",
      "houseRulesAccepted": "Sprejeto {date}",
      "houseRulesLabel": "Hišni red",
      "infants": "{count, plural, one {{count} dojenček} two {{count} dojenčka} few {{count} dojenčki} other {{count} dojenčkov}}",
      "moreGuestsExpected": "{count, plural, one {Pričakujemo še {count} gosta} two {Pričakujemo še {count} gosta} few {Pričakujemo še {count} goste} other {Pričakujemo še {count} gostov}}",
      "notGiven": "Ni navedeno",
      "notOnBookingYet": "Še ni na rezervaciji · skenirajte dokument, da ga dodate",
      "notSpecified": "Ni določeno",
      "occupancyLabel": "Zasedenost",
      "openGuestLabel": "Odprite: {name}",
      "registrationAriaLabel": "Prijava gosta {name}: {status}",
      "reservationInformation": "Podatki o rezervaciji",
      "room": "Soba {room}",
      "scanBooker": "Skenirajte dokument",
      "scanBookerAriaLabel": "Skenirajte dokument: {name}",
      "scanId": "Skenirajte dokument",
      "specialRequest": "Posebna želja",
      "taskWithUnit": "{task} · Enota {unit}",
      "tasksTitle": "Naloge",
      "typeId": "Vnesite ročno",
      "unassigned": "{count, plural, one {Nedodeljena} two {# nedodeljeni} few {# nedodeljene} other {# nedodeljenih}}",
      "unitLabel": "Enota",
      "unitsLabel": "Enote",
      "unknownUnit": "Neznana enota",
      "unscheduled": "Brez termina"
    },
    "stayAction": {
      "checkIn": "Označite prihod",
      "checkInGuest": "Označite prihod: {guestName}",
      "checkOut": "Označite odhod",
      "checkOutGuest": "Označite odhod: {guestName}"
    },
    "unitOptions": {
      "booked": "Rezervirano"
    },
    "useStayAction": {
      "errorNotUpdated": "Bivanja ni bilo mogoče posodobiti. Poskusite znova."
    }
  },

  "settings": {
    "accessSection": {
      "doorCode": "Koda za vrata",
      "doorCodeDescription": "Gostje na dan prihoda dobijo kodo za tipkovnico",
      "label": "Način dostopa",
      "lockbox": "Sef za ključe",
      "lockboxDescription": "Gostje ključ vzamejo iz sefa s kodo",
      "placeholder": "Izberite način dostopa",
      "receptionCloses": "Recepcija se zapre",
      "receptionOpens": "Recepcija se odpre",
      "smartLock": "Pametna ključavnica",
      "smartLockDescription": "Gostje odklenejo s kodo ali aplikacijo",
      "staffedReception": "Recepcija z osebjem",
      "staffedReceptionDescription": "Gostje ključe prevzamejo na recepciji"
    },
    "account": {
      "interfaceLanguage": {
        "automatic": "Samodejno ({language})",
        "description": "Meniji, gumbi in zasloni so prikazani v tem jeziku.",
        "title": "Jezik vmesnika"
      }
    },
    "accountDeletion": {
      "genericFailure": "Računa ni bilo mogoče izbrisati. Poskusite znova.",
      "protectedAccount": "Ta račun je zaščiten in ga ni mogoče izbrisati.",
      "soleOwner": "{count, plural, one {Nastanitev {properties} nima drugega lastnika razen vas.} two {Nastanitvi {properties} nimata drugega lastnika razen vas.} few {Nastanitve {properties} nimajo drugega lastnika razen vas.} other {Nastanitve {properties} nimajo drugega lastnika razen vas.}} Preden izbrišete račun, za lastnika določite še koga drugega ali {count, plural, one {nastanitev izbrišite} two {nastanitvi izbrišite} few {nastanitve izbrišite} other {nastanitve izbrišite}}."
    },
    "accountPassword": {
      "genericFailure": "Gesla ni bilo mogoče nastaviti. Poskusite znova.",
      "sessionStale": "Zaradi varnosti se pred nastavitvijo gesla izpišite in znova vpišite."
    },
    "accountView": {
      "appearanceDescription": "Spremembe v tej napravi začnejo veljati takoj.",
      "appearanceTitle": "Videz",
      "errorNameRequired": "Ime je obvezno",
      "errorPhotoNotSaved": "Fotografije ni bilo mogoče shraniti. Poskusite znova.",
      "hapticsDescription": "Kratek vibracijski odziv, ko označite prihod, opravite skeniranje ali končate menjavo, da lahko pogled ostane na gostu. V tej napravi velja takoj.",
      "hapticsTitle": "Vibracije",
      "hapticsToggle": "Vibriranje ob potrditvah",
      "languageArabic": "Arabščina",
      "languageDefault": "Privzeto (angleščina)",
      "languageChinese": "Kitajščina",
      "languageEnglish": "Angleščina",
      "languageFrench": "Francoščina",
      "languageGerman": "Nemščina",
      "languageItalian": "Italijanščina",
      "languageJapanese": "Japonščina",
      "languagePortuguese": "Portugalščina",
      "languageSlovenian": "Slovenščina",
      "languageSpanish": "Španščina",
      "nameDescription": "Prikazano ekipi in na sporočilih, ki jih pošljete.",
      "namePlaceholder": "Vnesite ime",
      "nameTitle": "Ime in priimek",
      "phoneDescription": "Vaša službena številka.",
      "phoneTitle": "Telefonska številka",
      "photoAlt": "Profil",
      "photoCaption": "Tapnite, da zamenjate profilno fotografijo",
      "subtitle": "Upravljajte profil in podatke",
      "themeDark": "Temno",
      "themeLight": "Svetlo",
      "themeSystem": "Sistemsko",
      "title": "Račun",
      "translationLanguageDescription": "Sporočila v drugih jezikih se prevedejo v ta jezik.",
      "translationLanguageTitle": "Jezik prevodov"
    },
    "addressSection": {
      "countryLabel": "Država",
      "hint": "Poiščite in izberite naslov nastanitve. Z njim določimo lokacijo in samodejno vnesemo državo.",
      "label": "Naslov",
      "placeholder": "Poiščite naslov nastanitve …"
    },
    "availabilityDisplay": {
      "availableDuring": "Na voljo {summary}",
      "awayOn": "Odsoten {date}",
      "awayRange": "Odsoten {range}",
      "awayThrough": "Odsoten do {end}",
      "awayToday": "Danes odsoten",
      "awayTomorrow": "Jutri odsoten",
      "outsideAvailability": "Zunaj razpoložljivosti"
    },
    "breakfastPage": {
      "adult": "Odrasli",
      "child": "Otrok",
      "errorSave": "Nastavitev zajtrka ni bilo mogoče shraniti. Poskusite znova.",
      "from": "Od",
      "inclusionCharged": "Zaračunano",
      "inclusionChargedDetail": "Gostje ga plačajo. Brezplačno ga dobijo le bivanja, prodana s ceno z nočitvijo in zajtrkom.",
      "inclusionComplimentary": "Brezplačno",
      "inclusionComplimentaryDetail": "Brezplačno za vse goste, ne glede na rezervirano ceno. Na račun se ne doda nič.",
      "inclusionIncluded": "Vključeno v ceno",
      "inclusionLabel": "Način plačila",
      "placeLabel": "Običajno postreženo",
      "priceHint": "Na osebo na jutro, v {currency}. Kdo šteje za otroka, določa rezervacija, zato pri bivanju prek kanala velja starostno pravilo kanala.",
      "priceLabel": "Cena",
      "save": "Shranite",
      "saved": "Shranjeno",
      "serveBreakfast": "Strežemo zajtrk",
      "serveBreakfastHint": "Če je izklopljeno, jutra niso načrtovana in v pogledu Danes se nič ne prikaže.",
      "serviceHint": "Gostje vidijo te ure. Kje se streže, lahko za vsako sobo spremenite tisto jutro.",
      "serviceLabel": "Strežba",
      "title": "Zajtrk",
      "unavailableDescription": "Na tej napravi Vidimo ne more naložiti nastavitev zajtrka. Če poskusite znova, se bo aplikacija na novo naložila.",
      "unavailableTitle": "Zajtrka trenutno ni mogoče spremeniti",
      "until": "Do"
    },
    "cancellationSection": {
      "flexible": "Prilagodljivi",
      "hint": "{policyDescription} Gostje, ki rezervirajo na vaši javni strani, to vidijo pred plačilom, vračila pa se ravnajo po tem.",
      "label": "Pogoji odpovedi",
      "moderate": "Zmerni",
      "nonRefundable": "Brez vračila",
      "placeholder": "Izberite pogoje odpovedi",
      "strict": "Strogi"
    },
    "channelCards": {
      "announced": "Povežite {label}, da se razpoložljivost in cene sinhronizirajo v obe smeri, nove rezervacije pa prihajajo naravnost v Vidimo.",
      "cancel": "Prekličite",
      "comingSoon": "Povezava s kanalom {label} bo kmalu na voljo.",
      "connectButton": "Povežite {label}",
      "connectTitle": "Povežite {label}",
      "connecting": "Povezovanje …",
      "continue": "Nadaljujte",
      "errorConnect": "Kanala ni bilo mogoče povezati. Poskusite znova.",
      "errorOpenSetup": "Nastavitve kanala ni bilo mogoče odpreti. Poskusite znova.",
      "errorSync": "Sinhronizacija ni uspela. Poskusite znova.",
      "explainerLogin": "Končali boste na varni strani za nastavitev, zato imejte pri roki dostopne podatke za kanal {label}.",
      "explainerOwnerOnly": "{label} lahko poveže le račun lastnika oglasa, ne sogostitelj.",
      "explainerSync": "Razpoložljivost in cene se s kanalom {label} usklajujejo v obe smeri, nove rezervacije pa prihajajo v Vidimo.",
      "noUnits": "Najprej dodajte enoto v to nastanitev.",
      "opening": "Odpiranje …",
      "setUpChannels": "Nastavite {label}",
      "statusError": "napaka",
      "syncAction": "Sinhronizirajte razpoložljivost in cene",
      "syncDone": "Razpoložljivost in cene so znova usklajene s kanalom {label}.",
      "syncSlow": "{label} se odziva počasi. Sinhronizacija se bo končala samodejno.",
      "syncStarted": "Sinhronizacija se je začela. Končala se bo v ozadju.",
      "syncing": "Sinhroniziranje …",
      "warnings": {
        "delayed": "Sinhronizacija zamuja. Samodejno bomo poskušali znova, ukrepati vam ni treba.",
        "ourSide": "Pri tem kanalu je na naši strani prišlo do težave. O tem smo že obveščeni.",
        "unlinkedRoom": "Nove rezervacije nismo mogli povezati. Preverite nastavitev tega kanala."
      },
      "whichUnits": "Katere enote so objavljene na kanalu {label}?"
    },
    "chrome": {
      "statusActionNeeded": "Potrebno ukrepanje",
      "statusConnected": "Povezano",
      "statusOff": "Izklopljeno",
      "statusSettingUp": "Nastavljanje"
    },
    "cleaningChecklistEditor": {
      "addStep": "Dodajte korak",
      "alwaysLast": "· vedno zadnji",
      "guestNeedsHint": "Potrebe gostov iz rezervacije, kot sta otroška posteljica ali hišni ljubljenček, se dodajo tik pred končnim pregledom.",
      "listFull": "{count, plural, one {Kontrolni seznam ima lahko največ # korak.} two {Kontrolni seznam ima lahko največ # koraka.} few {Kontrolni seznam ima lahko največ # korake.} other {Kontrolni seznam ima lahko največ # korakov.}}",
      "moveDown": "Premaknite korak {position} navzdol",
      "moveUp": "Premaknite korak {position} navzgor",
      "remove": "Odstranite korak {position}",
      "saveList": "Shranite kontrolni seznam",
      "saving": "Shranjevanje …",
      "stepBlank": "Izpolnite ta korak ali ga odstranite.",
      "stepLabel": "Korak {position}",
      "stepLength": "{length} / {max}",
      "stepPlaceholder": "Opišite korak",
      "stepTooLong": "{count, plural, one {Predolgo za {count} znak.} two {Predolgo za {count} znaka.} few {Predolgo za {count} znake.} other {Predolgo za {count} znakov.}}",
      "unsavedChanges": "Neshranjene spremembe"
    },
    "cleaningPage": {
      "allRooms": "Vse sobe",
      "assignHeading": "Komu gre naloga",
      "discard": "Zavrzite",
      "discardDescription": "Ta kontrolni seznam ima neshranjene spremembe. Če zdaj preklopite, bodo zavržene.",
      "discardDescriptionReload": "Imate neshranjene spremembe. Če zdaj znova naložite aplikacijo, jih boste izgubili.",
      "discardTitle": "Želite zavreči spremembe?",
      "errorReset": "Kontrolnega seznama ni bilo mogoče spremeniti. Poskusite znova.",
      "errorSave": "Kontrolnega seznama ni bilo mogoče shraniti. Poskusite znova.",
      "giveOwnList": "Enoti {unitName} dodelite lasten kontrolni seznam",
      "hintPostCheckout": "Gost je odšel, isti dan pa ne prihaja nihče.",
      "hintRefresh": "Recepcija tik pred prihodom vsakega gosta pripravi že očiščeno sobo.",
      "hintTurnover": "En gost odide, drug pa prispe isti dan.",
      "inheritedPostCheckoutFromProperty": "{unitName} uporablja kontrolni seznam nastanitve za čiščenje po odhodu:",
      "inheritedPostCheckoutFromStandard": "{unitName} uporablja standardni kontrolni seznam za čiščenje po odhodu:",
      "inheritedPreCheckinRefreshFromProperty": "{unitName} uporablja kontrolni seznam nastanitve za osvežitev pred prihodom:",
      "inheritedPreCheckinRefreshFromStandard": "{unitName} uporablja standardni kontrolni seznam za osvežitev pred prihodom:",
      "inheritedTurnoverFromProperty": "{unitName} uporablja kontrolni seznam nastanitve za menjavo gostov:",
      "inheritedTurnoverFromStandard": "{unitName} uporablja standardni kontrolni seznam za menjavo gostov:",
      "intro": "Te nastavitve določajo, komu gre vsaka naloga čiščenja, ki jo ustvari Vidimo, in s katerimi koraki se začne. Ročna dodelitev ima vedno prednost, obstoječe naloge pa ohranijo, kar so imele ob nastanku.",
      "keepEditing": "Nadaljujte urejanje",
      "kindLabel": "Vrsta čiščenja",
      "loading": "Nalaganje kontrolnih seznamov …",
      "ownListCreated": "{name} ima zdaj lasten kontrolni seznam. Uredite ga spodaj.",
      "refreshError": "Nastavitve osvežitve ni bilo mogoče shraniti. Poskusite znova.",
      "refreshHint": "Recepcija vsako sobo po čiščenju pripravi tik pred prihodom gosta. Velja le za rezervacije, ustvarjene po vklopu.",
      "refreshLabel": "Osvežitev pred vsakim prihodom",
      "resetLabelProperty": "Uporabite kontrolni seznam nastanitve",
      "resetLabelStandard": "Ponastavite na standardni kontrolni seznam",
      "resetToProperty": "{name} zdaj uporablja kontrolni seznam nastanitve.",
      "resetToStandard": "Ponastavljeno na standardni kontrolni seznam.",
      "saveAndSwitch": "Shranite in preklopite",
      "saveFirstDescription": "Ta kontrolni seznam ima neshranjene spremembe. Shranite jih pred preklopom ali pa jih zavrzite.",
      "saveFirstTitle": "Želite shraniti spremembe?",
      "saved": "Kontrolni seznam je shranjen. Uporabljale ga bodo naloge čiščenja, ki jih Vidimo ustvari od zdaj naprej.",
      "scopeHint": "Sobi dodelite lasten kontrolni seznam le, če se razlikuje, na primer zaradi balkona ali masažne kadi.",
      "scopeLabel": "Velja za",
      "stepsHeading": "Kontrolni seznam",
      "thisRoom": "To sobo",
      "title": "Čiščenje",
      "unavailableDescription": "Na tej napravi jih Vidimo ne more naložiti. Če poskusite znova, se bo aplikacija ponovno naložila.",
      "unavailableTitle": "Kontrolnih seznamov trenutno ni mogoče spremeniti",
      "undo": "Razveljavite"
    },
    "createPage": {
      "created": "Nastanitev ustvarjena",
      "createdPendingSync": "Nastanitev ustvarjena. Prikazala se bo, ko se povezava ujame.",
      "description": "Nastavite novo nastanitev za upravljanje gostov in osebja.",
      "errorNotCreated": "Nastanitve ni bilo mogoče ustvariti. Poskusite znova.",
      "title": "Ustvarite nastanitev"
    },
    "createPropertyForm": {
      "addressHint": "Poiščite in izberite naslov, da določite lokacijo in izpolnite državo. Naslov lahko dodate tudi pozneje.",
      "addressLabel": "Naslov",
      "addressNoCountry": "Ta naslov nima države. Izberite jo spodaj.",
      "addressPlaceholder": "Poiščite naslov nastanitve …",
      "cancel": "Prekličite",
      "countryHint": "Določa prijavo gostov, turistično takso in DDV za nastanitev.",
      "countryLabel": "Država *",
      "countryPlaceholder": "Izberite državo",
      "nameLabel": "Ime nastanitve *",
      "namePlaceholder": "Vnesite ime nastanitve",
      "submit": "Nadaljujte"
    },
    "credentialHealth": {
      "accepted": "{system} je {checkedAt} sprejel vaš vpis in testni zapis. Preverjanje ničesar ne odda.",
      "badge": {
        "enterAgain": "Vnesite znova",
        "keyRefused": "Ključ zavrnjen",
        "noAnswer": "Brez odgovora",
        "refusedAccount": "Račun zavrnjen",
        "signInRefused": "Vpis zavrnjen",
        "works": "Račun deluje"
      },
      "enterAgain": "Od {since} Vidimo ne more uporabiti shranjenih dostopnih podatkov, zato v sistem {system} ni bilo poslano nič. Vnesite jih znova.",
      "keyRefused": "Od {since} {system} zavrača ta {key}.{said} Ustvarite novega in ga vnesite z možnostjo Posodobite dostopne podatke. {help}",
      "noAnswer": "{system} {checkedAt} ni odgovoril na preverjanje Vidima.{streak} Vidimo bo znova preveril v enem dnevu.",
      "recordRefused": "Vpis deluje. {checkedAt} je {system} zavrnil testni zapis Vidima, kar moramo odpraviti mi, ne vi.{said} Nič ni bilo oddano.",
      "refusedAccount": "Od {since} {system} sprejme vpis, vendar za ta račun zavrne preverjanje.{said} Preverite, ali je za ta račun omogočena spletna storitev in ali so spodnje številke apartmaja ali računa pravilne.",
      "said": " Sporočilo: »{message}«.",
      "signInRefused": "Od {since} {system} zavrača vpis s temi podatki.{said} Preverite uporabniško ime in geslo.",
      "streak": " Od {since} ni dal nobenega odgovora.",
      "unanswered": "{system} je {checkedAt} namesto odgovora vrnil napako: »{message}«.{streak} Vidimo bo znova preveril v enem dnevu."
    },
    "customDomainView": {
      "addDomain": "Dodajte domeno",
      "copied": "Kopirano v odložišče",
      "copyRecordValue": "Kopirajte vrednost zapisa {type}",
      "dnsInstructions": "Te zapise dodajte pri registrarju domene. Spremembe DNS lahko potrebujejo nekaj minut, da začnejo veljati.",
      "domainAdded": "Domena dodana: za potrditev nastavite zapise DNS",
      "domainLabel": "Vaša domena",
      "domainLive": "Vaša domena deluje",
      "domainPlaceholder": "vas-hotel.si",
      "domainRemoved": "Lastna domena odstranjena",
      "errorAdd": "Domene ni bilo mogoče dodati",
      "errorCopy": "Kopiranje v odložišče ni uspelo",
      "errorRemove": "Domene ni bilo mogoče odstraniti",
      "intro": "Spletno stran Places za vašo nastanitev objavite na lastni domeni, npr. <example>www.vas-hotel.si</example>. Gostje naslova vidimo.app nikoli ne vidijo.",
      "loadFailedBody": "Preverite povezavo in poskusite znova.",
      "loadFailedTitle": "Nastavitev domene ni bilo mogoče naložiti",
      "openSite": "Odprite stran",
      "primary": "glavna",
      "remove": "Odstranite",
      "retry": "Poskusite znova",
      "siteLiveBody": "Gostje vas najdejo na {url}.",
      "siteLiveTitle": "Vaša stran je objavljena",
      "statusActive": "Aktivna",
      "statusError": "Napaka",
      "statusPendingDns": "Čaka na DNS",
      "statusVerifying": "Preverjanje",
      "stillWaiting": "Še čakamo na DNS; to lahko traja nekaj minut",
      "title": "Lastna domena",
      "verificationFailedBody": "Preverite spodnje zapise DNS in poskusite znova.",
      "verificationFailedTitle": "Preverjanje ni uspelo",
      "verify": "Preverite"
    },
    "deleteAccountSection": {
      "confirmPhrase": "trajno izbriši",
      "description": "Trajno izbrišite račun in osebne podatke, vključno s profilom, sporočili v klepetih ekipe in dostopom do vseh nastanitev, katerih član ste. Tega ni mogoče razveljaviti.",
      "errorLoad": "Tega računa ni bilo mogoče preveriti. Preverite povezavo in poskusite znova.",
      "errorNotDeleted": "Računa ni bilo mogoče izbrisati. Poskusite znova.",
      "errorOffline": "Ste brez povezave, zato tega računa trenutno ni mogoče preveriti.",
      "title": "Izbris računa"
    },
    "deleteConfirmDialog": {
      "cancel": "Prekličite",
      "confirmNamePrompt": "Za potrditev vnesite: <strong>{entityName}</strong>",
      "confirmPhrasePrompt": "Za potrditev izbrisa <strong>{entityName}</strong> vnesite <strong>»{expectedValue}«</strong>",
      "deleting": "Brisanje …",
      "placeholder": "Vnesite »{expectedValue}«"
    },
    "deleteDangerSection": {
      "checking": "Preverjanje …",
      "retry": "Poskusite znova"
    },
    "disconnectIntegration": {
      "cancel": "Prekličite",
      "disconnect": "Prekinite povezavo",
      "disconnected": "Povezava s kanalom {channel} prekinjena",
      "disconnecting": "Prekinjanje povezave …",
      "error": "Povezave s kanalom {channel} ni bilo mogoče prekiniti. Poskusite znova.",
      "title": "Želite prekiniti povezavo s kanalom {channel}?"
    },
    "editableSettingCard": {
      "errorNotSaved": "Shranjevanje ni uspelo. Poskusite znova.",
      "save": "Shranite",
      "saved": "Shranjeno",
      "saving": "Shranjevanje …"
    },
    "emailPreviewSheet": {
      "frameTitle": "Predogled e-pošte",
      "loading": "Nalaganje …",
      "sampleNote": "Primer z imenom in naslovom vaše nastanitve. Datumi, gost in številka rezervacije so izmišljeni.",
      "subject": "Zadeva",
      "title": "Predogled"
    },
    "facilityNumber": {
      "addedWithLogin": "Polje »{field}« izpolnite, ko spodaj vnesete dostopne podatke.",
      "elsewhere": "Obrat s številko, vneseno v polje »{field}«, je v registru vpisan v občini {other}, ne v tej. Preverite številko ali občino nastanitve.",
      "errorSave": "Polja »{field}« ni bilo mogoče shraniti. Poskusite znova.",
      "listed": "Obrat je v registru vpisan v tej občini.",
      "listedNamed": "V registru je pod to številko vpisan obrat {name}.",
      "neededForTax": "Turistična taksa je v tej občini odvisna od tega, kje je vaša nastanitev, kakšne vrste je ali kdo jo oddaja, zato Vidimo za izračun potrebuje to številko.",
      "notListed": "V tej občini v registru ni aktivnega nastanitvenega obrata s številko, vneseno v polje »{field}«. Obrat, vpisan danes, se prikaže naslednji dan.",
      "registerIncomplete": "V registru o tem obratu še ni dovolj podatkov za izračun turistične takse. Vidimo jo prikaže, ko bodo podatki na voljo.",
      "save": "Shranite",
      "saved": "Polje »{field}« je shranjeno",
      "saving": "Shranjevanje …"
    },
    "guestPortalForm": {
      "cancel": "Prekličite",
      "errorNotSaved": "Portala za goste ni bilo mogoče shraniti. Poskusite znova.",
      "intro": "Gostje to berejo na strani svojega bivanja, osnutki odgovorov AI pa odgovarjajo na podlagi tega. Gesla za WiFi in kod za vrata osnutki nikoli ne dobijo.",
      "parking": "Parkiranje",
      "parkingSummary": "{count, plural, =0 {Še ni nastavljeno} one {# parkirno mesto} two {# parkirni mesti} few {# parkirna mesta} other {# parkirnih mest}}",
      "save": "Shranite",
      "subtitle": "Kaj gostje berejo na strani svojega bivanja",
      "title": "Portal za goste"
    },
    "guestPortalPage": {
      "title": "Portal za goste"
    },
    "guestPreviewPage": {
      "desktopUnavailable": "Predogled se odpre v spletni aplikaciji ter v aplikacijah za telefon in tablico.",
      "title": "Predogled kot gost"
    },
    "guestRegistryPage": {
      "bornOn": "roj. {date}",
      "document": "{type} {number}",
      "documentIdCard": "Osebna izkaznica",
      "documentOther": "Dokument",
      "documentPassport": "Potni list",
      "documentWithIssuer": "{type} {number} ({country})",
      "emptyDescription": "Gostje se prikažejo tukaj, ko se prijavijo.",
      "emptyFilteredDescription": "Tem filtrom ne ustreza noben vpis.",
      "emptyTitle": "Ni vpisov",
      "errorLoad": "Knjige gostov ni bilo mogoče naložiti. Poskusite znova.",
      "loadMore": "Naložite več",
      "loadingMore": "Nalaganje …",
      "noDocument": "Brez dokumenta",
      "occupancy": "{adults, plural, one {# odr.} two {# odr.} few {# odr.} other {# odr.}}",
      "occupancyUnknownAdults": "? odr.",
      "occupancyUnknownAdultsWithChildren": "? odr. · {children, plural, one {# otr.} two {# otr.} few {# otr.} other {# otr.}}",
      "occupancyWithChildren": "{adults, plural, one {# odr.} two {# odr.} few {# odr.} other {# odr.}} · {children, plural, one {# otr.} two {# otr.} few {# otr.} other {# otr.}}",
      "title": "Knjiga gostov"
    },
    "guestRegistryParams": {
      "statusAll": "Vsa bivanja",
      "statusCheckedIn": "V nastanitvi",
      "statusCheckedOut": "Odšli"
    },
    "guestRegistryRegistryFilterBar": {
      "allTime": "Ves čas",
      "count": "{count, plural, one {{count} vpis} two {{count} vpisa} few {{count} vpisi} other {{count} vpisov}}",
      "countPartial": "{shown} od {total, plural, one {{total} vpisa} two {{total} vpisov} few {{total} vpisov} other {{total} vpisov}}",
      "customRange": "Poljubno obdobje",
      "exportCsv": "Izvozite CSV",
      "exporting": "Izvažanje …",
      "intro": "Uradna evidenca o tem, kdo je bival pri vas, zajeta ob prijavi. Vpise je mogoče le dodajati; ogled in izvoz jih nikoli ne spremenita.",
      "rangePlaceholder": "Izberite obdobje",
      "searchPlaceholder": "Iščite ime gosta …",
      "statusFilterLabel": "Filtrirajte po statusu bivanja",
      "yearFilterLabel": "Filtrirajte po letu"
    },
    "guestRegistryUseGuestRegistry": {
      "errorExport": "Knjige gostov ni bilo mogoče izvoziti.",
      "errorLoadMore": "Več vpisov ni bilo mogoče naložiti."
    },
    "houseRulesSection": {
      "houseInfoHint": "Kako vse deluje: ogrevanje, smeti, aparati, nočni mir.",
      "houseInfoLabel": "O nastanitvi",
      "houseInfoPlaceholder": "Ogrevanje se upravlja na plošči ob vratih.\nSmeti odnesemo v torek zvečer.",
      "houseRulesHint": "Eno pravilo na vrstico. Gostje jih preberejo v portalu in jih ob prijavi enkrat potrdijo; če polje pustite prazno, se ta korak preskoči.",
      "houseRulesLabel": "Hišni red",
      "houseRulesPlaceholder": "Kajenje v vsej stavbi ni dovoljeno.\nNočni mir od 22:00 do 8:00.",
      "localTipsHint": "Vaši nasveti iz okolice: hrana, prevoz, česa ne smete zamuditi.",
      "localTipsLabel": "Lokalni nasveti",
      "localTipsPlaceholder": "Najboljša kava: pekarna na vogalu.\nAvtobus št. 6 pelje naravnost v staro mestno jedro."
    },
    "importsPage": {
      "applyChange": "Uporabite različico iz sistema {source}",
      "brief": "{guest} · {dates} · {rooms}",
      "briefBlock": "Zaprto · {dates} · {rooms}",
      "briefCancelled": "{brief} · odpovedano",
      "candidate": "Rezervacija {number} iz prejšnjega uvoza",
      "changes": "Dodano: {added} · posodobljeno: {amended} · odpovedano: {cancelled} · nespremenjeno: {unchanged}",
      "current": "V Vidimu",
      "detail": "{field}: {value}",
      "detailNone": "brez",
      "details": {
        "adults": "Odrasli",
        "amountMinor": "Skupaj",
        "children": "Otroci",
        "email": "E-pošta",
        "infants": "Dojenčki",
        "notes": "Opombe",
        "phone": "Telefon",
        "reason": "Razlog",
        "source": "Vir",
        "status": "Stanje"
      },
      "emptyDescription": "Vidimo to nastanitev že upravlja, zato vanjo ni mogoče uvoziti rezervacij. Uvoz je namenjen le nastanitvi, ki je še v pripravi.",
      "emptyTitle": "Ni uvoženih rezervacij",
      "errorLoad": "Uvozov ni bilo mogoče naložiti. Čez trenutek poskusite znova.",
      "held": "{count, plural, one {# rezervacija čaka na vašo odločitev} two {# rezervaciji čakata na vašo odločitev} few {# rezervacije čakajo na vašo odločitev} other {# rezervacij čaka na vašo odločitev}}",
      "heldReason": {
        "host_changed": "V Vidimu ste spremenili rezervacijo {number} ali vnesli goste za sobo, iz katere jo sistem {source} zdaj premika, sistem {source} pa jo je medtem spremenil. Vaša različica ostane, dokler se ne odločite.",
        "host_deleted": "V Vidimu ste izbrisali rezervacijo {number}, sistem {source} pa jo je medtem spremenil. Ostane izbrisana, dokler se ne odločite.",
        "possible_match": "Rezervacija {number} v sistemu {source} je morda ista kot rezervacija, ki jo je prejšnji uvoz dodal pod drugo številko. Ni bila dodana, zato se nič ne podvoji."
      },
      "heldRoomRemoved": "Njena soba je bila odstranjena iz Vidima, zato različice iz sistema {source} tukaj ni mogoče uporabiti.",
      "heldUntilNext": "Odločite se, preden vaša aplikacija AI opravi naslednji uvoz: ta zapre odprte odločitve in znova vpraša o rezervacijah, ki so še vedno nejasne.",
      "how": {
        "connect": "Vidimo dodajte v Claude ali ChatGPT kot povezovalnik in ko vas Vidimo vpraša, pustite označeno možnost »{importLabel}«.",
        "copied": "Kopirano",
        "copy": "Kopirajte poziv",
        "copyFailed": "Kopiranje ni uspelo. Označite poziv in ga kopirajte sami.",
        "guide": "Preberite vodnik",
        "paste": "Ta poziv prilepite v nov klepet. Aplikacija AI vam pomaga dodati, kar manjka, zastavi nekaj vprašanj in kopira rezervacije.",
        "prompt": "Rezervacije iz sistema, ki ga uporabljam zdaj, želim kopirati v svojo nastanitev {property} v Vidimu. Najprej preveri, ali imaš obe stvari, ki sta za to potrebni. Če katera manjka, se ustavi, povej mi, katera, in me vodi skozi nastavitev.\n\n1. Vidimova orodja, na primer getImportPlaybook. Brez njih je Vidimo v tem klepetu izklopljen ali pa v tej aplikaciji še ni dodan. Najprej me prosi, naj pogledam med povezovalnike te aplikacije: če je Vidimo tam, ga vklopim. Če ga ni, mi pomagaj, da ga dodam kot povezovalnik po meri z naslovom {connectorUrl}. V Claudu je to Customize, Connectors, Add, Add custom connector. V ChatGPT-ju je to Plugins, Add, Add custom MCP server. To so angleška imena: če je moj vmesnik v drugem jeziku, mi povej imena, ki jih vidim jaz. Ko me Vidimo vpraša, se vpišem in pustim označeno možnost »{importLabel}«. Nato mi reci, naj začnem nov klepet in znova prilepim ta poziv, saj klepet dobi le povezovalnike, s katerimi se je začel. Če lahko odpiraš spletne strani, so koraki tudi na {guideUrl}.\n\n2. Brskalnik, ki ga lahko uporabljaš zame, v katerem se vpišem v svoj sistem, ti pa bereš njegove strani, na primer razširitev »Claude in Chrome« ali način »Work mode« v ChatGPT-ju. Spletno iskanje ni dovolj, ker moj sistem zahteva vpis. Če v tem klepetu ne moreš uporabljati nobenega, mi povej, kako ga dobim v tej aplikaciji.\n\nKo imaš oboje, pokliči getImportPlaybook in mu sledi.",
        "signIn": "V brskalniku, ki ga uporablja vaša aplikacija AI, odprite svoj trenutni sistem in se vpišite.",
        "title": "Uvozite rezervacije z aplikacijo AI"
      },
      "ignore": "Ne dodajte",
      "intro": "Tu so vsi uvozi, ki jih je opravila vaša aplikacija AI. Kjer vaš trenutni sistem prikazuje seštevke, so uvozi preverjeni z njimi.",
      "introUndo": "Dokler je ta nastanitev v pripravi, lahko uvoz razveljavite in tako odstranite rezervacije, ki jih je dodal.",
      "keep": "Obdržite ga",
      "keepDeleted": "Naj ostane izbrisana",
      "keepMine": "Obdržite svojo različico",
      "matches": "Ujema se s sistemom {source}: rezervacije po mesecih in zasedene noči po sobah so enake.",
      "mismatch": "Ne ujema se s sistemom {source}",
      "missingInVidimo": "{room}, noči {nights}: zasedeno v sistemu {source}, prosto v Vidimu",
      "monthDifference": "{month}: prihodov v sistemu {source}: {pms}, v Vidimu: {vidimo}",
      "noTotals": "Seštevki sistema {source} niso bili poslani s tem uvozom, zato Vidimo ne more potrditi, da ni ničesar izpustil. Uvoz sami primerjajte s sistemom {source}.",
      "notInPms": "{room}, noči {nights}: zasedeno v Vidimu, prosto v sistemu {source}",
      "notSent": "{count, plural, one {# rezervacija iz prejšnjega uvoza v tem uvozu manjka. Ostala je nespremenjena in ni odpovedana.} two {# rezervaciji iz prejšnjih uvozov v tem uvozu manjkata. Ostali sta nespremenjeni in nista odpovedani.} few {# rezervacije iz prejšnjih uvozov v tem uvozu manjkajo. Ostale so nespremenjene in niso odpovedane.} other {# rezervacij iz prejšnjih uvozov v tem uvozu manjka. Ostale so nespremenjene in niso odpovedane.}}",
      "problems": "{count, plural, one {# stvar za pregled} two {# stvari za pregled} few {# stvari za pregled} other {# stvari za pregled}}, po poročilu vaše aplikacije AI ob koncu uvoza",
      "proposed": "V sistemu {source}",
      "resolveFailed": "Vaše izbire ni bilo mogoče shraniti. Čez trenutek poskusite znova.",
      "resolveRefused": "Te izbire ni mogoče uporabiti takšne, kot je: rezervacija se je medtem spremenila, izbira se ne ujema več z njenimi datumi ali sobami ali pa bi odstranila goste, ki ste jih vnesli za sobo. Preverite rezervacijo v Vidimu in nato izberite znova.",
      "restore": "Obnovite iz sistema {source}",
      "runTitle": "Iz sistema {source}",
      "sameBooking": "Gre za isto rezervacijo",
      "separateBooking": "Dodajte kot novo rezervacijo",
      "status": {
        "finished": "Končano",
        "open": "Uvažanje",
        "undone": "Razveljavljeno"
      },
      "stillImporting": "Uvoz še poteka. Ko se konča, se preveri s seštevki sistema {source}, kjer jih aplikacija AI lahko pošlje.",
      "title": "Uvožene rezervacije",
      "superseded": "Medtem se je končal poznejši uvoz iz sistema {source}, zato preverjanje tega uvoza ne velja več: oglejte si poznejšega.",
      "totals": "{source}: {pmsBookings, plural, one {# rezervacija} two {# rezervaciji} few {# rezervacije} other {# rezervacij}} (po datumu prihoda), {pmsNights, plural, one {# sobna noč} two {# sobni noči} few {# sobne noči} other {# sobnih noči}}. Vidimo: {vidimoBookings, plural, one {# rezervacija} two {# rezervaciji} few {# rezervacije} other {# rezervacij}}, {vidimoNights, plural, one {# sobna noč} two {# sobni noči} few {# sobne noči} other {# sobnih noči}}.",
      "totalsFrom": "Preverjeno s seštevki sistema {source} na dan {date}.",
      "undo": "Razveljavite uvoz",
      "undoAmended": "Spremembe, ki jih je ta uvoz naredil pri rezervacijah iz prejšnjih uvozov, ostanejo.",
      "undoBody": "S tem iz Vidima odstranite, kar je ta uvoz kopiral iz sistema {source}: {reservations, plural, =1 {rezervacijo} one {# rezervacijo} two {# rezervaciji} few {# rezervacije} other {# rezervacij}}{blocks, plural, =0 {} one { in # zaprto sobo} two { in # zaprti sobi} few { in # zaprte sobe} other { in # zaprtih sob}}. V sistemu {source} se nič ne spremeni, rezervacije, ki ste jih ustvarili sami ali so jih dodali drugi uvozi, pa ostanejo.",
      "undoFailed": "Uvoza ni bilo mogoče razveljaviti. Čez trenutek poskusite znova.",
      "undoGuestDetails": "{count, plural, one {Pri # od uvoženih rezervacij ste vnesli goste: tudi ti podatki se odstranijo, profili gostov pa ostanejo.} two {Pri # od uvoženih rezervacij ste vnesli goste: tudi ti podatki se odstranijo, profili gostov pa ostanejo.} few {Pri # od uvoženih rezervacij ste vnesli goste: tudi ti podatki se odstranijo, profili gostov pa ostanejo.} other {Pri # od uvoženih rezervacij ste vnesli goste: tudi ti podatki se odstranijo, profili gostov pa ostanejo.}}",
      "undoNothingAdded": "Nič, kar je ta uvoz dodal, ni več v Vidimu, zato razveljavitev ničesar ne odstrani. Uvoz se označi kot razveljavljen, odločitve, ki so še čakale na vas, pa se zaprejo.",
      "undoOpenBody": "Ta uvoz še poteka. Razveljavitev ga ustavi in iz Vidima odstrani vse rezervacije, ki jih je kopiral iz sistema {source}, doslej {reservations}. V sistemu {source} se nič ne spremeni, rezervacije, ki ste jih ustvarili sami ali so jih dodali drugi uvozi, pa ostanejo.",
      "undoRefusedActive": "Vidimo zdaj upravlja to nastanitev, zato uvoza ni mogoče razveljaviti. Rezervacije spremenite posamično.",
      "undoTitle": "Želite razveljaviti ta uvoz?",
      "undone": "Uvoz razveljavljen. Odstranjeno: {reservations, plural, one {# rezervacija} two {# rezervaciji} few {# rezervacije} other {# rezervacij}}{blocks, plural, =0 {} one { in # zaprta soba} two { in # zaprti sobi} few { in # zaprte sobe} other { in # zaprtih sob}}.",
      "undoneOn": "Razveljavljeno {date}. Rezervacije, ki jih je ta uvoz dodal, so odstranjene.",
      "unknownRoom": "Odstranjena soba"
    },
    "infoEdit": {
      "errorNotDeleted": "Nastanitve ni bilo mogoče izbrisati. Poskusite znova."
    },
    "inviteMemberDrawer": {
      "emailHint": "Po e-pošti mu bomo poslali povezavo za pridružitev in kodo povabila, ki jo lahko vnese v aplikaciji.",
      "emailLabel": "E-pošta",
      "emailPlaceholder": "ime@primer.si",
      "errorFailed": "Vabilo ni uspelo",
      "noPermission": "Nimate dovoljenja za vabljenje članov v to nastanitev.",
      "roleLabel": "Vloga",
      "submit": "Pošljite povabilo",
      "submitPending": "Pošiljanje …",
      "title": "Povabite člana"
    },
    "joinPage": {
      "description": "Vnesite prejeto kodo povabila in se pridružite ekipi.",
      "title": "Pridružite se nastanitvi"
    },
    "joinPropertyForm": {
      "cancel": "Prekličite",
      "codeLabel": "Koda povabila",
      "codePlaceholder": "Vnesite kodo povabila",
      "submit": "Pridružite se"
    },
    "linkError": {
      "alreadyLinkedToDifferentUser": "Ta račun je že povezan z drugim računom Vidimo. Najprej ga tam odklopite.",
      "emailDoesNotMatch": "Ta račun uporablja drug e-poštni naslov. Povežete lahko le račun z istim e-poštnim naslovom kot ta račun.",
      "emailNotFound": "Ponudnik ni posredoval e-poštnega naslova, zato računa ni mogoče povezati s tem računom.",
      "generic": "Tega računa ni bilo mogoče povezati. Poskusite znova.",
      "unableToLinkAccount": "Tega računa ni bilo mogoče povezati. Preverite, ali je njegov e-poštni naslov potrjen pri ponudniku, in poskusite znova."
    },
    "linkSocialAccount": {
      "linkFailed": "Računa {provider} ni bilo mogoče povezati"
    },
    "membersAvailability": {
      "notFound": "Člana ni mogoče najti"
    },
    "membersMembers": {
      "errorNotResent": "Povabila ni bilo mogoče znova poslati. Poskusite znova.",
      "errorNotWithdrawn": "Povabila ni bilo mogoče preklicati. Poskusite znova.",
      "resent": "Povabilo znova poslano na {email}",
      "withdrawn": "Povabilo preklicano"
    },
    "connectRefusal": {
      "account_claimed": "Ta račun je povezan z drugo nastanitvijo, zato ga tukaj ni mogoče povezati.",
      "contactSupport": "Pišite podpori",
      "number_claimed": "Ta številka je povezana z drugo nastanitvijo, zato je tukaj ni mogoče povezati.",
      "numberClaimedBy": "Ta številka je povezana z nastanitvijo {property}, zato je tukaj ni mogoče povezati.",
      "property_preparing": "Ta nastanitev je v pripravi, zato še ni mogoče ničesar povezati. Povezovanje bi lahko prevzelo storitev, ki jo zdaj opravlja vaš trenutni sistem.",
      "setup_broken": "Nastavitve te povezave v aplikaciji ni mogoče dokončati. Ekipa Vidimo lahko to uredi.",
      "subscription_required": "Za povezavo kanala potrebujete aktivno naročnino."
    },
    "messagingCards": {
      "addressCopied": "Naslov kopiran",
      "checking": "Preverjanje …",
      "codeAccepted": "Koda sprejeta. Dokončujemo povezavo.",
      "codeHint": "WhatsApp jo pošlje v SMS-u ali s samodejnim klicem. Do prejema lahko mineta minuta ali dve.",
      "codeLabel": "Vnesite kodo, ki vam jo je poslal WhatsApp",
      "codeLabelSentTo": "Vnesite kodo, poslano na {e164}",
      "comingSoon": "Kmalu",
      "connectFailed": "Povezava ni uspela. Poskusite znova.",
      "connectInstagram": "Povežite Instagram",
      "connectWhatsApp": "Povežite WhatsApp",
      "copyEmailAddress": "Kopirajte e-poštni naslov",
      "disconnectInstagramDescription": "Nova neposredna sporočila ne bodo več prihajala v Vidimo, račun pa bo sproščen, da ga lahko znova povežete tukaj ali pri drugi nastanitvi. Obstoječi pogovori ostanejo v Klepetih.",
      "disconnectWhatsAppDescription": "Sporočila gostov na to številko ne bodo več prihajala v Vidimo. Obstoječi pogovori ostanejo v Klepetih.",
      "emailDescription": "Gostje lahko pišejo na ta naslov. Odgovori pristanejo tukaj v Klepetih: brez nastavljanja, brez posredovanja.",
      "errorCode": "Ta koda ni delovala. Preverite jo in poskusite znova.",
      "errorConnectInstagram": "Povezovanja z Instagramom ni bilo mogoče začeti",
      "errorCopyAddress": "Naslova ni bilo mogoče kopirati",
      "errorLinkPhone": "Številke ni bilo mogoče povezati. Poskusite znova.",
      "errorOpenManagement": "Upravljanja WhatsApp ni bilo mogoče odpreti. Poskusite znova.",
      "errorReachWhatsApp": "WhatsApp ni dosegljiv. Čez trenutek poskusite znova.",
      "errorStartConnection": "Povezovanja ni bilo mogoče začeti. Poskusite znova.",
      "instagramConnected": "Vir in neposredna sporočila so povezani.",
      "instagramPitch": "Pokažite svoj vir in odgovarjajte na neposredna sporočila iz nabiralnika.",
      "instagramReplyRule": "Instagram vam dovoli odgovoriti šele, ko vam gost piše prvi.",
      "linkPhone": "Povežite telefon",
      "linking": "Povezovanje …",
      "manageWhatsApp": "Upravljajte v WhatsApp Business",
      "number": "Številka: <number>{e164}</number>",
      "numberConnected": "Povezana številka: <number>{e164}</number>",
      "numberConnecting": "Povezovanje številke: <number>{e164}</number>",
      "opening": "Odpiranje …",
      "phoneLinked": "Telefonska številka povezana",
      "phoneNumberLabel": "Telefonska številka (E.164)",
      "phoneSubtitle": "Klici in SMS prek Twilia za to nastanitev",
      "reconnectInstagram": "Znova povežite Instagram",
      "reconnecting": "Ponovno povezovanje …",
      "retryConnection": "Znova poskusite povezati",
      "senderOffline": {
        "displayNameRejected": "WhatsApp ni odobril prikaznega imena za to številko. V WhatsApp Managerju izberite drugo ime in znova poskusite povezati.",
        "numberReassigned": "Ta številka je zdaj registrirana pri drugem računu WhatsApp, zato sporočila gostov ne prihajajo več v to nastanitev.",
        "numberRemoved": "Ta številka je bila odstranjena iz WhatsApp Business. Znova poskusite povezati, da jo ponovno nastavite.",
        "policyRestricted": "WhatsApp je to številko omejil zaradi kršitve poslovnih pravil. Kaj morate popraviti, preverite v WhatsApp Managerju.",
        "unrecognised": "WhatsApp je to številko izklopil. Znova poskusite povezati, da jo ponovno nastavite, ali podrobnosti preverite v WhatsApp Managerju."
      },
      "statusActionNeeded": "Potrebno ukrepanje",
      "statusActive": "Aktivno",
      "statusConnected": "Povezano",
      "submit": "Pošljite",
      "twilioSidLabel": "SID številke Twilio (neobvezno)",
      "update": "Posodobite",
      "whatsAppEmpty": "Povežite številko WhatsApp Business, da boste v tej nastanitvi prejemali sporočila gostov.",
      "whatsAppNumberHeld": "WhatsApp to številko še zadržuje. Prekinite povezavo in jo nato znova povežite.",
      "whatsAppNumberHint": "Ko se odpre registracija pri Meti, vnesite isto številko.",
      "whatsAppNumberLabel": "Številka WhatsApp",
      "whatsAppReconnected": "WhatsApp je znova povezan",
      "whatsAppSettingUp": "Običajno nekaj minut. Ta zaslon lahko zapustite: postopek se konča sam.",
      "whatsAppSettingUpTitle": "Nastavljanje številke v WhatsAppu",
      "whatsAppSubtitle": "Sporočila gostov na lastno številko nastanitve",
      "whatsAppUnavailable": "Povezovanje WhatsAppa v tem okolju ni na voljo."
    },
    "municipalitySection": {
      "countryPending": "Država nastanitve se je pravkar spremenila. Občine te države se bodo prikazale tukaj, ko bo Vidimo prejel spremembo.",
      "loadFailed": "Občine ni bilo mogoče naložiti. Preverite povezavo.",
      "noCountry": "Najprej v razdelku <link>Splošno</link> dodajte naslov in državo nastanitve.",
      "noMatch": "Ni ustreznih občin",
      "notListed": "Vidimo seznama občin za to državo še nima.",
      "pickFailed": "Občine ni bilo mogoče shraniti. Poskusite znova.",
      "placeholder": "Izberite svojo občino",
      "retired": "Te občine ni več na uradnem seznamu. Izberite občino, ki jo je nadomestila.",
      "retry": "Poskusite znova",
      "searchFailed": "Iskanje ni uspelo. Preverite povezavo.",
      "searchLabel": "Iščite občine",
      "searching": "Iskanje …",
      "source": "{method, select, host {Izbrali ste sami} address_register {Glede na vaš naslov} other {Nastavljeno za to nastanitev}}",
      "title": "Občina",
      "typeToSearch": "Za iskanje vnesite ime"
    },
    "notificationsView": {
      "complianceDescription": "Prijave gostov, ki jih Vidimo ne oddaja, in tiste, ki se bližajo zakonskemu roku za oddajo",
      "complianceLabel": "Roki za prijavo gostov",
      "messagesDescription": "Nova sporočila gostov in ekipe",
      "messagesLabel": "Sporočila",
      "reservationsDescription": "Prihodi gostov, odpovedi in potekle blokade na karticah",
      "reservationsLabel": "Rezervacije",
      "title": "Obvestila"
    },
    "operationalState": {
      "badge": "V pripravi",
      "blocked": "Ta nastanitev je v pripravi, zato je Vidimo še ne upravlja. Njene rezervacije in goste še vedno ureja vaš trenutni sistem.",
      "description": "Še vedno jo upravlja vaš trenutni sistem. Nastavite jo in se prosto razglejte: nič, kar storite tukaj, še ne doseže gostov, kanalov ali pristojnih organov.",
      "importBookings": "Uvozite rezervacije",
      "noConnections": "Kanalov, WhatsAppa, Instagrama in telefonskih številk ni mogoče povezati.",
      "noFilings": "Prijave gostov in statistična poročila se ne oddajajo.",
      "noGuestContact": "Gostje ne prejemajo sporočil, povezav za prijavo ali zahtev za plačilo.",
      "noReservations": "Rezervacij ni mogoče ustvariti, spremeniti ali odpovedati.",
      "privateWebsite": "Vaša spletna stran in stran za rezervacije ostaneta zasebni.",
      "title": "Ta nastanitev je v pripravi"
    },
    "parkingEditor": {
      "addParking": "Dodajte parkirišče",
      "addPhotos": "Dodajte fotografije",
      "cancel": "Prekličite",
      "checkOnMap": "Preverite na zemljevidu",
      "delete": "Izbrišite to parkirišče",
      "directionsLabel": "Navodila",
      "directionsPlaceholder": "Uvoz s Slovenske ceste. Pri zapornici vzemite listek, potrdimo ga na recepciji.",
      "errorUpload": "Te fotografije ni bilo mogoče naložiti.",
      "linkErrorNoLocation": "V tej povezavi ni bilo mogoče najti lokacije. V Google Zemljevidih postavite žebljiček na mesto, tapnite Deli in povezavo prilepite sem.",
      "linkErrorNotGoogle": "Tukaj delujejo le povezave Google Zemljevidov. Mesto odprite v Google Zemljevidih, tapnite Deli in prilepite povezavo.",
      "linkErrorTooLong": "{count, plural, one {Ta povezava je predolga za shranjevanje (več kot {count} znak). Raje postavite žebljiček v Google Zemljevidih in ga delite.} two {Ta povezava je predolga za shranjevanje (več kot {count} znaka). Raje postavite žebljiček v Google Zemljevidih in ga delite.} few {Ta povezava je predolga za shranjevanje (več kot {count} znaki). Raje postavite žebljiček v Google Zemljevidih in ga delite.} other {Ta povezava je predolga za shranjevanje (več kot {count} znakov). Raje postavite žebljiček v Google Zemljevidih in ga delite.}}",
      "linkErrorUnreadable": "Te povezave ni bilo mogoče prebrati. Preverite povezavo z internetom in poskusite znova.",
      "locationLabel": "Lokacija",
      "mapsLinkHint": "Za mesto brez naslova postavite žebljiček v Google Zemljevidih in prilepite njegovo povezavo. Neobvezno: pustite prazno, če navodila povedo vse.",
      "mapsLinkLabel": "Povezava Google Zemljevidov",
      "mapsLinkPlaceholder": "Ali prilepite povezavo Google Zemljevidov",
      "nameLabel": "Ime",
      "namePlaceholder": "Garažna hiša na Kongresnem trgu",
      "photoAlt": "Parkirišče {number}",
      "photosHint": "{count, plural, one {Uvoz, zapornica ali parkirno mesto: do # fotografija. Delujejo tudi posnetki zaslona.} two {Uvoz, zapornica ali parkirno mesto: do # fotografiji. Delujejo tudi posnetki zaslona.} few {Uvoz, zapornica ali parkirno mesto: do # fotografije. Delujejo tudi posnetki zaslona.} other {Uvoz, zapornica ali parkirno mesto: do # fotografij. Delujejo tudi posnetki zaslona.}}",
      "photosLabel": "Fotografije",
      "pinnedAt": "Označeno na {latitude}, {longitude}",
      "removeLocation": "Odstranite lokacijo",
      "removePhoto": "Odstranite fotografijo {number}",
      "save": "Shranite",
      "searchAddress": "Poiščite naslov",
      "searchDifferentAddress": "Poiščite drug naslov",
      "uploading": "Nalaganje …",
      "useLink": "Uporabite povezavo"
    },
    "parkingEditorPage": {
      "deleted": "{label} izbrisano.",
      "deleting": "Brisanje …",
      "errorDelete": "Parkirišča ni bilo mogoče izbrisati. Poskusite znova.",
      "errorRestore": "Parkirišča ni bilo mogoče obnoviti. Dodajte ga znova.",
      "errorSave": "Parkirišča ni bilo mogoče shraniti. Poskusite znova.",
      "newTitle": "Novo parkirišče",
      "notFound": "To parkirišče je bilo izbrisano ali nikoli ni obstajalo.",
      "saved": "Parkirišče shranjeno.",
      "title": "Parkirišče",
      "undo": "Razveljavite"
    },
    "parkingPage": {
      "add": "Dodajte parkirišče",
      "emptyDescription": "Dodajte garažo, ulico ali parkirni prostor, ki ga uporabljajo gostje, z navodili in fotografijo uvoza.",
      "emptyTitle": "Še ni parkirišč",
      "errorReorder": "Vrstnega reda ni bilo mogoče spremeniti. Poskusite znova.",
      "intro": "Povejte gostom, kje naj pustijo avto. To vidijo pred prihodom, da lahko načrtujejo pot, in ves čas bivanja.",
      "loading": "Nalaganje parkirišč …",
      "moveDown": "Premaknite {label} navzdol",
      "moveUp": "Premaknite {label} navzgor",
      "photoCount": "{count, plural, one {{count} fotografija} two {{count} fotografiji} few {{count} fotografije} other {{count} fotografij}}",
      "pinnedLocation": "Označena lokacija",
      "title": "Parkiranje"
    },
    "passwordDialog": {
      "cancel": "Prekličite",
      "changeDescription": "Vnesite trenutno geslo, nato izberite novo. Tukaj ostanete vpisani, v drugih napravah pa boste izpisani.",
      "changeSubmit": "Spremenite geslo",
      "changeTitle": "Sprememba gesla",
      "confirmPasswordLabel": "Potrdite novo geslo",
      "confirmPasswordPlaceholder": "Znova vnesite geslo",
      "currentPasswordLabel": "Trenutno geslo",
      "errorCurrentRequired": "Vnesite trenutno geslo",
      "errorMismatch": "Gesli se ne ujemata",
      "errorNotSaved": "Gesla ni bilo mogoče shraniti. Poskusite znova.",
      "errorTooShort": "Geslo mora imeti vsaj {count, plural, one {# znak} two {# znaka} few {# znake} other {# znakov}}",
      "newPasswordLabel": "Novo geslo",
      "newPasswordPlaceholder": "Najmanj {count, plural, one {# znak} two {# znaka} few {# znaki} other {# znakov}}",
      "setDescription": "Izberite geslo, da se boste lahko vpisali tudi z e-poštnim naslovom. Obstoječi načini vpisa še naprej delujejo.",
      "setSubmit": "Nastavite geslo",
      "setTitle": "Nastavitev gesla",
      "submitPending": "Shranjevanje …"
    },
    "paymentsCard": {
      "statusActionNeeded": "Potrebno ukrepanje",
      "statusConnected": "Povezano",
      "statusDisabled": "Onemogočeno",
      "statusNotConnected": "Ni povezano",
      "statusOff": "Izklopljeno",
      "statusSetupUnfinished": "Nastavitev ni končana",
      "subtitle": "Plačila gostov s kartico prek vašega računa Stripe",
      "subtitleSettles": "Stripe · poravnava v {currency}",
      "subtitleSettlesAccountCurrency": "Stripe · poravnava v valuti vašega računa",
      "title": "Plačila s kartico"
    },
    "paymentsPage": {
      "title": "Plačila"
    },
    "paymentsView": {
      "checkAgain": "Preverite znova",
      "checkingWithStripe": "Preverjanje pri Stripu",
      "connectStripe": "Povežite račun Stripe",
      "continueStripeSetup": "Nadaljujte nastavitev Stripa",
      "depositChargeBody": "Denar prejmete vnaprej. Pristane v vašem stanju Stripe, vrnitev pa je vračilo.",
      "depositChargeLabel": "Bremenite",
      "depositHoldBody": "Znesek se blokira na gostovi kartici, ne da bi ga bremenili. Unovčite, kar potrebujete, preostanek pa sprostite. Blokade potečejo po približno 7 dneh.",
      "depositHoldLabel": "Blokirajte na kartici",
      "depositsTitle": "Predplačila",
      "description": "Plačila gostov s kartico prejemajte prek lastnega računa Stripe. Denar gre naravnost vam, Vidimo ne vzame provizije.",
      "errorLoad": "Nastavitev ni bilo mogoče naložiti",
      "errorOpenStripe": "Stripa ni bilo mogoče odpreti",
      "errorReachStripe": "Stripe ni dosegljiv",
      "errorSave": "Shranjevanje ni uspelo",
      "finishingSetup": "Dokončevanje nastavitve pri Stripu. To običajno traja nekaj sekund.",
      "loadFailed": "Nastavitev plačil ni bilo mogoče naložiti. Vaš račun Stripe in že prejeta plačila ostanejo nespremenjeni.",
      "offHint": "Pustite izklopljeno, če želite plačila še naprej evidentirati ročno kot doslej.",
      "openStripe": "Odprite Stripe",
      "payoutsEnabled": "Izplačila so omogočena.",
      "payoutsEnabledSettles": "Izplačila so omogočena. Poravnava v {currency}.",
      "payoutsNotEnabled": "Izplačila še niso omogočena.",
      "payoutsNotEnabledSettles": "Izplačila še niso omogočena. Poravnava v {currency}.",
      "statusActive": "Pripravljeno za plačila",
      "statusDisabled": "Onemogočil Stripe",
      "statusNotStarted": "Ni povezano",
      "statusPending": "Nastavitev ni končana",
      "statusRestricted": "Potrebno ukrepanje",
      "stripeAccount": "Račun Stripe",
      "stripeDashboardHint": "Vračila, izplačila in spore urejate na lastni nadzorni plošči Stripe.",
      "title": "Plačila s kartico",
      "tryAgain": "Poskusite znova",
      "unavailable": "Plačila s kartico v tem okolju še niso na voljo."
    },
    "propertyActivityView": {
      "emptyDescription": "Spremembe cen, rezervacij, nalog in gostov bodo prikazane tukaj, ko se zgodijo.",
      "emptyTitle": "Še nič",
      "errorLoad": "Dejavnosti ni bilo mogoče prebrati. Povlecite navzdol in poskusite znova.",
      "intro": "Kdo je tukaj spremenil cene, rezervacije, naloge in goste ter kdaj. Pri spremembah cen piše, ali so jih vaši kanali sprejeli.",
      "loading": "Nalaganje …",
      "noPropertyDescription": "Izberite nastanitev, da vidite njeno dejavnost.",
      "noPropertyTitle": "Nobena nastanitev ni izbrana",
      "ratesChanged": "Spremenjene cene ali pravila za {nights}",
      "ratesChangedSpan": "Spremenjene cene ali pravila za {nights}, {span}",
      "title": "Dejavnost",
      "unitsFreeUpdated": "Posodobljeno število prostih enot za {nights}",
      "unitsFreeUpdatedSpan": "Posodobljeno število prostih enot za {nights}, {span}"
    },
    "propertyBlocksView": {
      "emptyDescription": "Nič ni umaknjeno iz prodaje. Za zaprtje datumov zgoraj dodajte zaprtje.",
      "emptyTitle": "Ni zaprtih datumov",
      "errorAdd": "Zaprtja ni bilo mogoče dodati. Poskusite znova.",
      "errorRemoveRolledBack": "Zaprtja ni bilo mogoče odstraniti. Spet je aktivno.",
      "everyUnitType": "Vse enote vrste {unitType}",
      "firstNight": "Prva noč",
      "fromSource": "· vir: {source}",
      "intro": "Noči umaknite iz prodaje brez rezervacije: za bivanje lastnika, vzdrževanje ali ročno zaprtje. Zaprte noči se ne prodajajo več tukaj in na povezanih kanalih.",
      "lastNight": "Zadnja noč",
      "noPropertyDescription": "Izberite nastanitev, da upravljate njene zaprte datume.",
      "noPropertyTitle": "Nobena nastanitev ni izbrana",
      "reason": "Razlog",
      "removeBlock": "Odstranite zaprtje od {firstNight}",
      "submit": "Zaprite datume",
      "targetLabel": "Kaj zapreti",
      "targetPlaceholder": "Izberite enoto ali vrsto enote",
      "title": "Zaprti datumi",
      "unknownUnit": "Neznana enota"
    },
    "propertyColorPicker": {
      "customPlaceholder": "#RRGGBB (po meri)",
      "hint": "Vizualna oznaka, s katero je ta nastanitev prepoznavna v vsej aplikaciji. Pustite prazno, da se iz ID-ja nastanitve samodejno izbere stalna barva.",
      "label": "Barva",
      "reset": "Ponastavite na samodejno",
      "swatchLabel": "Nastavite barvo {color}"
    },
    "propertyEmailsView": {
      "bookingConfirmationDescription": "Pošlje se, ko gost rezervira in plača na vaši spletni strani. Rezervacije, ki pridejo prek kanala, potrdi kanal, ne mi.",
      "bookingConfirmationLabel": "Potrditev rezervacije",
      "checkInInviteDescription": "Pošlje se enkrat, ko prispe rezervacija, in gosta povabi k spletni prijavi. Če to izklopite, pred prihodom ne boste prejeli niti podatkov o gostih, ki jih potrebujete za prijavo gostov.",
      "checkInInviteLabel": "Povabilo k prijavi",
      "errorNotLoaded": "Nastavitev e-pošte ni bilo mogoče naložiti",
      "errorNotSaved": "Tega ni bilo mogoče shraniti. Poskusite znova.",
      "errorPreviewNotLoaded": "Predogleda ni bilo mogoče naložiti",
      "intro": "Ta sporočila se gostom pošljejo samodejno z lastnega naslova nastanitve, da odgovor pride do vas v Klepete. Tapnite Predogled pri katerem koli, da preberete, kaj prejme gost.",
      "paymentsNeeded": "Še ni ničesar za pošiljanje: to sporočilo se pošlje, ko gost plača na vaši spletni strani, za kar morate najprej nastaviti <link>plačila s kartico</link>.",
      "preview": "Predogled",
      "signInLinkNote": "Gostje lahko zahtevajo tudi povezavo za vpis v svoje bivanje. Ker gost s tem želi dostop do lastne rezervacije, se vedno pošlje. Kar sami napišete v Klepetih, se pošlje, ko to pošljete.",
      "title": "E-pošta gostom"
    },
    "propertyForm": {
      "avatarFallbackName": "Nastanitev",
      "cancel": "Prekličite",
      "confirmPhrase": "izbriši",
      "deleteDescription": "Trajno odstranite to nastanitev in vse z njo povezane podatke (enote, rezervacije, naloge). Tega dejanja ni mogoče razveljaviti.",
      "deleteTitle": "Izbris nastanitve",
      "descriptionHint": "Ta opis bodo videli gostje in uporabniki",
      "descriptionLabel": "Opis",
      "descriptionPlaceholder": "Opišite to nastanitev",
      "errorNotSaved": "Nastanitve ni bilo mogoče shraniti. Poskusite znova.",
      "imageCaption": "Tapnite, da zamenjate sliko nastanitve",
      "nameLabel": "Ime nastanitve",
      "namePlaceholder": "Vnesite ime nastanitve",
      "readOnlyNotice": "Ta nastanitev nima aktivne naročnine, zato njenih podatkov ni mogoče spreminjati.",
      "save": "Shranite",
      "shortCodeHintAuto": "Samodejno izpolnjeno iz imena nastanitve. Vnesite svojo kodo ali polje počistite, da se znova izpolnjuje samodejno.",
      "shortCodeHintManual": "Uporablja se kot kratka oznaka v koledarjih in značkah. Počistite polje, da bo samodejno sledilo imenu nastanitve.",
      "shortCodeLabel": "Kratka koda",
      "subtitle": "Upravljajte podatke in celostno podobo nastanitve",
      "title": "Splošno"
    },
    "propertyIntegrationsView": {
      "communicationSubtitle": "Kanali za nastanitev {name}",
      "communicationTitle": "Komunikacija z gosti",
      "distributionSubtitle": "Kje {name} sprejema rezervacije",
      "distributionTitle": "Prodajni kanali",
      "loading": "Nalaganje …",
      "paymentsSubtitle": "Kako {name} prejema plačila",
      "paymentsTitle": "Plačila"
    },
    "propertyMembersView": {
      "cancelInvitation": "Prekličite povabilo",
      "codeCopied": "Koda povabila kopirana",
      "copyCode": "Kopirajte kodo povabila",
      "errorCodeNotCopied": "Kopiranje ni uspelo: označite kodo in jo kopirajte ročno.",
      "invite": "Povabite",
      "invitedAs": "Povabljen kot: {role}",
      "memberCount": "{count, plural, one {# član} two {# člana} few {# člani} other {# članov}}",
      "moreActions": "Več dejanj",
      "noMatches": "Iskanju ne ustreza noben član.",
      "pendingInvitations": "Čakajoča povabila",
      "removeConfirm": "Želite odstraniti {name} iz nastanitve {property}?",
      "removeFromProperty": "Odstranite iz nastanitve",
      "resend": "Pošljite znova",
      "searchPlaceholder": "Iščite člane …",
      "title": "Člani"
    },
    "propertyNotFound": {
      "notFound": "Nastanitve ni mogoče najti",
      "syncing": "Sinhroniziranje nastanitve …"
    },
    "propertyPhotosView": {
      "addPhotos": "Dodajte fotografije",
      "added": "{count, plural, one {Fotografija dodana} two {# fotografiji dodani} few {# fotografije dodane} other {# fotografij dodanih}}",
      "addedSome": "{total, plural, one {Dodano {added} od # fotografije.} two {Dodano {added} od # fotografij.} few {Dodano {added} od # fotografij.} other {Dodano {added} od # fotografij.}}",
      "addedSomeWithReason": "{total, plural, one {Dodano {added} od # fotografije. {reason}} two {Dodano {added} od # fotografij. {reason}} few {Dodano {added} od # fotografij. {reason}} other {Dodano {added} od # fotografij. {reason}}}",
      "descriptionHint": "Bralniki zaslona ga preberejo na glas, iskalniki pa za to sliko dobijo samo to besedilo.",
      "descriptionLabel": "Opis",
      "descriptionPlaceholder": "npr. Terasa ob mraku",
      "emptyDescription": "Dodajte fotografije nastanitve in sob. Dokler jih ne dodate, vaša javna stran ne bo v rezultatih iskanja.",
      "emptyTitle": "Še ni fotografij",
      "errorDescriptionNotSaved": "Opisa ni bilo mogoče shraniti",
      "errorNotAdded": "Fotografije ni bilo mogoče dodati",
      "errorNotMoved": "Fotografije ni bilo mogoče premakniti",
      "errorNotRemoved": "Fotografije ni bilo mogoče odstraniti",
      "errorNotReordered": "Vrstnega reda fotografij ni bilo mogoče spremeniti",
      "intro": "Prikazane so na javni strani nastanitve. Prva fotografija je na začetku galerije in se uporabi pri deljenju strani.",
      "mainGallery": "Glavna galerija",
      "moveEarlier": "Premaknite naprej",
      "moveLater": "Premaknite nazaj",
      "removePhoto": "Odstranite fotografijo",
      "removed": "Fotografija odstranjena",
      "showsOn": "Prikazano na",
      "title": "Fotografije",
      "uploading": "Nalaganje …"
    },
    "propertyRatesView": {
      "addSeason": "Dodajte sezono",
      "basePerNight": "Osnovna / noč",
      "cancel": "Prekličite",
      "editSeason": "Uredite sezono {name}",
      "editingSeason": "Urejanje sezone »{name}«",
      "ensureFailedDescription": "Cenikov ni bilo mogoče ustvariti. Preverite povezavo in poskusite znova.",
      "ensureFailedTitle": "Cen ni bilo mogoče nastaviti",
      "errorBaseRateRolledBack": "Cene na noč ni bilo mogoče shraniti. Poskusite znova.",
      "errorFloorRolledBack": "Najnižje cene ni bilo mogoče shraniti. Poskusite znova.",
      "errorRemoveSeasonRolledBack": "Sezone ni bilo mogoče odstraniti. Spet je tukaj.",
      "errorSaveSeason": "Sezone ni bilo mogoče shraniti. Poskusite znova.",
      "firstNight": "Prva noč",
      "floorHint": "Nobena noč, sezona ali osnovna cena ne more biti nižja.",
      "floorLabel": "Najnižja cena",
      "floorOwnerOnly": "Spremeni jo lahko le lastnik.",
      "intro": "Nastavite osnovno ceno za vsako vrsto enote, za posamezna obdobja pa določite sezonske cene. Spremembe se sinhronizirajo s povezanimi kanali.",
      "lastNight": "Zadnja noč",
      "minStay": "Najkrajše bivanje",
      "minStayPlaceholder": "Poljubno",
      "noFloor": "Najnižja cena ni nastavljena",
      "noSeasons": "Ni sezon. Za noči velja zgornja osnovna cena.",
      "noUnitsDescription": "Preden nastavite cene, tej nastanitvi dodajte enote.",
      "noUnitsTitle": "Še ni enot",
      "none": "Brez",
      "notSet": "Ni nastavljeno",
      "occupancyReduction": "Znižanje na gosta pod zmogljivostjo",
      "occupancyReductionHint": "Odšteje se od cene na noč za vsakega gosta pod zmogljivostjo vrste enote. Samo za neposredne rezervacije; na kanalih se prodaja po polni ceni.",
      "openRates": "Oglejte si in spremenite cene na noč",
      "pricePerNight": "Cena / noč",
      "pricePlaceholder": "Osnovna",
      "priority": "Prednost",
      "removeSeason": "Odstranite sezono {name}",
      "saveChanges": "Shranite spremembe",
      "savedFloor": "Shranjeno: {amount}",
      "savedNoFloor": "Shranjeno: brez najnižje cene",
      "seasonBaseRate": "osnovna cena",
      "seasonDates": "{start}–{end}",
      "seasonLabel": "Sezona",
      "seasonMinStay": "{count, plural, one {· najmanj {count} noč} two {· najmanj {count} noči} few {· najmanj {count} noči} other {· najmanj {count} noči}}",
      "seasonOccupancyReduction": "· −{amount} na gosta pod zmogljivostjo (neposredno)",
      "seasonPlaceholder": "Poletje 2027",
      "seasonPriority": "· prednost {priority}",
      "seasonShortStaySurcharge": "{count, plural, one {· +{amount} za bivanje, krajše od {count} noči (neposredno)} two {· +{amount} za bivanje, krajše od {count} noči (neposredno)} few {· +{amount} za bivanje, krajše od {count} noči (neposredno)} other {· +{amount} za bivanje, krajše od {count} noči (neposredno)}}",
      "seasonsHeading": "Sezone",
      "seasonsPriorityHint": "Kjer se obdobja prekrivajo, velja najvišja prednost",
      "settingUp": "Nastavljanje …",
      "shortStayPlaceholder": "noči",
      "shortStayUnder": "Kratko bivanje pod",
      "surcharge": "Doplačilo",
      "surchargeHint": "Doda se bivanju, ki je krajše od zgornjega števila noči. Samo za neposredne rezervacije: kanali poznajo le eno enotno ceno na noč in tega ne morejo izraziti.",
      "title": "Cene",
      "tryAgain": "Poskusite znova"
    },
    "propertyRegistrationView": {
      "asksBeforeSubmitting": "Vaši dostopni podatki ostanejo shranjeni. Vidimo vas bo vprašal, preden z njimi karkoli odda.",
      "checkAgainAfter": "Znova lahko preverite po {time}.",
      "checkBusy": "Preverjanje že poteka.",
      "checkFailed": "Preverjanja ni bilo mogoče izvesti. Poskusite znova.",
      "checkNow": "Preverite zdaj",
      "checkRefused": "Ti dostopni podatki so bili zavrnjeni. Za ponovno preverjanje jih posodobite.",
      "checkTooOften": "Preverjeno prepogosto. Poskusite pozneje.",
      "checking": "Preverjanje …",
      "confirmDisconnect": "Želite odklopiti te dostopne podatke? Odstranili jih bomo iz vašega računa.",
      "confirmDisconnectChecked": "Želite odklopiti te dostopne podatke? Odstranili jih bomo iz vašega računa in jih nehali preverjati.",
      "confirmDisconnectFiling": "Želite odklopiti te dostopne podatke? Oddajanje v ta sistem bomo ustavili, dokler jih znova ne vnesete.",
      "confirmDisconnectWaiting": "Želite odklopiti te dostopne podatke? Odstranili jih bomo iz vašega računa, nastavitev pa se ne bo znova odprla, dokler samodejna oddaja ne bo pripravljena.",
      "connectToCheck": "Povežite za preverjanje",
      "connectToCheckLine": "Povežite račun zdaj in Vidimo bo preveril, ali deluje. Preverjanje ničesar ne odda.",
      "credentialsDisconnected": "Dostopni podatki odklopljeni",
      "credentialsStay": "Vaši dostopni podatki ostanejo shranjeni in z oddajanjem bomo začeli, ko bo pripravljeno.",
      "disconnect": "Odklopite",
      "disconnecting": "Odklapljanje …",
      "errorDisconnect": "Odklop ni uspel. Poskusite znova.",
      "errorLoadCredentials": "Dostopnih podatkov ni bilo mogoče naložiti. Poskusite znova.",
      "fileEachGuestYourself": "Vsakega gosta pred iztekom roka prijavite sami.",
      "filesFrom": "Vidimo prijavlja goste, ki prispejo od {date} naprej. Goste, ki so prispeli prej in jih Vidimo ni prijavil, prijavite sami.",
      "inPreparationConnector": "Vidimo pripravlja vaša poročila za sistem {system}. Samodejno oddajanje je še v razvoju.",
      "onFileSecret": "{label}: ••••",
      "onFileValue": "{label}: {value}",
      "setUp": "Nastavite",
      "setupOpensLater": "Nastavitev dostopnih podatkov se bo odprla tukaj, ko bo to pripravljeno.",
      "statusConnected": "Povezano",
      "statusInPreparation": "V razvoju",
      "statusNeedsAttention": "Zahteva pozornost",
      "statusNotConnected": "Ni povezano",
      "updateCredentials": "Posodobite dostopne podatke"
    },
    "propertySettingsView": {
      "activityDescription": "Kdo je spremenil cene in rezervacije ter kdaj",
      "activityTitle": "Dejavnost",
      "blockedDatesDescription": "Umaknite noči iz prodaje zaradi bivanja lastnika, vzdrževanja ali ročnega zaprtja",
      "blockedDatesTitle": "Zaprti datumi",
      "breakfastDescription": "Ure, cena in kje se streže",
      "breakfastTitle": "Zajtrk",
      "cleaningDescription": "Komu gre vsaka naloga čiščenja in s katerimi koraki se začne",
      "cleaningTitle": "Čiščenje",
      "complianceDescription": "Prijava gostov, statistika, turistična taksa in knjiga gostov",
      "complianceTitle": "Skladnost",
      "customDomainDescription": "Spletno stran Places objavite na lastni domeni",
      "customDomainTitle": "Lastna domena",
      "generalDescription": "Ime, naslov, opis in podrobnosti",
      "generalTitle": "Splošno",
      "groupAccount": "Račun",
      "groupGuests": "Gostje",
      "groupProperty": "Nastanitev",
      "guestEmailsDescription": "Kaj gostom samodejno pošiljamo po e-pošti in s katerega naslova",
      "guestEmailsTitle": "E-pošta gostom",
      "guestPortalDescription": "Kaj gostje berejo na strani svojega bivanja, s predogledom: dostop, hišni red, WiFi",
      "guestPortalTitle": "Portal za goste",
      "guestPreviewDescription": "Oglejte si stran bivanja, kot jo vidi gost: pred prihodom, med bivanjem in po odhodu",
      "guestPreviewTitle": "Predogled kot gost",
      "guestRegistryDescription": "Uradna evidenca o tem, kdo je bival pri vas, z izvozom CSV",
      "guestRegistryTitle": "Knjiga gostov",
      "importsDescription": "Rezervacije, ki jih je aplikacija AI kopirala iz vašega trenutnega sistema, preverjene z njegovimi seštevki, kjer jih ta prikazuje",
      "importsTitle": "Uvožene rezervacije",
      "membersDescription": "Upravljajte, kdo ima dostop do te nastanitve",
      "membersTitle": "Člani",
      "messagingDescription": "Kanali, prek katerih vas gostje dosežejo, in e-pošta, ki jo pošiljamo v vašem imenu",
      "messagingTitle": "Sporočanje",
      "notFoundTitle": "Nastanitev",
      "parkingDescription": "Kje gostje parkirajo, prikazano pred bivanjem in med njim",
      "parkingTitle": "Parkiranje",
      "photosDescription": "Fotografije na javni strani nastanitve",
      "photosTitle": "Fotografije",
      "pricingDescription": "Cene na noč, najkrajše bivanje in zaprte noči za vaše enote",
      "pricingTitle": "Cene",
      "roomsDescription": "Enote, cene, zaprte noči in kanali, s katerimi se sinhronizirajo",
      "roomsTitle": "Sobe in cene",
      "sectionExtras": "Dodatki",
      "sectionHousekeeping": "Urejanje sob",
      "sectionInventory": "Kaj prodajate",
      "sectionMoving": "Prehod na Vidimo",
      "sectionPeople": "Ljudje",
      "sectionPublicPage": "Javna stran",
      "sectionRecords": "Evidence",
      "sectionSentAutomatically": "Samodejno pošiljanje",
      "sectionStayPage": "Stran bivanja",
      "siteDescription": "Vaša javna stran: vsebina, fotografije in domena ter plačila s kartico",
      "siteTitle": "Spletna stran",
      "stayDescription": "Vsebina za goste pred bivanjem in med njim, parkiranje in zajtrk",
      "stayTitle": "Bivanje gostov",
      "teamDescription": "Člani, pravila in kontrolni seznami za čiščenje ter kdo je kaj spremenil",
      "teamTitle": "Ekipa",
      "title": "Nastavitve",
      "unitsDescription": "Upravljajte enote in vrste enot",
      "unitsTitle": "Enote",
      "websiteDescription": "Zgodba, poudarki, mnenja in pogosta vprašanja za vašo javno stran",
      "websiteTitle": "Vsebina strani"
    },
    "propertyUnitsView": {
      "clearSearch": "Počistite iskanje",
      "createUnit": "Ustvarite enoto",
      "emptyDescription": "Za začetek ustvarite prvo enoto.",
      "emptyTitle": "Še ni enot",
      "maxGuests": "{count, plural, one {{count} gost} two {{count} gosta} few {{count} gostje} other {{count} gostov}}",
      "noMatchDescription": "Poskusite z drugim iskalnim izrazom ali počistite iskanje.",
      "noMatchTitle": "Iskanju ne ustreza nobena enota",
      "searchPlaceholder": "Iščite enote …",
      "title": "Enote"
    },
    "propertyWebsiteView": {
      "activitiesIntroLabel": "Uvod",
      "activitiesIntroPlaceholder": "Kaj lahko počnete v bližini?",
      "activityBlurbPlaceholder": "Na smaragdni reki",
      "activityTitlePlaceholder": "Kajakaštvo",
      "addActivity": "Dodajte dejavnost",
      "addDistance": "Dodajte razdaljo",
      "addHighlight": "Dodajte poudarek",
      "addQuestion": "Dodajte vprašanje",
      "addReview": "Dodajte mnenje",
      "defaultsToPropertyName": "Privzeto ime nastanitve",
      "enquiryLabel": "Pokažite gumb za povpraševanje prek WhatsAppa",
      "errorImageNotUploaded": "Slike ni bilo mogoče naložiti",
      "errorNotLoaded": "Vsebine spletne strani ni bilo mogoče naložiti",
      "errorNotSaved": "Sprememb ni bilo mogoče shraniti",
      "facebookLabel": "URL Facebook",
      "faqAnswerPlaceholder": "Odgovor",
      "faqQuestionPlaceholder": "Vprašanje",
      "headlineLabel": "Naslov po meri",
      "highlightIconPlaceholder": "Ikona (npr. waves)",
      "highlightLabelPlaceholder": "Bazen",
      "highlightSublabelPlaceholder": "Odprt od maja do novembra",
      "instagramLabel": "Uporabniško ime na Instagramu",
      "instagramPlaceholder": "vashotel",
      "intro": "Vse tukaj je prikazano na javni strani vaše nastanitve. Če razdelek pustite prazen, bo skrit.",
      "loadFailed": "Vsebine spletne strani ni bilo mogoče naložiti.",
      "locationIntroLabel": "Uvod o lokaciji",
      "locationIntroPlaceholder": "Kaj je v bližini, v stavku ali dveh",
      "nearbyLabelPlaceholder": "Mestni trg",
      "nearbyValuePlaceholder": "2 min peš",
      "off": "Izklopljeno",
      "on": "Vklopljeno",
      "remove": "Odstranite",
      "removeImage": "Odstranite sliko",
      "replacePhoto": "Zamenjajte fotografijo",
      "reviewAuthorPlaceholder": "Ime",
      "reviewLocationPlaceholder": "Mesto (neobvezno)",
      "reviewQuotePlaceholder": "Kaj je povedal gost",
      "reviewRatingPlaceholder": "Ocena 1–5",
      "reviewSourcePlaceholder": "TripAdvisor (neobvezno)",
      "saveChanges": "Shranite spremembe",
      "saved": "Spletna stran posodobljena",
      "sectionEnquiries": "Povpraševanja",
      "sectionFaqs": "Pogosta vprašanja",
      "sectionHero": "Naslovni del",
      "sectionHighlights": "Poudarki",
      "sectionLocation": "Lokacija",
      "sectionReviews": "Mnenja",
      "sectionSearch": "Iskanje (SEO)",
      "sectionSocial": "Družbena omrežja",
      "sectionStory": "Zgodba",
      "sectionThingsToDo": "Kaj početi",
      "seoDescriptionLabel": "Metaopis",
      "seoDescriptionPlaceholder": "En ali dva stavka za rezultate iskanja",
      "seoTitleLabel": "Naslov strani po meri",
      "storyImageLabel": "Slika k zgodbi",
      "storyLabel": "Vaša zgodba",
      "storyPlaceholder": "Kako je ta kraj nastal …",
      "taglineLabel": "Slogan",
      "taglinePlaceholder": "Kratek stavek, ki prepriča goste",
      "tiktokLabel": "URL TikTok",
      "title": "Vsebina strani",
      "tryAgain": "Poskusite znova",
      "uploadPhoto": "Naložite fotografijo",
      "viewPublicPage": "Oglejte si javno stran"
    },
    "registrationCards": {
      "comingBody": "Podporo za prijavo gostov in turistično takso v Vidimo uvajamo postopoma, državo za državo. Dokler države vaše nastanitve ne dodamo, ju še naprej urejajte kot doslej. Sporočite nam, da to potrebujete za nastanitev {name}, in obvestili vas bomo, takoj ko bo na voljo.",
      "comingTitle": "Postopoma v več državah",
      "filesGuests": "prijava gostov",
      "filesStatistics": "statistika",
      "filesTouristTax": "turistična taksa",
      "pickMunicipality": "Za nastavitev integracij izberite svojo občino.",
      "registrationSubtitle": "Kako {name} poroča o gostih pristojnim organom",
      "registrationTitle": "Prijava gostov",
      "statisticsNotCovered": "Vidimo za deželo, v kateri je vaša občina, še ne oddaja turistične statistike, zato jo še naprej sami pošiljajte uradu svoje dežele.",
      "statisticsSubtitle": "Statistična poročila o turizmu za nastanitev {name}",
      "statisticsTitle": "Statistika",
      "statusConnected": "Povezano",
      "statusInPreparation": "V razvoju",
      "statusNeedsAttention": "Zahteva pozornost",
      "statusNotConnected": "Ni povezano"
    },
    "registrationCredentialForm": {
      "beforeYouStart": "Preden začnete",
      "checkNotice": "Ko shranite, se Vidimo vpiše v sistem {system} in preveri testni zapis. Preverjanje ničesar ne odda.",
      "checkNoticeAsks": "Ko shranite, se Vidimo vpiše v sistem {system} in preveri testni zapis. Preverjanje ničesar ne odda, Vidimo pa vas bo vprašal, preden odda prijavo katerega koli gosta.",
      "chooseFile": "Izberite datoteko",
      "connect": "Povežite",
      "errorInvalid": "Shranjevanje ni uspelo. Preverite vnesene vrednosti in poskusite znova.",
      "errorPlaceChanged": "Shranjevanje ni uspelo: sistem {system} ni na voljo tam, kjer je zdaj vaša nastanitev. Preverite njeno občino.",
      "errorReadFile": "Te datoteke ni bilo mogoče prebrati.",
      "errorSave": "Dostopnih podatkov ni bilo mogoče shraniti. Poskusite znova.",
      "fileOnFile": "shranjeno",
      "fileOnFileNamed": "{name} shranjeno",
      "noFileSelected": "Nobena datoteka ni izbrana",
      "openAuthority": "Odprite {authority}",
      "replaceFile": "Zamenjajte datoteko",
      "saved": "Dostopni podatki shranjeni",
      "savedAlreadyRefused": "Shranjeno. {system} jih je že zavrnil, zato niso bili znova preverjeni",
      "savedNoAnswer": "Shranjeno. {system} se na preverjanje ni odzval",
      "savedNotChecked": "Shranjeno. Še ni preverjeno",
      "savedRefused": "Shranjeno, vendar jih je {system} zavrnil",
      "savedRefusedAccount": "Shranjeno, vendar je {system} za ta račun zavrnil preverjanje",
      "savedUnreadable": "Shranjeno, vendar jih Vidimo ni mogel prebrati",
      "savedWorks": "Shranjeno. Vaš račun deluje",
      "secretOnFilePlaceholder": "•••••••• shranjeno. Pustite prazno, da ostane.",
      "update": "Posodobite"
    },
    "integrationPage": {
      "changeMunicipality": "Spremenite občino v razdelku Skladnost",
      "deadline": "Rok",
      "deadlineFromArrival": "{hours, plural, one {{hours} h od prihoda} two {{hours} h od prihoda} few {{hours} h od prihoda} other {{hours} h od prihoda}}",
      "deadlineFromArrivalWithDeparture": "{hours, plural, one {{hours} h od prihoda; odda se tudi odjava} two {{hours} h od prihoda; odda se tudi odjava} few {{hours} h od prihoda; odda se tudi odjava} other {{hours} h od prihoda; odda se tudi odjava}}",
      "deadlineShortStay": "{hours, plural, one {{hours} h} two {{hours} h} few {{hours} h} other {{hours} h}}, če bivanje traja {maxStayHours, plural, one {{maxStayHours} h} two {{maxStayHours} h} few {{maxStayHours} h} other {{maxStayHours} h}} ali manj",
      "disconnectAccount": "Prej nastavljeni račun lahko odklopite.",
      "lawRequires": "Kaj zahteva zakon",
      "loginTitle": "Prijava v {system}",
      "municipality": "Občina",
      "noMunicipality": "Izberite občino svoje nastanitve, da bo Vidimo vedel, da tam velja sistem {system}.",
      "notFound": "Integracije ni mogoče najti",
      "notOffered": "Sistem {system} v državi vaše nastanitve ni na voljo. Preverite naslov nastanitve.",
      "notPicked": "Še ni izbrana",
      "pickMunicipality": "Izberite občino v razdelku Skladnost",
      "propertyTitle": "Ta nastanitev v sistemu {system}",
      "regionMoved": "Ti dostopni podatki veljajo za deželo {onFile}, vaša občina pa poroča deželi {current}. Posodobite jih z dostopnimi podatki za deželo {current}.",
      "regionNotCovered": "Vidimo za deželo, v kateri je vaša občina, še ne oddaja statistike.",
      "reportsTo": "Poroča deželi",
      "requiredFields": "Obvezno za vsakega prijavljenega gosta",
      "scopeAllGuests": "Vsi gostje",
      "scopeForeignGuestsOnly": "Samo tuji gostje",
      "setBy": "Določa: <bases></bases>",
      "who": "Kdo"
    },
    "roleSelect": {
      "changeRoleFrom": "Spremenite vlogo: {role}",
      "title": "Sprememba vloge"
    },
    "searchSortBar": {
      "sortAscending": "Razvrščeno A–Ž (tapnite za Ž–A)",
      "sortDescending": "Razvrščeno Ž–A (tapnite za A–Ž)"
    },
    "settingsRowStates": {
      "breakfastOff": "Izklopljeno",
      "breakfastOn": "Vklopljeno",
      "members": "{count, plural, one {# oseba} two {# osebi} few {# osebe} other {# oseb}}",
      "parking": "{count, plural, =0 {Še nobenega} one {# parkirno mesto} two {# parkirni mesti} few {# parkirna mesta} other {# parkirnih mest}}",
      "photos": "{count, plural, =0 {Še nobene} one {# fotografija} two {# fotografiji} few {# fotografije} other {# fotografij}}",
      "units": "{count, plural, =0 {Še nobene} one {# enota} two {# enoti} few {# enote} other {# enot}}"
    },
    "signInMethods": {
      "apple": "Apple",
      "credential": "E-pošta in geslo",
      "google": "Google"
    },
    "signInSecuritySection": {
      "changePassword": "Spremenite geslo",
      "connect": "Povežite",
      "description": "Načini, kako lahko odprete ta račun. Dodajte še enega, da ne boste nikoli zaklenjeni, če ponudnik ni na voljo.",
      "errorLoad": "Načinov vpisa ni bilo mogoče naložiti. Preverite povezavo in poskusite znova.",
      "errorOffline": "Ste brez povezave, zato načinov vpisa trenutno ni mogoče naložiti.",
      "errorPasswordNotChanged": "Gesla ni bilo mogoče spremeniti. Poskusite znova.",
      "errorSessionNotFresh": "Zaradi varnosti se pred odstranitvijo načina vpisa izpišite in znova vpišite.",
      "errorUnlinkFailed": "Tega načina vpisa ni bilo mogoče odstraniti.",
      "errorWrongCurrentPassword": "To ni vaše trenutno geslo. Poskusite znova.",
      "loading": "Nalaganje načinov vpisa …",
      "remove": "Odstranite",
      "retry": "Poskusite znova",
      "setPassword": "Nastavite geslo",
      "statusConnected": "Povezano",
      "statusNoPassword": "Geslo ni nastavljeno",
      "statusNotConnected": "Ni povezano",
      "statusOnlyMethod": "Vaš edini način vpisa",
      "statusPasswordSet": "Geslo nastavljeno",
      "title": "Vpis in varnost"
    },
    "staffAvailabilityForm": {
      "addTimeOff": "Dodajte odsotnost",
      "addWindow": "Dodajte termin",
      "dayLabel": "Dan",
      "endLabel": "Konec <optional>(neobvezno)</optional>",
      "errorTimeOffNotAdded": "Odsotnosti ni bilo mogoče dodati. Poskusite znova.",
      "errorTimeOffNotRemoved": "Odsotnosti ni bilo mogoče odstraniti. Spet je tukaj.",
      "errorWindowNotAdded": "Ur ni bilo mogoče dodati. Poskusite znova.",
      "errorWindowNotRemoved": "Teh ur ni bilo mogoče odstraniti. Spet so tukaj.",
      "fromLabel": "Od",
      "noTimeOff": "Ni zabeleženih odsotnosti.",
      "noWindows": "Še ni terminov: {name} je povsod prikazan kot nerazpoložljiv.",
      "noteLabel": "Opomba",
      "notePlaceholder": "Neobvezno (npr. zobozdravnik)",
      "removeTimeOff": "Odstranite odsotnost",
      "removeWindow": "Odstranite termin",
      "startLabel": "Začetek",
      "timeOffTitle": "Odsotnost",
      "title": "Razpoložljivost",
      "toLabel": "Do",
      "viewOnly": "Samo ogled: razpoložljivost nastavi lastnik ali upravitelj.",
      "weeklyDescription": "{name} je na voljo v teh terminih. Vse zunaj njih lahko izjemoma še vedno dodelite ročno.",
      "weeklyTitle": "Tedenska razpoložljivost",
      "windowRange": "{day} {start}–{end}"
    },
    "staffTaskFunctionsForm": {
      "description": "Pravilo za čiščenje, ki zahteva eno od teh znanj, izbere le nekoga, ki ga ima. Ročno lahko nalogo še vedno dodelite komur koli.",
      "errorNotSaved": "Te spremembe ni bilo mogoče shraniti. Poskusite znova.",
      "title": "Kaj lahko opravlja"
    },
    "statisticsFilingsHistory": {
      "description": "Poročila o nočitvah, oddana deželnemu uradu za turistično statistiko.",
      "errorRetry": "Ponovna oddaja poročila ni uspela. Poskusite znova.",
      "reference": "Sklic: {reference}",
      "retry": "Poskusite znova",
      "retryFailedAgain": "Poročilo znova ni uspelo.",
      "retryFiled": "Statistično poročilo oddano.",
      "retryNotWaiting": "To poročilo ne čaka več na vas.",
      "statusActionNeeded": "Potrebno ukrepanje",
      "statusCanceled": "Preklicano",
      "statusFiled": "Sprejeto",
      "statusFiling": "Oddajanje …",
      "statusRetrying": "Ponovni poskus",
      "statusScheduled": "Načrtovano",
      "statusSubmitted": "Oddano",
      "title": "Statistična poročila"
    },
    "stayTimesSection": {
      "checkIn": "Prihod od",
      "checkOut": "Odhod do"
    },
    "taskCalendarFeedSection": {
      "cancel": "Prekličite",
      "copyLink": "Kopirajte povezavo",
      "create": "Ustvarite povezavo do koledarja",
      "createPending": "Ustvarjanje povezave …",
      "description": "Spremljajte naloge, ki so vam dodeljene, v Google Koledarju, Apple Koledarju ali Outlooku.",
      "errorCopy": "Povezave ni bilo mogoče kopirati",
      "errorCreate": "Povezave do koledarja ni bilo mogoče ustvariti. Poskusite znova.",
      "errorLoad": "Povezave do koledarja ni bilo mogoče naložiti. Preverite povezavo z internetom in poskusite znova.",
      "errorOffline": "Ste brez povezave, zato povezave do koledarja trenutno ni mogoče naložiti.",
      "errorRegenerate": "Nove povezave ni bilo mogoče ustvariti. Poskusite znova.",
      "errorTurnOff": "Povezave ni bilo mogoče izklopiti. Poskusite znova.",
      "linkCopied": "Povezava do koledarja kopirana",
      "linkLabel": "Povezava do koledarja",
      "loading": "Nalaganje povezave do koledarja …",
      "newLink": "Nova povezava",
      "offlineActionsNote": "Ste brez povezave. Kopiranje še deluje, za novo povezavo ali izklop pa potrebujete internet.",
      "offlineCreateNote": "Ste brez povezave. Za ustvarjanje povezave potrebujete internet.",
      "privacyNote": "Kdor ima to povezavo, vidi vaše naloge. Če pride v napačne roke, ustvarite novo.",
      "regenerateConfirm": "Ustvarite novo povezavo",
      "regenerateDescription": "Trenutna povezava takoj preneha delovati, koledarji, ki jo uporabljajo, pa se ne bodo več posodabljali, dokler ne dodate nove.",
      "regeneratePending": "Ustvarjanje povezave …",
      "regenerateTitle": "Želite ustvariti novo povezavo?",
      "retry": "Poskusite znova",
      "subscribeHelp": "V koledarsko aplikacijo jo dodajte kot koledar z URL-ja. Koledarske aplikacije spremembe preverjajo po svojem urniku, kar lahko traja nekaj ur.",
      "title": "Koledar nalog",
      "turnOff": "Izklopite",
      "turnOffConfirm": "Izklopite",
      "turnOffDescription": "Povezava takoj preneha delovati, koledarji, ki jo uporabljajo, pa se ne bodo več posodabljali. Novo povezavo lahko tukaj ustvarite kadar koli.",
      "turnOffPending": "Izklapljanje …",
      "turnOffTitle": "Želite izklopiti povezavo do koledarja?"
    },
    "taskRulesPage": {
      "anyone": "Kdor koli",
      "assignTo": "Dodelite",
      "defaultOperator": "Sodelavec (privzeto)",
      "defaultReceptionist": "Receptor (privzeto)",
      "errorSave": "Tega pravila ni bilo mogoče shraniti. Poskusite znova.",
      "fallbackOperator": "V tej nastanitvi nihče z vlogo Sodelavec nima delovnega časa, zato te naloge dobi lastnik ali upravitelj, ki takrat dela. Če takrat ne dela nihče od njih, ostanejo nedodeljene. Če želite, da jih namesto tega dobi nekdo z vlogo Sodelavec, mu pod Člani nastavite delovni čas.",
      "fallbackReceptionist": "V tej nastanitvi nihče z vlogo Receptor nima delovnega časa, zato te naloge dobi lastnik ali upravitelj, ki takrat dela. Če takrat ne dela nihče od njih, ostanejo nedodeljene. Če želite, da jih namesto tega dobi nekdo z vlogo Receptor, mu pod Člani nastavite delovni čas.",
      "formerMember": "Nekdo, ki je zapustil to nastanitev",
      "functionHint": "Znanja posameznikov nastavite pod Člani.",
      "functionLabel": "Mora znati opraviti",
      "hintAny": "Vse druge naloge čiščenja, tudi ročno ustvarjene.",
      "hintDefaultOperator": "Dodeli se nekomu z vlogo Sodelavec, ki takrat dela: tistemu, ki ima ta dan najmanj nalog. Če takrat ne dela nihče z vlogo Sodelavec, jo dobi lastnik ali upravitelj, ki dela. Če ne dela nihče, ostane nedodeljena.",
      "hintDefaultReceptionist": "Dodeli se nekomu z vlogo Receptor, ki takrat dela: tistemu, ki ima ta dan najmanj nalog. Če takrat ne dela nihče z vlogo Receptor, jo dobi lastnik ali upravitelj, ki dela. Če ne dela nihče, ostane nedodeljena.",
      "hintFollowsAny": "Sledi spodnjemu pravilu za vse druge naloge čiščenja.",
      "loading": "Nalaganje dodelitev čiščenja …",
      "noOperator": "V tej nastanitvi nihče z vlogo Sodelavec, Lastnik ali Upravitelj nima nastavljenega delovnega časa, zato te naloge ostanejo nedodeljene. Delovni čas nastavite pod Člani.",
      "noReceptionist": "V tej nastanitvi nihče z vlogo Receptor, Lastnik ali Upravitelj nima nastavljenega delovnega časa, zato te naloge ostanejo nedodeljene. Delovni čas nastavite pod Člani.",
      "noRuleFollowsAny": "Enako kot vse druge naloge čiščenja",
      "noRuleKindDefaults": "Privzeto za vsako vrsto naloge",
      "nobodyYet": "Še nihče",
      "person": "Oseba",
      "personHasLeft": "Ta oseba je zapustila nastanitev, zato to pravilo ne dodeli nikogar. Izberite nekoga drugega.",
      "personHint": "Nalogo dobi tudi, ko je odsotna; opozorilo boste videli pri sami nalogi.",
      "summaryOperator": "Sodelavec",
      "summaryOwnerOrManager": "Lastnik ali Upravitelj",
      "summaryReceptionist": "Receptor",
      "summaryUnassigned": "Nedodeljeno",
      "unavailableDescription": "Na tej napravi jih Vidimo ne more naložiti. Poskusite še enkrat: aplikacija se bo pri tem ponovno naložila.",
      "unavailableTitle": "Pravil za naloge trenutno ni mogoče spremeniti"
    },
    "taxReturns": {
      "badgeMore": "Še za plačilo",
      "badgeOpen": "Za plačilo",
      "badgePaid": "Plačano",
      "badgeRunning": "Ta mesec",
      "description": "Turistična taksa po mesecih, skupaj s promocijsko takso: v posamezni mesec se štejejo bivanja, katerih zadnja noč je v tem mesecu. Nakažite jo občini do roka in jo nato tukaj označite kot plačano. Takso, ki vam jo je gost plačal že pred tem mesecem, nakažete v mesecu po plačilu.",
      "errorMarkPaid": "Plačila ni bilo mogoče označiti. Poskusite znova.",
      "markPaid": "Označite kot plačano",
      "markedPaid": "Označeno kot plačano.",
      "overpaid": "Plačali ste {amount} več, kot zdaj znaša taksa za ta bivanja.",
      "stays": "{count, plural, one {# bivanje} two {# bivanji} few {# bivanja} other {# bivanj}}",
      "summaryMore": "Še {amount} za plačilo do {date}",
      "summaryOpen": "{amount} za plačilo do {date}",
      "summaryPaid": "Plačano {amount}",
      "summaryRunning": "Doslej {amount}, rok {date}",
      "title": "Plačila turistične takse",
      "uncomputed": "{count, plural, one {Za # bivanje taksa še ni izračunana, zato ni vključena v znesek.} two {Za # bivanji taksa še ni izračunana, zato ni vključena v znesek.} few {Za # bivanja taksa še ni izračunana, zato ni vključena v znesek.} other {Za # bivanj taksa še ni izračunana, zato ni vključena v znesek.}}"
    },
    "taxRules": {
      "ageFrom": "od {age} let naprej",
      "ageRange": "od {from} do {to} let",
      "ageUnder": "mlajši od {age} let",
      "chargesNothing": "V tej občini se ne obračunava",
      "checked": "Preverjeno {date}",
      "from": "Od {date}: {rule}",
      "maxNights": "{count, plural, one {največ # noč na bivanje} two {največ # noči na bivanje} few {največ # noči na bivanje} other {največ # noči na bivanje}}",
      "paysFree": "{ages}: brez takse",
      "paysHalf": "{ages}: polovična taksa",
      "paysPercent": "{ages}: {percent} polne takse",
      "perPersonNight": "{amounts} na osebo na noč",
      "rateCategory": "{category}: {rate}",
      "ratePercent": "{percent} cene, največ {cap}",
      "awaitsFacility": "Turistična taksa je v tej občini odvisna od tega, kje je vaša nastanitev, kakšne vrste je ali kdo jo oddaja. Vidimo te podatke poišče v registru na podlagi številke v polju »{field}« na zaslonu {system} v Vidimu in prikaže takso, ko vašo nastanitev najde v registru.",
      "errorLoad": "Turistične takse ni bilo mogoče naložiti. Poskusite znova.",
      "notCovered": "Vidimo turistične takse v kraju te nastanitve še ne pozna, zato njene rezervacije zaenkrat ne prikazujejo takse.",
      "source": "Vir",
      "withSurcharge": "{rate} + {surcharge} {label}",
      "zone": "Znesek za {zone}"
    },
    "timezoneField": {
      "hint": "Uporablja se za čase prihoda in odhoda ter načrtovanje",
      "label": "Časovni pas"
    },
    "unitForm": {
      "amenitiesLabel": "Oprema",
      "amenitiesPlaceholder": "Izberite opremo",
      "babyCots": "Otroške posteljice",
      "cancel": "Prekličite",
      "codeHintAuto": "{count, plural, one {Samodejno izpolnjeno iz imena enote. Vnesite svojo kodo ali polje počistite, da se znova izpolnjuje samodejno. Največ # znak.} two {Samodejno izpolnjeno iz imena enote. Vnesite svojo kodo ali polje počistite, da se znova izpolnjuje samodejno. Največ # znaka.} few {Samodejno izpolnjeno iz imena enote. Vnesite svojo kodo ali polje počistite, da se znova izpolnjuje samodejno. Največ # znaki.} other {Samodejno izpolnjeno iz imena enote. Vnesite svojo kodo ali polje počistite, da se znova izpolnjuje samodejno. Največ # znakov.}}",
      "codeHintManual": "{count, plural, one {Kratka oznaka za koledar in sezname nalog, npr. 101, APH-SV. Počistite polje, da bo samodejno sledila imenu enote. Največ # znak.} two {Kratka oznaka za koledar in sezname nalog, npr. 101, APH-SV. Počistite polje, da bo samodejno sledila imenu enote. Največ # znaka.} few {Kratka oznaka za koledar in sezname nalog, npr. 101, APH-SV. Počistite polje, da bo samodejno sledila imenu enote. Največ # znaki.} other {Kratka oznaka za koledar in sezname nalog, npr. 101, APH-SV. Počistite polje, da bo samodejno sledila imenu enote. Največ # znakov.}}",
      "codeLabel": "Kratka koda",
      "codePlaceholder": "npr. 101 ali APH",
      "cotsAndExtraBeds": "Posteljice in dodatna ležišča",
      "createSubtitle": "Tej nastanitvi dodajte novo enoto, ki jo je mogoče rezervirati",
      "createTitle": "Ustvarite enoto",
      "deleteDescription": "Trajno odstranite to enoto. Rezervacije, povezane z njo, bo morda treba posodobiti. Tega dejanja ni mogoče razveljaviti.",
      "deleteLabel": "Izbrišite enoto",
      "descriptionHint": "Prikazano na javni strani sobe in pomaga, da jo najdejo iskalniki.",
      "descriptionLabel": "Opis",
      "descriptionPlaceholder": "Opišite sobo: razgled, svetlobo, kaj jo dela posebno. Prikazano na javni strani sobe.",
      "duplicate": "Podvojite enoto",
      "editSubtitle": "Upravljajte podatke o enoti",
      "editTitle": "Uredite enoto",
      "errorDelete": "Enote ni bilo mogoče izbrisati. Poskusite znova.",
      "errorDuplicate": "Enote ni bilo mogoče podvojiti. Poskusite znova.",
      "errorSave": "Enote ni bilo mogoče shraniti. Poskusite znova.",
      "extraBeds": "Dodatna ležišča",
      "maxAdults": "Največ odraslih",
      "maxChildren": "Največ otrok",
      "maxChildrenPayable": "Otroci (plačljiva cena)",
      "maxGuests": "Največ gostov",
      "nameLabel": "Ime",
      "namePlaceholder": "npr. Soba 101 ali Apartma A",
      "occupancy": "Zasedenost",
      "save": "Shranite",
      "sizeLabel": "Velikost",
      "sizePlaceholder": "npr. 25",
      "sizeUnitLabel": "Merska enota",
      "smokingAllowed": "Kajenje dovoljeno",
      "smokingLabel": "Pravila o kajenju",
      "smokingNonSmoking": "Nekadilska",
      "smokingPlaceholder": "Izberite pravilo",
      "smokingUnknown": "Neznano",
      "unitTypeLabel": "Vrsta enote",
      "unitTypePlaceholder": "Izberite vrsto enote"
    },
    "unitsEdit": {
      "notFound": "Enote ni mogoče najti"
    },
    "unlinkMethodDialog": {
      "cancel": "Prekličite",
      "confirm": "Odstranite",
      "confirmPending": "Odstranjevanje …",
      "description": "Z načinom {method} se ne boste več mogli vpisati. Drugi načini vpisa še naprej delujejo, ta način pa lahko na tem zaslonu kadar koli znova povežete.",
      "title": "Želite odstraniti {method}?"
    },
    "wifiSection": {
      "hidePassword": "Skrijte geslo za WiFi",
      "hint": "Gostom se prikaže od dneva prihoda, ko sta nastavljena ime omrežja in geslo. Geslo nikoli ni vključeno v osnutke AI.",
      "label": "WiFi",
      "passwordLabel": "Geslo za WiFi",
      "passwordPlaceholder": "Geslo",
      "revealPassword": "Pokažite geslo za WiFi",
      "ssidLabel": "Ime omrežja WiFi",
      "ssidPlaceholder": "Ime omrežja"
    }
  },

  "setup": {
    "setupBookingsStep": {
      "continue": "Nadaljujte",
      "description": "Vaša aplikacija AI jih lahko kopira v Vidimo, da vam ni treba voditi dveh koledarjev.",
      "fresh": "Ne, začenjam s praznim koledarjem",
      "import": "Da, želim jih uvoziti",
      "imported": "Rezervacije so uvožene iz sistema {source}.",
      "openImports": "Odprite razdelek Uvožene rezervacije",
      "results": "To lahko storite tudi pozneje na računalniku. Poziv za vašo aplikacijo AI in rezultate uvoza najdete v nastavitvah.",
      "skip": "Zaenkrat preskočite",
      "title": "Ali rezervacije že vodite v drugem sistemu?"
    },
    "setupEmptyState": {
      "calendarDescription": "Dokončajte nastavitev nastanitve in enot, da boste rezervacije videli razporejene po koledarju.",
      "calendarTitle": "Tukaj bo koledar rezervacij",
      "chatsDescription": "Dokončajte nastavitev nastanitve in začela bodo prihajati sporočila gostov, rezervacije in odgovori AI.",
      "chatsTitle": "Tukaj bodo pogovori z gosti",
      "setUp": "Nastavite nastanitev",
      "skip": "Zaenkrat preskočite",
      "tasksDescription": "Dokončajte nastavitev nastanitve, da boste lahko ekipi dodeljevali čiščenja, sprejem gostov in vzdrževanje.",
      "tasksTitle": "Tukaj bodo naloge vaše ekipe",
      "todayDescription": "Dokončajte nastavitev nastanitve in tukaj bodo prihodi, odhodi in gostje v nastanitvi za vsak dan.",
      "todayTitle": "Tukaj se bo začel vaš dan"
    },
    "setupEssentialsStep": {
      "addressHint": "Poiščite in izberite naslov, da določite lokacijo in državo.",
      "addressLabel": "Naslov",
      "addressPlaceholder": "Poiščite naslov nastanitve …",
      "continue": "Shranite in nadaljujte",
      "description": "Osnove, na katere se zanašajo gostje in ekipa. Vse lahko pozneje dopolnite v nastavitvah.",
      "errorNotSaved": "Podatkov o nastanitvi ni bilo mogoče shraniti. Poskusite znova.",
      "nameLabel": "Ime nastanitve *",
      "namePlaceholder": "Vnesite ime nastanitve",
      "timezoneConfirm": "Potrdite",
      "timezoneDetected": "Zaznano s te naprave; ni shranjeno, dokler ga ne potrdite ali izberete naslova.",
      "timezoneHint": "Uporablja se za čase prihoda in odhoda ter načrtovanje.",
      "timezoneLabel": "Časovni pas",
      "timezonePlaceholder": "Izberite časovni pas",
      "title": "Osnovni podatki nastanitve"
    },
    "setupStepLayout": {
      "back": "Nazaj",
      "saving": "Shranjevanje …",
      "skip": "Preskočite"
    },
    "setupSummaryStep": {
      "addressLabel": "Naslov",
      "bookingsImported": "Uvožene iz sistema {source}",
      "bookingsLabel": "Rezervacije",
      "bookingsNone": "Ničesar za uvoz",
      "bookingsNotYet": "Še niso uvožene",
      "descriptionComplete": "Vse je pripravljeno. Nastanitev lahko začne delovati.",
      "descriptionIncomplete": "Zdaj lahko končate, preostale osnove pa kadar koli dopolnite v nastavitvah.",
      "finish": "Končajte nastavitev",
      "finishAnyway": "Vseeno končajte",
      "invitesNone": "Še ni povabil (neobvezno)",
      "invitesPending": "{count, plural, one {{count} povabilo čaka} two {{count} povabili čakata} few {{count} povabila čakajo} other {{count} povabil čaka}}",
      "nameLabel": "Ime nastanitve",
      "notSet": "Še ni nastavljeno",
      "teamLabel": "Ekipa",
      "timezoneLabel": "Časovni pas",
      "title": "Pregled",
      "unitsAdded": "{count, plural, one {Dodana {count} enota} two {Dodani {count} enoti} few {Dodane {count} enote} other {Dodanih {count} enot}}",
      "unitsLabel": "Enote",
      "unitsNone": "Dodajte vsaj eno enoto"
    },
    "setupTeamStep": {
      "continue": "Nadaljujte",
      "description": "Povabite sodelavca, ki vam bo pomagal voditi nastanitev. To je neobvezno in lahko storite tudi pozneje.",
      "emailHint": "Po e-pošti mu bomo poslali povezavo za pridružitev in kodo povabila, ki jo lahko vnese v aplikaciji.",
      "emailLabel": "E-pošta",
      "emailPlaceholder": "ime@primer.si",
      "errorNotSent": "Povabila ni bilo mogoče poslati.",
      "invitationPending": "{role} · povabilo čaka",
      "invitationSent": "Povabilo poslano",
      "noPermission": "Nimate dovoljenja za vabljenje članov v to nastanitev.",
      "roleLabel": "Vloga",
      "rolePlaceholder": "Izberite vlogo",
      "send": "Pošljite povabilo",
      "sending": "Pošiljanje …",
      "skip": "Zaenkrat preskočite",
      "title": "Povabite ekipo"
    },
    "setupUnitsStep": {
      "add": "Dodajte enoto",
      "adding": "Dodajanje …",
      "continue": "Nadaljujte",
      "description": "Dodajte sobe ali apartmaje, ki jih gostje lahko rezervirajo. Potrebujete vsaj eno enoto, več jih lahko kadar koli dodate v nastavitvah.",
      "errorNotAdded": "Enote ni bilo mogoče dodati. Poskusite znova.",
      "errorNotRemoved": "Enote ni bilo mogoče odstraniti. Poskusite znova.",
      "maxGuestsLabel": "Največ gostov",
      "nameLabel": "Ime enote",
      "namePlaceholder": "npr. Soba 101 ali Apartma A",
      "remove": "Odstranite {name}",
      "skip": "Zaenkrat preskočite",
      "title": "Enote",
      "typeLabel": "Vrsta",
      "typePlaceholder": "Izberite vrsto",
      "typeSleeps": "{count, plural, one {{type} · {count} ležišče} two {{type} · {count} ležišči} few {{type} · {count} ležišča} other {{type} · {count} ležišč}}",
      "unitFallback": "Enota"
    },
    "setupWizard": {
      "skipSetup": "Preskočite nastavitev",
      "stepBookings": "Rezervacije",
      "stepEssentials": "Osnove",
      "stepReview": "Pregled",
      "stepTeam": "Ekipa",
      "stepUnits": "Enote",
      "subtitle": "Pripravite nastanitev za delo",
      "titleNamed": "Nastavite {name}",
      "titleUnnamed": "Nastavite nastanitev"
    }
  },

  "shell": {
    "appHeader": {
      "search": "Iskanje"
    },
    "appNavRail": {
      "label": "Glavna navigacija"
    },
    "auditFormatting": {
      "fieldLabel": {
        "assignedTo": "izvajalec",
        "description": "opis",
        "endAt": "odhod",
        "expectedArrivalTime": "predviden prihod",
        "linkedGuest": "Povezava z gostom",
        "mergedDuplicate": "Združitev",
        "startAt": "prihod",
        "status": "status",
        "taxNote": "opomba o taksi",
        "title": "naslov",
        "type": "vrsta",
        "unitId": "enota"
      },
      "fromTo": "{from} → {to}",
      "none": "brez",
      "withheldChange": "{kind, select, added {dodano} removed {odstranjeno} other {spremenjeno}}",
      "withheldField": "{field}: {kind, select, added {dodano} removed {odstranjeno} other {spremenjeno}}"
    },
    "auditTimeline": {
      "bySupport": "Podpora Vidimo v imenu: {actor}",
      "changeTo": "→",
      "headline": {
        "guestCreate": "Dodan gost: {summary}",
        "guestDelete": "Odstranjen gost: {summary}",
        "guestUpdate": "Spremenjen gost: {summary}",
        "rateCreate": "Dodane cene: {summary}",
        "rateDelete": "Odstranjene cene: {summary}",
        "rateUpdate": "Spremenjene cene: {summary}",
        "reservationCreate": "Dodana rezervacija: {summary}",
        "reservationDelete": "Odstranjena rezervacija: {summary}",
        "reservationUpdate": "Spremenjena rezervacija: {summary}",
        "taskCreate": "Dodana naloga: {summary}",
        "taskDelete": "Odstranjena naloga: {summary}",
        "taskMissTakenBack": "Spet čaka: gost vendarle še ni prispel",
        "taskMissed": "Prepozno: gost je prispel, preden je bila naloga opravljena",
        "taskUpdate": "Spremenjena naloga: {summary}"
      },
      "byVidimo": "Vidimo",
      "onBehalf": "{agent} (podpora Vidimo) v imenu: {actor}",
      "open": {
        "guest": "Odprite gosta",
        "reservation": "Odprite rezervacijo",
        "task": "Odprite nalogo"
      },
      "title": "Dejavnost",
      "unknownActor": "Neznano"
    },
    "avatarUpload": {
      "chooseImage": "Izberite sliko",
      "errorUpload": "Slike ni bilo mogoče naložiti. Poskusite znova."
    },
    "connectionStatusBanner": {
      "backendUnreachable": "Vidimo ni dosegljiv. Spremembe se bodo sinhronizirale, ko bo spet na voljo.",
      "changesNotSent": "Nekatere spremembe še niso bile poslane. Pustite aplikacijo odprto, medtem ko poskušamo znova.",
      "deviceOffline": "Ste brez povezave. Spremembe se bodo sinhronizirale, ko se povežete."
    },
    "copyRecordLink": {
      "copied": "Povezava kopirana",
      "errorNotCopied": "Povezave ni bilo mogoče kopirati"
    },
    "deviceReplica": {
      "clearDatabase": {
        "cancel": "Obdržite",
        "confirm": "Vseeno počistite",
        "unsynced": "{count, plural, one {{count} sprememba na tej napravi še ni sinhronizirana. Če zdaj počistite, bo izbrisana s te naprave in ne bo prišla v Vidimo.} two {{count} spremembi na tej napravi še nista sinhronizirani. Če zdaj počistite, bosta izbrisani s te naprave in ne bosta prišli v Vidimo.} few {{count} spremembe na tej napravi še niso sinhronizirane. Če zdaj počistite, bodo izbrisane s te naprave in ne bodo prišle v Vidimo.} other {{count} sprememb na tej napravi še ni sinhroniziranih. Če zdaj počistite, bodo izbrisane s te naprave in ne bodo prišle v Vidimo.}}",
        "unsyncedUnknown": "Nekatere spremembe na tej napravi morda še niso sinhronizirane. Če zdaj počistite, bodo izbrisane s te naprave in ne bodo prišle v Vidimo."
      },
      "signOut": {
        "cancel": "Ostanite vpisani",
        "confirm": "Vseeno se izpišite",
        "unsynced": "{count, plural, one {{count} sprememba na tej napravi še ni sinhronizirana. Če se zdaj izpišete, bo izbrisana s te naprave in ne bo prišla v Vidimo.} two {{count} spremembi na tej napravi še nista sinhronizirani. Če se zdaj izpišete, bosta izbrisani s te naprave in ne bosta prišli v Vidimo.} few {{count} spremembe na tej napravi še niso sinhronizirane. Če se zdaj izpišete, bodo izbrisane s te naprave in ne bodo prišle v Vidimo.} other {{count} sprememb na tej napravi še ni sinhroniziranih. Če se zdaj izpišete, bodo izbrisane s te naprave in ne bodo prišle v Vidimo.}}",
        "unsyncedUnknown": "Nekatere spremembe na tej napravi morda še niso sinhronizirane. Če se zdaj izpišete, bodo izbrisane s te naprave in ne bodo prišle v Vidimo."
      },
      "signOutFailed": "Izpis ni uspel. Preverite povezavo in poskusite znova.",
      "signOutOffline": "Ste brez povezave. Za izpis se povežite; do takrat vse ostane na tej napravi.",
      "unsyncedTitle": "Nesinhronizirane spremembe"
    },
    "errorBoundary": {
      "description": "Za nadaljevanje znova naložite aplikacijo.",
      "reload": "Znova naložite aplikacijo",
      "title": "Nekaj je šlo narobe"
    },
    "loading": "Nalaganje …",
    "mrzScanner": {
      "alreadyOnBooking": "{name} je že na tej rezervaciji. {outcome}",
      "confirm": "Potrdite",
      "errorNoReservation": "Ni jasno, za katero rezervacijo gre. Znova odprite rezervacijo in poskusite še enkrat.",
      "errorNotAccepted": "Podatki niso bili sprejeti. Primerjajte jih z dokumentom in poskusite znova.",
      "errorNotOnBooking": "Ta oseba ni več na tej rezervaciji. Znova odprite rezervacijo in preverite, kdo je na njej.",
      "errorPartyFull": "Na tej rezervaciji so že vsi pričakovani gostje. Če želite koga dodati, najprej povečajte število pri »Odrasli«, »Otroci« ali »Dojenčki«. Če želite skenirati nekoga, ki je že na rezervaciji, tapnite ikono dokumenta v njegovi vrstici.",
      "errorReservationNotActive": "Za to rezervacijo prijave niso več mogoče.",
      "errorUnreachable": "Strežnik ni dosegljiv. Preverite povezavo in poskusite znova.",
      "guestPickerLabel": "Čigav je ta dokument?",
      "noGuests": "Ta rezervacija še nima gostov: prvo skeniranje jih bo dodalo.",
      "outcomeActionNeeded": "Shranjeno, vendar prijava še zahteva pozornost. Kaj je potrebno, vidite v razdelku »Prijava« pri gostu.",
      "outcomeFiled": "Shranjeno in oddano. Organ je prijavo potrdil.",
      "outcomeNone": "Dokument je shranjen pri gostu.",
      "outcomeSubmitted": "Shranjeno in oddano. Čaka na potrditev.",
      "scanner": {
        "back": "Nazaj",
        "cameraFailed": "Kamere ni bilo mogoče zagnati. Preverite dovoljenja in poskusite znova.",
        "cancelScan": "Prekličite skeniranje",
        "checkingRequirements": "Preverjamo, kaj zahteva prijava tega bivanja …",
        "chooseOneOf": "Izberite: {choices}.",
        "chooseWho": "Izberite, kdo se prijavlja.",
        "close": "Zaprite",
        "countryClear": "Počistite",
        "documentNumber": "Št. dokumenta",
        "documentNumberPlaceholder": "Številka dokumenta",
        "doubleCheck": "Še enkrat preverite: {fields}",
        "expiryDate": "Velja do",
        "failedBody": "To se zgodi pogosto. Izberite, kar vam je najlažje:",
        "failedTitle": "Dokumenta ni bilo mogoče prebrati",
        "guestFallback": "Gost {id}",
        "manualBody": "Prepišite jih z dokumenta, ujemati se morajo natančno.",
        "manualSubmit": "Shranite podatke",
        "manualTitle": "Vnesite podatke z dokumenta",
        "missingLicense": "Skeniranje dokumentov trenutno ni na voljo. Obrnite se na gostitelja.",
        "noCamera": "Nimate kamere? Podatke vnesite ročno",
        "openingCamera": "Odpiranje kamere …",
        "optional": "Neobvezno",
        "personalNumber": "Osebna identifikacijska številka",
        "personalNumberPlaceholder": "Kot na dokumentu",
        "pickGuest": "Izberite, čigavi so ti podatki.",
        "regimeFieldsIntro": "Potrebno za prijavo bivanja tukaj, na dokumentu pa ni navedeno.",
        "required": "Obvezno",
        "retake": "Skenirajte znova",
        "reviewBody": "Prebrano z dokumenta, na vašem telefonu. Popravite vse, kar ni videti prav: ujemati se mora natančno.",
        "reviewTitle": "Preverite, ali se ujema z dokumentom",
        "scanBody": "Stran s fotografijo držite v okvirju. Prebere se sama, ničesar vam ni treba pritisniti.",
        "scanButton": "Skenirajte potni list ali osebno izkaznico",
        "scanEyebrow": "Skeniranje dokumenta",
        "scanTarget": "Za",
        "scanTitle": "Skenirajte gostov potni list ali osebno izkaznico",
        "scanned": "✓ Skenirano",
        "select": "Izberite",
        "selectSex": "Izberite spol",
        "submitFailed": "Prijave ni bilo mogoče oddati.",
        "submitting": "Oddajanje …",
        "tryAgainSub": "Več svetlobe, manj odsevov, dokument naj leži ravno",
        "tryAgainTitle": "Poskusite znova",
        "typeInsteadSub": "Vnesite, kar je natisnjeno na dokumentu",
        "typeInsteadTitle": "Podatke raje vnesite ročno",
        "view": {
          "bothSidesScanned": "Obe strani skenirani ✓",
          "cameraAccessDenied": "Dostop do kamere je zavrnjen",
          "closeScanner": "Zaprite skener",
          "flipDocument": "Zdaj skenirajte stran s fotografijo",
          "flipDocumentCountdown": "Obrnite dokument in skenirajte drugo stran ({seconds} s)",
          "holdSteady": "Držite pri miru …",
          "loadImageFailed": "Slike ni bilo mogoče naložiti",
          "portraitScanned": "Fotografija skenirana ✓",
          "positionMRZ": "Strojno berljivo polje (MRZ) postavite v okvir",
          "positionPortrait": "Fotografijo postavite v okvir",
          "rotateDevice": "Napravo obrnite v pokončni položaj",
          "scanMRZFirst": "Najprej skenirajte stran s strojno berljivim poljem (MRZ)",
          "scanSuccess": "MRZ skeniran ✓",
          "scanningPortrait": "Skeniranje fotografije …",
          "skipPortraitLabel": "Preskočite skeniranje fotografije",
          "switchCamera": "Zamenjajte kamero",
          "toggleFlash": "Vklopite ali izklopite bliskavico"
        }
      }
    },
    "notFound": {
      "description": "V Vidimu ta povezava ne vodi nikamor. Morda je zastarela ali napačno vpisana.",
      "goToToday": "Odprite pogled Danes",
      "title": "Strani ni mogoče najti"
    },
    "osHelpers": {
      "cancel": "Prekličite",
      "settings": "Nastavitve"
    },
    "pageHeader": {
      "back": "Nazaj"
    },
    "parkedDrawerBar": {
      "close": "Zaprite podrobnosti",
      "reopen": "Znova odprite: {name}"
    },
    "paywallGate": {
      "errorOwnerOnly": "Naročnino lahko uredi le lastnik nastanitve.",
      "lapsedNativeDescription": "Ta nastanitev je zaustavljena. Nič ni izbrisano, dostop pa se vrne takoj, ko je naročnina spet aktivna.",
      "lapsedNotice": "Naročnina za to nastanitev je potekla. Prosite lastnika, naj jo podaljša.",
      "lapsedTitle": "Vaša naročnina je potekla",
      "noSubscriptionDescription": "Potrebuje aktivno naročnino. Do takrat so vaši podatki varni.",
      "noSubscriptionTitle": "Ta nastanitev še ni aktivna",
      "pastDueNative": "Plačilo ni uspelo. Dostop bo morda kmalu prekinjen.",
      "propertySettings": "Nastavitve nastanitve",
      "signOut": "Izpišite se",
      "trialActive": "Brezplačni preizkus je aktiven.",
      "trialDaysLeft": "Brezplačni preizkus: še {days, plural, one {# dan} two {# dneva} few {# dnevi} other {# dni}}."
    },
    "persisted": {
      "lateRollback": "Sprememba, ki ste jo pravkar shranili, se ni ohranila. Preverite jo in poskusite znova."
    },
    "placePicker": {
      "errorDetails": "Tega naslova ni bilo mogoče naložiti. Poskusite z drugim zadetkom.",
      "errorLookup": "Iskanje naslova ni uspelo. Preverite povezavo.",
      "poweredByGoogle": "Poganja Google",
      "searching": "Iskanje …",
      "unavailable": "Iskanje naslovov ni na voljo"
    },
    "powersyncUploadFeedback": {
      "breakfastAlreadySetUp": "Zajtrk je bil že nastavljen na drugi napravi, zato vaša sprememba ni bila shranjena.",
      "discarded": "Nekaterih sprememb ni bilo mogoče shraniti, zato so bile razveljavljene.",
      "discardedEntity": "Nekaterih sprememb ({label}) ni bilo mogoče shraniti, zato so bile razveljavljene.",
      "labels": {
        "availability": "razpoložljivost",
        "breakfast": "nastavitev zajtrka",
        "charge": "postavka",
        "conversation": "pogovor",
        "guest": "gost",
        "message": "sporočilo",
        "payment": "plačilo",
        "pricing": "cene",
        "property": "nastanitev",
        "reaction": "odziv",
        "reservation": "rezervacija",
        "suggestion": "predlog",
        "task": "naloga",
        "timeOff": "odsotnost",
        "unit": "enota"
      }
    },
    "prerenderRoutes": {
      "signupMetaDescription": "Ustvarite račun Vidimo in upravljajte nastanitve, rezervacije, sporočila gostov in prijave na enem mestu.",
      "signupTitle": "Ustvarite račun · Vidimo"
    },
    "primaryTabs": {
      "calendar": "Koledar",
      "chats": "Klepeti",
      "guests": "Gostje",
      "tasks": "Naloge",
      "today": "Danes"
    },
    "propertyFacet": {
      "addProperty": "Dodajte nastanitev",
      "allProperties": "Vse nastanitve",
      "colorLabel": "Barva nastanitve {name}",
      "empty": "Ni razpoložljivih nastanitev.",
      "only": "Samo",
      "onlyLabel": "Pokažite samo {name}",
      "settingsLabel": "Nastavitve: {name}",
      "title": "Vaše nastanitve"
    },
    "rowPending": {
      "syncing": "{kind, select, guest {Sinhroniziranje gosta …} member {Sinhroniziranje člana …} parking {Sinhroniziranje parkirišča …} reservation {Sinhroniziranje rezervacije …} staffMember {Sinhroniziranje člana ekipe …} task {Sinhroniziranje naloge …} unit {Sinhroniziranje enote …} other {Sinhroniziranje …}}"
    },
    "scopeChip": {
      "allProperties": "Vse nastanitve",
      "clearFilters": "Počistite<suffix> {count, plural, one {# filter} two {# filtra} few {# filtre} other {# filtrov}}</suffix>",
      "clearFiltersLabel": "Počistite {count, plural, one {# filter} two {# filtra} few {# filtre} other {# filtrov}}",
      "noProperties": "Ni nastanitev",
      "propertyCount": "{count, plural, one {# nastanitev} two {# nastanitvi} few {# nastanitve} other {# nastanitev}}",
      "scopeLabel": "Obseg: {label}",
      "scopeLabelFiltered": "Obseg: {label} (aktivni filtri: {count})"
    },
    "scopeDrawer": {
      "title": "Obseg"
    },
    "searchOverlay": {
      "close": "Zaprite iskanje",
      "emptyDescription": "Iščite goste, osebje, rezervacije in naloge",
      "guestFallback": "Gost",
      "noResultsDescription": "Poskusite z drugim iskalnim izrazom",
      "noResultsTitle": "Ni zadetkov",
      "placeholder": "Iščite goste, osebje, rezervacije, naloge …",
      "reservationFallback": "Rezervacija",
      "taskSubtitle": "Naloga",
      "taskSubtitleAssigned": "Naloga • {assignee}",
      "title": "Iskanje"
    },
    "staffFacet": {
      "allStaff": "Vse osebje",
      "empty": "Ni razpoložljivega osebja.",
      "meSuffix": "(jaz)",
      "only": "Samo",
      "onlyLabel": "Pokažite samo {name}",
      "title": "Osebje"
    },
    "stillLooking": {
      "description": "Morda se še sinhronizira. Če se ne prikaže, je bil morda odstranjen ali pa spada k nastanitvi, do katere nimate dostopa.",
      "title": "{kind, select, guest {Še iščemo tega gosta} member {Še iščemo tega člana} parking {Še iščemo to parkirišče} reservation {Še iščemo to rezervacijo} staffMember {Še iščemo tega člana ekipe} task {Še iščemo to nalogo} unit {Še iščemo to enoto} other {Še iščemo}}"
    },
    "supportSession": {
      "ended": {
        "description": "Podatki stranke so iz tega zavihka izbrisani. Zavihek lahko zaprete.",
        "title": "Seja podpore je končana"
      },
      "failed": {
        "description": "Preverite povezavo, nato odprite novo sejo iz CRM-ja.",
        "title": "Seje ni bilo mogoče odpreti"
      },
      "invalid": {
        "description": "Vsaka povezava odpre eno sejo in deluje eno minuto. Novo odprite iz CRM-ja.",
        "title": "Ta povezava je potekla ali je bila že uporabljena"
      },
      "opening": "Odpiranje aplikacije stranke …"
    },
    "supportSessionBanner": {
      "exit": "Izhod",
      "viewingAs": "Ogled kot {name}, podpora Vidimo"
    },
    "syncingState": {
      "defaultLabel": "Sinhroniziranje pogovorov …",
      "retry": "Poskusite znova",
      "retrying": "Ponovni poskus …",
      "slow": "Sinhronizacija traja dlje kot običajno …",
      "unreachableDescription": "Podatki se bodo naložili takoj, ko bo povezava spet vzpostavljena. Preverite internetno povezavo ali poskusite znova čez trenutek.",
      "unreachableTitle": "Strežnik za sinhronizacijo ni dosegljiv"
    },
    "useAcceptInvitation": {
      "errorInvitationNotFound": "Ta koda povabila ni več veljavna: morda je potekla ali bila preklicana. Prosite za novo.",
      "errorNotJoined": "Pridružitev nastanitvi ni uspela. Preverite kodo povabila in poskusite znova.",
      "errorSupportSession": "Pridružitev nastanitvi v seji podpore ni na voljo.",
      "errorWrongRecipient": "To povabilo je bilo poslano na drug e-poštni naslov. Za sprejem se vpišite s tem naslovom.",
      "joined": "Pridružili ste se nastanitvi"
    },
    "useDirtyGuard": {
      "discardPrompt": "Imate neshranjene spremembe. Jih želite zavreči?"
    },
    "userDrawer": {
      "account": "Račun",
      "accountDescription": "Profil, videz in koledar nalog",
      "accountSection": "Račun",
      "contactSupport": "Pišite podpori",
      "contactSupportDescription": "Sporočilo ekipi Vidimo",
      "help": "Pomoč",
      "helpDescription": "Vodniki za uporabo Vidima",
      "joinProperty": "Pridružite se nastanitvi",
      "joinPropertyDescription": "S kodo povabila sodelavca",
      "legalSection": "Pravno",
      "notifications": "Nastavitve obvestil",
      "notificationsDescription": "Zvoki sporočil, skupin in klicev",
      "privacy": "Politika zasebnosti",
      "privacyDescription": "Kako Vidimo ravna z vašimi podatki",
      "signOut": "Izpišite se",
      "signedIn": "Vpisani",
      "supportSection": "Podpora",
      "terms": "Pogoji uporabe",
      "termsDescription": "Dogovor o vaši uporabi Vidima",
      "trigger": "Uporabniški meni",
      "triggerWithNews": "Uporabniški meni, z novostjo v razdelku Novosti",
      "whatsNew": "Novosti",
      "whatsNewDescription": "Kaj se je v Vidimu spremenilo, izdaja za izdajo",
      "whatsNewUnseen": "Nov vnos"
    }
  },

  "stayPreview": {
    "stayPreviewFrame": {
      "frameTitle": "Predogled strani bivanja za goste",
      "loadFailed": "Predogleda ni bilo mogoče naložiti.",
      "tryAgain": "Poskusite znova"
    },
    "stayPreviewHost": {
      "preview": "Predogled",
      "title": "Predogled kot gost"
    },
    "stayPreviewPanel": {
      "copyLink": "Kopirajte povezavo",
      "errorCopyFailed": "Povezave ni bilo mogoče kopirati",
      "linkCopied": "Povezava do predogleda kopirana",
      "phaseAfter": "Po odhodu",
      "phaseArrivalDay": "Dan prihoda",
      "phaseBefore": "Pred prihodom",
      "phaseGroupLabel": "Faza bivanja",
      "phaseInStay": "Med bivanjem",
      "qrCodeLabel": "Koda QR, ki ta predogled odpre na telefonu",
      "sampleNotice": "Vzorčno bivanje: datumi, gostje in koda za vrata so primeri.",
      "scanHint": "Skenirajte, da ta predogled odprete na telefonu. Prikazuje, kar ste shranili."
    }
  },

  "tasks": {
    "completed": {
      "completeFailed": "Naloge ni bilo mogoče zaključiti. Poskusite znova.",
      "title": "Naloga opravljena",
      "undo": "Razveljavite",
      "undoFailed": "Razveljavitev ni uspela. Naloga ostaja opravljena."
    },
    "completionNote": {
      "dictate": "Narekujte opombo",
      "hint": "Zapišite vse, kar zahteva nadaljnje ukrepanje.",
      "optional": "Neobvezno",
      "placeholder": "Vnesite opombo …",
      "save": "Shranite opombo",
      "saveFailed": "Opombe ni bilo mogoče shraniti. Poskusite znova.",
      "saved": "Shranjeno",
      "stopRecording": "Ustavite snemanje",
      "title": "Dodajte opombo k nalogi",
      "transcribeFailed": "Posnetka ni bilo mogoče prepisati. Poskusite znova.",
      "transcribing": "Prepisovanje …"
    },
    "editTaskForm": {
      "assignedTo": "Dodeljeno",
      "back": "Nazaj",
      "backToTasks": "Nazaj na naloge",
      "cancel": "Prekličite",
      "create": "Ustvarite",
      "created": "Naloga ustvarjena.",
      "dateLabel": "Datum <hint>(neobvezno; pustite prazno za opravilo brez roka)</hint>",
      "delete": "Izbrišite",
      "deleteDescription": "Izgine za vse. Delo je običajno bolje zaključiti tako, da nalogo označite kot opravljeno; brisanje je za nalogo, ki sploh ne bi smela obstajati.",
      "deleteTask": "Izbrišite nalogo",
      "deleteTitle": "Želite izbrisati to nalogo?",
      "deleted": "Naloga izbrisana",
      "deleting": "Brisanje …",
      "descriptionLabel": "Opis",
      "descriptionPlaceholder": "Opis naloge (neobvezno)",
      "endTimeLabel": "Konec",
      "errorNotDeleted": "Naloge ni bilo mogoče izbrisati. Poskusite znova.",
      "errorNotSaved": "Naloge ni bilo mogoče shraniti. Poskusite znova.",
      "notFound": "Naloge ni mogoče najti",
      "priorityHigh": "Visoka",
      "priorityLabel": "Prednost",
      "priorityLow": "Nizka",
      "priorityMedium": "Srednja",
      "propertyLabel": "Nastanitev",
      "propertyPlaceholder": "Izberite nastanitev",
      "save": "Shranite",
      "startTimeLabel": "Začetek",
      "statusLabel": "Status",
      "titleEdit": "Uredite nalogo",
      "titleLabel": "Naslov",
      "titleNew": "Nova naloga",
      "titlePlaceholder": "Naslov naloge",
      "typeCleaning": "Čiščenje",
      "typeLabel": "Vrsta",
      "typeMaintenance": "Vzdrževanje",
      "unitLabel": "Enota",
      "unitNeedsProperty": "Najprej izberite nastanitev",
      "updated": "Naloga posodobljena."
    },
    "staffAssigneeSelect": {
      "assigned": "Dodeljeno",
      "cancel": "Prekličite",
      "confirm": "Vseeno dodelite",
      "confirmDescription": "Za ta termin je označen kot nerazpoložljiv. Če je nujno, mu nalogo vseeno lahko dodelite.",
      "confirmDescriptionReason": "Za ta termin je označen kot nerazpoložljiv: {reason}. Če je nujno, mu nalogo vseeno lahko dodelite.",
      "confirmTitle": "Želite nalogo vseeno dodeliti osebi {name}?",
      "filteringNote": "{taskFunction, select, check_in {Prikazano je osebje, ki sprejema goste.} check_out {Prikazano je osebje, ki ureja odhode gostov.} cleaning {Prikazano je osebje, ki opravlja čiščenje.} concierge {Prikazano je osebje, ki opravlja concierge storitve.} maintenance {Prikazano je osebje, ki opravlja vzdrževanje.} other {Prikazano je osebje z vlogo {taskFunction}.}}",
      "noFunction": "{taskFunction, select, check_in {Ne sprejema gostov} check_out {Ne ureja odhodov} cleaning {Ne opravlja čiščenja} concierge {Ne opravlja storitev concierge} maintenance {Ne opravlja vzdrževanja} other {Nima vloge {taskFunction}}}",
      "showEveryone": "Pokažite vse",
      "showQualified": "Pokažite samo usposobljeno osebje",
      "unassigned": "Nedodeljeno"
    },
    "taskCues": {
      "label": {
        "infant": "Pripravite otroško posteljico: dojenček",
        "pet": "Potuje s hišnim ljubljenčkom",
        "petWithNotes": "Hišni ljubljenček: {notes}"
      },
      "short": {
        "accessibility": "Dostopnost",
        "dietary": "Prehrana",
        "infant": "Posteljica",
        "pet": "Ljubljenček"
      }
    },
    "taskDetails": {
      "accessibility": "Dostopnost",
      "afterCheckout": "Po odhodu ob {checkOut}",
      "afterCheckoutBeforeCheckIn": "Po odhodu ob {checkOut} · Pred prihodom ob {checkIn}",
      "assignedTo": "Dodeljeno",
      "assignment": "Dodelitev",
      "beforeCheckIn": "Pred prihodom ob {checkIn}",
      "checkIn": "Prihod",
      "cleaningUpAfter": "Čiščenje po gostu <guest>{name}</guest>",
      "completionNote": "Opomba ob zaključku",
      "description": "Opis",
      "dietary": "Prehrana",
      "eta": "· prihod pribl. {eta}",
      "markDone": "Označite kot opravljeno",
      "notScheduled": "Ni načrtovano",
      "openLiveView": "Odprite pogled v živo",
      "pets": "Hišni ljubljenčki",
      "prepFor": "Priprava za",
      "specialRequests": "Posebne želje",
      "startTask": "Začnite nalogo",
      "travellingWithPet": "Potuje s hišnim ljubljenčkom",
      "unassigned": "Nedodeljeno",
      "unitCode": "Enota {code}",
      "unitCodeAndName": "Enota {code}: {name}",
      "unknownUnit": "Neznana enota",
      "via": "prek",
      "viewFullReservation": "Oglejte si celotno rezervacijo",
      "viewSummary": "Oglejte si povzetek",
      "when": "Kdaj",
      "where": "Kje"
    },
    "taskLiveView": {
      "allStepsDone": "{total, plural, one {Opravljen je {total} korak} two {Opravljena oba koraka} few {Opravljeni vsi {total} koraki} other {Opravljenih vseh {total} korakov}}",
      "assignment": "Dodelitev",
      "back": "Nazaj",
      "backToTasks": "Nazaj na naloge",
      "checkInFrom": "Prihod gostov od {time}",
      "checkInFromWithEta": "Prihod gostov od {time} · predvidoma ob {eta}",
      "checklistTitle": "Čiščenje po standardu",
      "compactCheckIn": "Prihod {time}",
      "compactEta": "Predvidoma {time}",
      "edit": "Uredite",
      "errorComplete": "Naloge ni bilo mogoče zaključiti. Poskusite znova.",
      "errorStart": "Naloge ni bilo mogoče začeti. Poskusite znova.",
      "errorStepUpdate": "Tega koraka ni bilo mogoče posodobiti. Poskusite znova.",
      "errorUpdate": "Naloge ni bilo mogoče posodobiti. Poskusite znova.",
      "finishAnyway": "Vseeno zaključite",
      "finishHintTask": "Ko je soba pripravljena, zaključite nalogo. Brez naglice.",
      "finishHintTurnover": "Ko je soba pripravljena, zaključite menjavo. Brez naglice.",
      "missedHint": "Gost je prispel, preden je bila naloga opravljena. Če je bila vseeno opravljena, v nalogi nastavite status »Opravljeno«, nato pa sobi stanje »Čisto«.",
      "missedHintAskManager": "Gost je prispel, preden je bila naloga opravljena. Če je bila vseeno opravljena, v nalogi nastavite status »Opravljeno«, nato pa lastnika ali upravitelja prosite, naj sobi nastavi stanje »Čisto«.",
      "finishPostCheckout": "Zaključite čiščenje po odhodu",
      "finishPreCheckinRefresh": "Zaključite osvežitev pred prihodom",
      "finishTurnover": "Zaključite menjavo",
      "finished": "Zaključeno",
      "guestNames": "· {names}",
      "headerTitle": "Naloga",
      "headingKindUnit": "{kind} · {unit}",
      "keepGoing": "Nadaljujte",
      "kindCleaning": "Čiščenje",
      "kindComplete": "{kind}: končano",
      "kindMaintenance": "Vzdrževanje",
      "markComplete": "Označite kot opravljeno",
      "markedComplete": "Označeno kot opravljeno",
      "missing": "Ta naloga ni na voljo.",
      "notScheduled": "Ni načrtovano",
      "notesQuote": "»{notes}«",
      "pause": "Zaustavite",
      "prepFor": "Priprava za · naslednji gostje",
      "resume": "Nadaljujte",
      "someStepsDone": "Opravljeno: {done} / {total, plural, one {{total} korak} two {{total} koraka} few {{total} koraki} other {{total} korakov}}",
      "startTask": "Začnite nalogo",
      "started": "Začeto",
      "startedAt": "Začeto ob {time}",
      "stepsLeftDescription": "Še ni odkljukano:",
      "stepsLeftTitle": "{left, plural, one {Želite zaključiti, čeprav je ostal še {left} korak?} two {Želite zaključiti, čeprav sta ostala še {left} koraka?} few {Želite zaključiti, čeprav so ostali še {left} koraki?} other {Želite zaključiti, čeprav je ostalo še {left} korakov?}}",
      "task": "Naloga",
      "taskComplete": "Naloga opravljena",
      "todayBefore": "Danes, kadar koli pred {time}",
      "upNext": "Naslednje",
      "upNextFor": "Naslednje · {name}",
      "when": "Kdaj",
      "where": "Kje"
    },
    "taskPrep": {
      "adults": "{count, plural, one {# odrasli} two {# odrasla} few {# odrasli} other {# odraslih}}",
      "children": "{count, plural, one {# otrok} two {# otroka} few {# otroci} other {# otrok}}",
      "guests": "{count, plural, one {# gost} two {# gosta} few {# gostje} other {# gostov}}",
      "infants": "{count, plural, one {# dojenček} two {# dojenčka} few {# dojenčki} other {# dojenčkov}}"
    },
    "tasksView": {
      "completeTask": "Zaključite: {title}",
      "createTask": "Ustvarite novo nalogo",
      "dateAt": "{date} • {time}",
      "emptyDescription": "Za začetek ustvarite nalogo",
      "emptyTitle": "Ni nalog",
      "hideCompleted": "Skrijte opravljene naloge",
      "needsOwner": "brez izvajalca",
      "openTask": "Odprite: {title}",
      "sectionCompleted": "Opravljeno",
      "sectionMissed": "Prepozno",
      "sectionOverdue": "Po roku",
      "sectionToday": "Danes",
      "sectionUnscheduled": "Brez termina",
      "sectionUpcoming": "Prihajajoče",
      "showCompleted": "Pokažite opravljene naloge",
      "switchToColumns": "Preklopite na pogled stolpcev",
      "switchToList": "Preklopite na pogled seznama",
      "syncing": "Sinhroniziranje nalog …",
      "taskCount": "{count, plural, one {{count} naloga} two {{count} nalogi} few {{count} naloge} other {{count} nalog}}",
      "taskCountNeedsOwner": "{count, plural, one {{count} naloga • brez izvajalca} two {{count} nalogi • brez izvajalca} few {{count} naloge • brez izvajalca} other {{count} nalog • brez izvajalca}}",
      "title": "Naloge",
      "unassigned": "Nedodeljeno",
      "unavailableDescription": "Na tej napravi Vidimo ne more naložiti nalog. Ob ponovnem poskusu se bo aplikacija znova naložila.",
      "unavailableTitle": "Nalog trenutno ni mogoče prikazati"
    },
    "waitsForClean": {
      "detail": "Soba je še umazana. Osvežitev začnite, ko bo očiščena.",
      "title": "Čaka na čiščenje"
    }
  }
}
